webpackJsonp([32,30],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getPrototypeOf = __webpack_require__(290);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _vuexRouterSync = __webpack_require__(1696);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _elementUi = __webpack_require__(1008);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _en = __webpack_require__(307);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _Root = __webpack_require__(1172);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	var _vuex = __webpack_require__(3);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexI18n = __webpack_require__(801);
	
	var _vuexI18n2 = _interopRequireDefault(_vuexI18n);
	
	var _lang = __webpack_require__(538);
	
	var _lang2 = _interopRequireDefault(_lang);
	
	var _validations = __webpack_require__(539);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _veeValidate = __webpack_require__(165);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _vueFroalaWysiwyg = __webpack_require__(1169);
	
	var _vueFroalaWysiwyg2 = _interopRequireDefault(_vueFroalaWysiwyg);
	
	var _vueSelect = __webpack_require__(1693);
	
	var _vueSelect2 = _interopRequireDefault(_vueSelect);
	
	var _vueJsToggleButton = __webpack_require__(1171);
	
	var _vueJsToggleButton2 = _interopRequireDefault(_vueJsToggleButton);
	
	var _store = __webpack_require__(188);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(869);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _http = __webpack_require__(4);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _eventbus = __webpack_require__(866);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _config = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lang = 'en';
	
	__webpack_require__(864);
	
	__webpack_require__(861);
	__webpack_require__(862);
	
	_vue2.default.use(_http2.default, { store: _store2.default, router: _router2.default });
	
	window.baseUrl = _config.apiUrl;
	
	_vue2.default.use(_eventbus2.default);
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default);
	var hf = new _vuex2.default.Store({
	  modules: {
	    i18n: _vuexI18n2.default.store
	  }
	});
	
	_router2.default.beforeEach(function (to, from, next) {
	  if (to.name === 'userportal' || to.name === 'Enduserportal' || to.name === 'Enduserportal2') {
	    document.body.classList.add('userportallayout');
	  } else {
	    document.body.classList.remove('userportallayout');
	  }
	  next();
	});
	_vue2.default.use(_vueJsToggleButton2.default);
	_vue2.default.use(_vueFroalaWysiwyg2.default);
	
	_vue2.default.directive('focus', {
	  inserted: function inserted(el) {
	    el.focus();
	  }
	});
	
	var numeral = __webpack_require__(1141);
	
	_vue2.default.filter("formatNumber", function (value) {
	  return numeral(value).format("0,0");
	});
	
	_vue2.default.use(_vuexI18n2.default.plugin, hf);
	_vue2.default.i18n.add('en', _lang2.default.en);
	
	_vue2.default.i18n.set(Lang);
	(0, _moment2.default)().locale(Lang);
	
	_vue2.default.use(_elementUi2.default, { locale: _en2.default });
	
	_vue2.default.use(_veeValidate2.default, { locale: Lang, events: 'blur' });
	
	if (_veeValidate.Validator && _veeValidate.Validator.prototype && typeof _veeValidate.Validator.prototype.updateDictionary !== 'function') {
	  _veeValidate.Validator.prototype.updateDictionary = function (dictionary) {
	    return this.localize(dictionary);
	  };
	}
	_vue2.default.mixin({
	  created: function created() {
	    var validator = this.$validator;
	    if (validator && typeof validator.updateDictionary !== 'function') {
	      var proto = (0, _getPrototypeOf2.default)(validator);
	      if (proto && typeof proto.updateDictionary !== 'function') {
	        proto.updateDictionary = function (dictionary) {
	          return this.localize(dictionary);
	        };
	      }
	    }
	  }
	});
	
	var infiniteScroll = __webpack_require__(1170);
	_vue2.default.use(infiniteScroll);
	
	_vue2.default.config.lang = Lang;
	
	
	_vue2.default.component('v-select', _vueSelect2.default);
	
	var VueTruncate = __webpack_require__(1695);
	_vue2.default.use(VueTruncate);
	
	_vue2.default.filter('DateConvertTo24Hours', function (data) {
	  if (data) {
	    var onlyData = (0, _moment2.default)(String(data)).format('DD MMM YYYY');
	    return onlyData + ',' + ' ' + (0, _moment2.default)(data).format("HH:mm");
	  }
	});
	
	_vue2.default.filter('removeUnderscoreAddSpace', function (value) {
	  if (value) {
	    return value.replace(/_/g, ' ');
	  }
	});
	document.documentElement.style.setProperty('--background-color', '#2b303b');
	document.documentElement.style.setProperty('--sub-menus', '#272b35');
	document.documentElement.style.setProperty('--button-colors', '#48b0f7');
	
	_vue2.default.component('bulkCampaignCard', __webpack_require__(1417));
	_vue2.default.component('educationCard', __webpack_require__(1420));
	_vue2.default.component('scenarioCard', __webpack_require__(1422));
	_vue2.default.component('editCampaignModal', __webpack_require__(1419));
	_vue2.default.component('campaignScheduleCard', __webpack_require__(1418));
	_vue2.default.component('nextButtonCard', __webpack_require__(1421));
	_vue2.default.component('vcroFormulaInfo', __webpack_require__(1402));
	
	new _vue2.default({
	  store: _store2.default,
	  router: _router2.default,
	  el: '#app',
	  render: function render(h) {
	    return h(_Root2.default);
	  }
	});

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var apiUrl = exports.apiUrl = ("https://api2.citizenfirewall.in/internal/v1");
	var version = exports.version = ("4.1.2");
	var cdnDomain = exports.cdnDomain = ("https://cdn.citizenfirewall.in");
	var leaderBoardPoints = exports.leaderBoardPoints = (true);
	var termsLink = exports.termsLink = ("https://www.humanfirewall.io/terms.html");
	var policyLink = exports.policyLink = ("https://www.humanfirewall.io/privacy-policy.html");
	var educationLink = exports.educationLink = ("https://educate2.citizenfirewall.in/");
	var remediatorLink = exports.remediatorLink = ("https://139.59.82.8/api/v1/office/");
	var lmsUrl = exports.lmsUrl = ("https://lms2.citizenfirewall.in");
	var hfv3Url = exports.hfv3Url = ({"NODE_ENV":"production","API_URL":"https://api2.citizenfirewall.in/internal/v1","PRIVACY_POLICY":"https://www.humanfirewall.io/privacy-policy.html","VERSION":"4.1.2","CDN_DOMAIN":"https://cdn.citizenfirewall.in","EDUCATION_URL":"https://educate2.citizenfirewall.in/","MAIN_DOMAIN":"citizenfirewall.in","REMEDIATOR_URL":"https://139.59.82.8/api/v1/office/","LMS_URL":"https://lms2.citizenfirewall.in","SAML_URL":"https://api2.citizenfirewall.in/","AD_URL":"https://api2.citizenfirewall.in/internal/v1/adauth/admin/geturl","RECIPIENT_AD_URL":"https://api2.citizenfirewall.in/internal/v1/adauth/user/geturl","TERMS_LINK":"https://www.humanfirewall.io/terms.html","POLICY_LINK":"https://www.humanfirewall.io/privacy-policy.html","LEADER_BOARD_POINTS":true}).HFV3_URL;
	var hfv3apiUrl = exports.hfv3apiUrl = ({"NODE_ENV":"production","API_URL":"https://api2.citizenfirewall.in/internal/v1","PRIVACY_POLICY":"https://www.humanfirewall.io/privacy-policy.html","VERSION":"4.1.2","CDN_DOMAIN":"https://cdn.citizenfirewall.in","EDUCATION_URL":"https://educate2.citizenfirewall.in/","MAIN_DOMAIN":"citizenfirewall.in","REMEDIATOR_URL":"https://139.59.82.8/api/v1/office/","LMS_URL":"https://lms2.citizenfirewall.in","SAML_URL":"https://api2.citizenfirewall.in/","AD_URL":"https://api2.citizenfirewall.in/internal/v1/adauth/admin/geturl","RECIPIENT_AD_URL":"https://api2.citizenfirewall.in/internal/v1/adauth/user/geturl","TERMS_LINK":"https://www.humanfirewall.io/terms.html","POLICY_LINK":"https://www.humanfirewall.io/privacy-policy.html","LEADER_BOARD_POINTS":true}).HFV3_API_URL;
	var erv2apiUrl = exports.erv2apiUrl = ({"NODE_ENV":"production","API_URL":"https://api2.citizenfirewall.in/internal/v1","PRIVACY_POLICY":"https://www.humanfirewall.io/privacy-policy.html","VERSION":"4.1.2","CDN_DOMAIN":"https://cdn.citizenfirewall.in","EDUCATION_URL":"https://educate2.citizenfirewall.in/","MAIN_DOMAIN":"citizenfirewall.in","REMEDIATOR_URL":"https://139.59.82.8/api/v1/office/","LMS_URL":"https://lms2.citizenfirewall.in","SAML_URL":"https://api2.citizenfirewall.in/","AD_URL":"https://api2.citizenfirewall.in/internal/v1/adauth/admin/geturl","RECIPIENT_AD_URL":"https://api2.citizenfirewall.in/internal/v1/adauth/user/geturl","TERMS_LINK":"https://www.humanfirewall.io/terms.html","POLICY_LINK":"https://www.humanfirewall.io/privacy-policy.html","LEADER_BOARD_POINTS":true}).ERV2_API_URL;
	var adUrl = exports.adUrl = ("https://api2.citizenfirewall.in/internal/v1/adauth/admin/geturl");
	var recipientAdUrl = exports.recipientAdUrl = ("https://api2.citizenfirewall.in/internal/v1/adauth/user/geturl");
	var mainDomain = exports.mainDomain = ("citizenfirewall.in");
	var userTokenStorageKey = exports.userTokenStorageKey = 'APP_USER_TOKEN';
	var privacy_policy_url = exports.privacy_policy_url = ("https://www.humanfirewall.io/privacy-policy.html");
	var samlUrl = exports.samlUrl = ("https://api2.citizenfirewall.in/");
	var hfimap = exports.hfimap = ({"NODE_ENV":"production","API_URL":"https://api2.citizenfirewall.in/internal/v1","PRIVACY_POLICY":"https://www.humanfirewall.io/privacy-policy.html","VERSION":"4.1.2","CDN_DOMAIN":"https://cdn.citizenfirewall.in","EDUCATION_URL":"https://educate2.citizenfirewall.in/","MAIN_DOMAIN":"citizenfirewall.in","REMEDIATOR_URL":"https://139.59.82.8/api/v1/office/","LMS_URL":"https://lms2.citizenfirewall.in","SAML_URL":"https://api2.citizenfirewall.in/","AD_URL":"https://api2.citizenfirewall.in/internal/v1/adauth/admin/geturl","RECIPIENT_AD_URL":"https://api2.citizenfirewall.in/internal/v1/adauth/user/geturl","TERMS_LINK":"https://www.humanfirewall.io/terms.html","POLICY_LINK":"https://www.humanfirewall.io/privacy-policy.html","LEADER_BOARD_POINTS":true}).HF_IMAP;

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.http = undefined;
	exports.setToken = setToken;
	exports.default = install;
	
	var _axios = __webpack_require__(113);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _interceptors = __webpack_require__(867);
	
	var _interceptors2 = _interopRequireDefault(_interceptors);
	
	var _config = __webpack_require__(2);
	
	var _localforage = __webpack_require__(236);
	
	var _localforage2 = _interopRequireDefault(_localforage);
	
	var _lodash = __webpack_require__(9);
	
	var _config2 = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var http = exports.http = _axios2.default.create({
	  baseURL: _config.apiUrl
	});
	
	for (var key in _axios2.default) {
	  if (typeof _axios2.default[key] === 'function') {
	    http[key] = _axios2.default[key].bind(http);
	  } else {
	    http[key] = _axios2.default[key];
	  }
	}
	
	http.defaults.baseURL = _config.apiUrl;
	http.CancelToken = _axios2.default.CancelToken;
	http.isCancel = _axios2.default.isCancel;
	function setToken(token) {
	  http.defaults.headers.common.Authorization = 'Bearer ' + token;
	}
	
	function install(Vue, _ref) {
	  var store = _ref.store,
	      router = _ref.router;
	
	
	  (0, _interceptors2.default)(http, store, router);
	
	  Object.defineProperty(Vue.prototype, '$http', {
	    get: function get() {
	      return http;
	    }
	  });
	}

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.safeGet = exports.getData = undefined;
	
	var _lodash = __webpack_require__(9);
	
	var getData = exports.getData = function getData(obj) {
	  return (0, _lodash.get)(obj, 'data');
	};
	var safeGet = exports.safeGet = function safeGet(obj, path) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  return (0, _lodash.get)(obj, path, defaultValue);
	};

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.safeLmsRedirect = safeLmsRedirect;
	exports.safePostLoginRedirect = safePostLoginRedirect;
	exports.popPostLoginRedirect = popPostLoginRedirect;
	var POST_LOGIN_REDIRECT_KEY = exports.POST_LOGIN_REDIRECT_KEY = 'post_login_redirect';
	
	function safeLmsRedirect(value) {
	    return typeof value === 'string' && value.charAt(0) === '/' && value.charAt(1) !== '/' && /^\/lms(\/|-sso|\?|$)/.test(value);
	}
	
	function safePostLoginRedirect(value) {
	    return typeof value === 'string' && value.charAt(0) === '/' && value.charAt(1) !== '/' && (/^\/lms(\/|-sso|\?|$)/.test(value) || /^\/(campaigns|announcements|policy)\/preview(\/|\?|$)/.test(value) || /^\/(campaigns|announcements|policy)\/(creator|approver)-workspace(\/|\?|$)/.test(value));
	}
	
	function popPostLoginRedirect() {
	    var stored = null;
	    try {
	        stored = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
	        if (stored) {
	            sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
	        }
	    } catch (e) {
	        return null;
	    }
	    return safePostLoginRedirect(stored) ? stored : null;
	}

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLoginDetails = exports.getUserPortalDetials = exports.userPortalLogin = exports.getGoogleRecaptcha = exports.checkCompanyLicense = exports.revokeToken = exports.loadUserData = exports.postVerification = exports.postRegister = exports.postLearningLogin = exports.postByEmailLinkLogin = exports.postLogin = undefined;
	
	var _objectDestructuringEmpty2 = __webpack_require__(889);
	
	var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);
	
	var _http = __webpack_require__(4);
	
	var _get = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postLogin = exports.postLogin = function postLogin(_ref) {
	  var email = _ref.email,
	      password = _ref.password,
	      captchaResponse = _ref.captchaResponse;
	  return _http.http.post('/auth/login', { email: email, password: password, captchaResponse: captchaResponse }).then(_get.getData);
	};var postByEmailLinkLogin = exports.postByEmailLinkLogin = function postByEmailLinkLogin(_ref2) {
	  (0, _objectDestructuringEmpty3.default)(_ref2);
	  return _http.http.post('/auth/loginbyemail/'.target, {}).then(_get.getData);
	};var postLearningLogin = exports.postLearningLogin = function postLearningLogin(_ref3) {
	  var email = _ref3.email,
	      target = _ref3.target;
	  return _http.http.post('/auth/learning/login', { email: email, target: target }).then(_get.getData);
	};var postRegister = exports.postRegister = function postRegister(_ref4) {
	  var first_name = _ref4.first_name,
	      last_name = _ref4.last_name,
	      designation = _ref4.designation,
	      company = _ref4.company,
	      employee_count = _ref4.employee_count,
	      country = _ref4.country,
	      timezone = _ref4.timezone,
	      email = _ref4.email,
	      password = _ref4.password;
	  return _http.http.post('/auth/register', { first_name: first_name, last_name: last_name, designation: designation, company: company, employee_count: employee_count, country: country, timezone: timezone, email: email, password: password }).then(_get.getData);
	};var postVerification = exports.postVerification = function postVerification(_ref5) {
	  var id = _ref5.id,
	      token = _ref5.token,
	      secret = _ref5.secret;
	  return _http.http.post('/auth/verify', { id: id, token: token, secret: secret }).then(_get.getData);
	};
	var loadUserData = exports.loadUserData = function loadUserData() {
	  return _http.http.get('/me').then(_get.getData);
	};
	var revokeToken = exports.revokeToken = function revokeToken() {
	  return _http.http.post('/auth_token/revoke').then(_get.getData);
	};
	var checkCompanyLicense = exports.checkCompanyLicense = function checkCompanyLicense(token) {
	  return _http.http.post('/auth/validatelic', { 'token': token }).then(_get.getData);
	};
	var getGoogleRecaptcha = exports.getGoogleRecaptcha = function getGoogleRecaptcha() {
	  return _http.http.get('/auth/get-google-recaptcha').then(_get.getData);
	};
	var userPortalLogin = exports.userPortalLogin = function userPortalLogin(data) {
	  return _http.http.post('/auth/user-login', data).then(_get.getData);
	};
	var getUserPortalDetials = exports.getUserPortalDetials = function getUserPortalDetials(data) {
	  return _http.http.post('/auth/get/userportal/details', data, { withCredentials: true }).then(_get.getData);
	};
	
	var getLoginDetails = exports.getLoginDetails = function getLoginDetails(data) {
	  return _http.http.post('/auth/get/admin-login-page/details', data).then(_get.getData);
	};

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_TOKEN = exports.SET_TOKEN = 'Auth//SET_TOKEN';
	var SET_USER = exports.SET_USER = 'Auth//SET_USER';

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(860);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});
	
	var _routes = __webpack_require__(848);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(845);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(847);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(851);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(3);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _state = __webpack_require__(189);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(873);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(870);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _modules = __webpack_require__(872);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _plugins = __webpack_require__(874);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _getters = __webpack_require__(871);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  state: _state2.default,
	  mutations: _mutations2.default,
	  actions: _actions2.default,
	  modules: _modules2.default,
	  plugins: _plugins2.default,
	  getters: getters,
	  strict: ("production") !== 'production'
	});

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  messages: {
	    success: '',
	    error: {},
	    warning: '',
	    validation: {}
	  },
	  help_icon_route: [],
	  fetching: false,
	  permissions: function permissions() {
	    return JSON.parse(localStorage.getItem('permissions'));
	  }
	};

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.readStoredUser = undefined;
	
	var _typeof2 = __webpack_require__(43);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var readStoredUser = exports.readStoredUser = function readStoredUser() {
	  try {
	    var raw = localStorage.getItem('user');
	    if (!raw) {
	      return null;
	    }
	    var parsed = JSON.parse(raw);
	
	    return parsed && (typeof parsed === 'undefined' ? 'undefined' : (0, _typeof3.default)(parsed)) === 'object' ? parsed : null;
	  } catch (e) {
	    return null;
	  }
	};

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isBannerHidden = isBannerHidden;
	exports.hideBanner = hideBanner;
	exports.resetBanner = resetBanner;
	
	var KEY = 'hf_system_alert_banner_hidden';
	
	function isBannerHidden() {
	  try {
	    return localStorage.getItem(KEY) === '1';
	  } catch (e) {
	    return false;
	  }
	}
	
	function hideBanner() {
	  try {
	    localStorage.setItem(KEY, '1');
	  } catch (e) {}
	}
	
	function resetBanner() {
	  try {
	    localStorage.removeItem(KEY);
	  } catch (e) {}
	}

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo-white.83050bb.svg";

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CAMPAING_CHECKED_SETTINGS = exports.CAMPAING_CHECKED_SETTINGS = 'Campaign//CHECKED_SETTINGS';

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(816);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(819);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(823);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(824);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(827);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CAMPAING_CHECKED_SETTINGS = exports.CAMPAING_CHECKED_SETTINGS = 'Campaign//CHECKED_SETTINGS';

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(830);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(833);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCompanySubOrg = exports.deleteDomain = exports.verifyTxtRecord = exports.verifyNewDomain = exports.updateDomainData = exports.addNewDomain = exports.geteditDomains = exports.getDomains = undefined;
	
	var _http = __webpack_require__(4);
	
	var _get = __webpack_require__(15);
	
	var getDomains = exports.getDomains = function getDomains(id, orderfield, sortorder, page, per_page, searchQuery, activeTab) {
	  return _http.http.get('/companies/domains/listing?company=' + id + '&orderfield=' + orderfield + '&sortorder=' + sortorder + '&page=' + page + '&per_page=' + per_page + '&search=' + searchQuery + '&domainType=' + activeTab).then(_get.getData);
	};
	var geteditDomains = exports.geteditDomains = function geteditDomains(id) {
	  return _http.http.get('/companies/domains/edit/' + id).then(_get.getData);
	};
	var addNewDomain = exports.addNewDomain = function addNewDomain(_ref) {
	  var name = _ref.name,
	      comp_id = _ref.comp_id;
	  return _http.http.post('/companies/domains', { name: name, comp_id: comp_id }).then(_get.getData);
	};
	var updateDomainData = exports.updateDomainData = function updateDomainData(_ref2) {
	  var id = _ref2.id,
	      comp_id = _ref2.comp_id;
	  return _http.http.post('/companies/domains/update', { id: id, comp_id: comp_id }).then(_get.getData);
	};
	var verifyNewDomain = exports.verifyNewDomain = function verifyNewDomain(_ref3) {
	  var id = _ref3.id;
	  return _http.http.post('/companies/domains/verify', { id: id }).then(_get.getData);
	};
	var verifyTxtRecord = exports.verifyTxtRecord = function verifyTxtRecord(_ref4) {
	  var id = _ref4.id;
	  return _http.http.post('/companies/domains/verifytxtrecord', { id: id }).then(_get.getData);
	};
	var deleteDomain = exports.deleteDomain = function deleteDomain(_ref5) {
	  var id = _ref5.id;
	  return _http.http.delete('/companies/domains/' + id).then(_get.getData);
	};
	var getCompanySubOrg = exports.getCompanySubOrg = function getCompanySubOrg() {
	  return _http.http.get('/reports/company/suborg').then(_get.getData);
	};

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_DOMAIN_LIST = exports.SET_DOMAIN_LIST = 'Company//SET_DOMAIN_LIST';

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(189);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  domains: [],
	  messages: _state2.default.messages
	};

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(835);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(836);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(837);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(838);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(839);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(844);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(858);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(859);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAIN_SET_MESSAGE = exports.MAIN_SET_MESSAGE = 'MAIN_SET_MESSAGE';
	var MAIN_SET_FETCHING = exports.MAIN_SET_FETCHING = 'MAIN_SET_FETCHING';
	
	var CATEGORIES_SET_DATA = exports.CATEGORIES_SET_DATA = 'CATEGORIES_SET_DATA';
	var PRODUCTS_SET_DATA = exports.PRODUCTS_SET_DATA = 'PRODUCTS_SET_DATA';
	var SET_HELP_ICON_ROUTES = exports.SET_HELP_ICON_ROUTES = 'SET_HELP_ICON_ROUTES';

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 336,
		"./af.js": 336,
		"./ar": 343,
		"./ar-dz": 337,
		"./ar-dz.js": 337,
		"./ar-kw": 338,
		"./ar-kw.js": 338,
		"./ar-ly": 339,
		"./ar-ly.js": 339,
		"./ar-ma": 340,
		"./ar-ma.js": 340,
		"./ar-sa": 341,
		"./ar-sa.js": 341,
		"./ar-tn": 342,
		"./ar-tn.js": 342,
		"./ar.js": 343,
		"./az": 344,
		"./az.js": 344,
		"./be": 345,
		"./be.js": 345,
		"./bg": 346,
		"./bg.js": 346,
		"./bm": 347,
		"./bm.js": 347,
		"./bn": 349,
		"./bn-bd": 348,
		"./bn-bd.js": 348,
		"./bn.js": 349,
		"./bo": 350,
		"./bo.js": 350,
		"./br": 351,
		"./br.js": 351,
		"./bs": 352,
		"./bs.js": 352,
		"./ca": 353,
		"./ca.js": 353,
		"./cs": 354,
		"./cs.js": 354,
		"./cv": 355,
		"./cv.js": 355,
		"./cy": 356,
		"./cy.js": 356,
		"./da": 357,
		"./da.js": 357,
		"./de": 360,
		"./de-at": 358,
		"./de-at.js": 358,
		"./de-ch": 359,
		"./de-ch.js": 359,
		"./de.js": 360,
		"./dv": 361,
		"./dv.js": 361,
		"./el": 362,
		"./el.js": 362,
		"./en-au": 363,
		"./en-au.js": 363,
		"./en-ca": 364,
		"./en-ca.js": 364,
		"./en-gb": 365,
		"./en-gb.js": 365,
		"./en-ie": 366,
		"./en-ie.js": 366,
		"./en-il": 367,
		"./en-il.js": 367,
		"./en-in": 368,
		"./en-in.js": 368,
		"./en-nz": 369,
		"./en-nz.js": 369,
		"./en-sg": 370,
		"./en-sg.js": 370,
		"./eo": 371,
		"./eo.js": 371,
		"./es": 375,
		"./es-do": 372,
		"./es-do.js": 372,
		"./es-mx": 373,
		"./es-mx.js": 373,
		"./es-us": 374,
		"./es-us.js": 374,
		"./es.js": 375,
		"./et": 376,
		"./et.js": 376,
		"./eu": 377,
		"./eu.js": 377,
		"./fa": 378,
		"./fa.js": 378,
		"./fi": 379,
		"./fi.js": 379,
		"./fil": 380,
		"./fil.js": 380,
		"./fo": 381,
		"./fo.js": 381,
		"./fr": 384,
		"./fr-ca": 382,
		"./fr-ca.js": 382,
		"./fr-ch": 383,
		"./fr-ch.js": 383,
		"./fr.js": 384,
		"./fy": 385,
		"./fy.js": 385,
		"./ga": 386,
		"./ga.js": 386,
		"./gd": 387,
		"./gd.js": 387,
		"./gl": 388,
		"./gl.js": 388,
		"./gom-deva": 389,
		"./gom-deva.js": 389,
		"./gom-latn": 390,
		"./gom-latn.js": 390,
		"./gu": 391,
		"./gu.js": 391,
		"./he": 392,
		"./he.js": 392,
		"./hi": 393,
		"./hi.js": 393,
		"./hr": 394,
		"./hr.js": 394,
		"./hu": 395,
		"./hu.js": 395,
		"./hy-am": 396,
		"./hy-am.js": 396,
		"./id": 397,
		"./id.js": 397,
		"./is": 398,
		"./is.js": 398,
		"./it": 400,
		"./it-ch": 399,
		"./it-ch.js": 399,
		"./it.js": 400,
		"./ja": 401,
		"./ja.js": 401,
		"./jv": 402,
		"./jv.js": 402,
		"./ka": 403,
		"./ka.js": 403,
		"./kk": 404,
		"./kk.js": 404,
		"./km": 405,
		"./km.js": 405,
		"./kn": 406,
		"./kn.js": 406,
		"./ko": 407,
		"./ko.js": 407,
		"./ku": 408,
		"./ku.js": 408,
		"./ky": 409,
		"./ky.js": 409,
		"./lb": 410,
		"./lb.js": 410,
		"./lo": 411,
		"./lo.js": 411,
		"./lt": 412,
		"./lt.js": 412,
		"./lv": 413,
		"./lv.js": 413,
		"./me": 414,
		"./me.js": 414,
		"./mi": 415,
		"./mi.js": 415,
		"./mk": 416,
		"./mk.js": 416,
		"./ml": 417,
		"./ml.js": 417,
		"./mn": 418,
		"./mn.js": 418,
		"./mr": 419,
		"./mr.js": 419,
		"./ms": 421,
		"./ms-my": 420,
		"./ms-my.js": 420,
		"./ms.js": 421,
		"./mt": 422,
		"./mt.js": 422,
		"./my": 423,
		"./my.js": 423,
		"./nb": 424,
		"./nb.js": 424,
		"./ne": 425,
		"./ne.js": 425,
		"./nl": 427,
		"./nl-be": 426,
		"./nl-be.js": 426,
		"./nl.js": 427,
		"./nn": 428,
		"./nn.js": 428,
		"./oc-lnc": 429,
		"./oc-lnc.js": 429,
		"./pa-in": 430,
		"./pa-in.js": 430,
		"./pl": 431,
		"./pl.js": 431,
		"./pt": 433,
		"./pt-br": 432,
		"./pt-br.js": 432,
		"./pt.js": 433,
		"./ro": 434,
		"./ro.js": 434,
		"./ru": 435,
		"./ru.js": 435,
		"./sd": 436,
		"./sd.js": 436,
		"./se": 437,
		"./se.js": 437,
		"./si": 438,
		"./si.js": 438,
		"./sk": 439,
		"./sk.js": 439,
		"./sl": 440,
		"./sl.js": 440,
		"./sq": 441,
		"./sq.js": 441,
		"./sr": 443,
		"./sr-cyrl": 442,
		"./sr-cyrl.js": 442,
		"./sr.js": 443,
		"./ss": 444,
		"./ss.js": 444,
		"./sv": 445,
		"./sv.js": 445,
		"./sw": 446,
		"./sw.js": 446,
		"./ta": 447,
		"./ta.js": 447,
		"./te": 448,
		"./te.js": 448,
		"./tet": 449,
		"./tet.js": 449,
		"./tg": 450,
		"./tg.js": 450,
		"./th": 451,
		"./th.js": 451,
		"./tk": 452,
		"./tk.js": 452,
		"./tl-ph": 453,
		"./tl-ph.js": 453,
		"./tlh": 454,
		"./tlh.js": 454,
		"./tr": 455,
		"./tr.js": 455,
		"./tzl": 456,
		"./tzl.js": 456,
		"./tzm": 458,
		"./tzm-latn": 457,
		"./tzm-latn.js": 457,
		"./tzm.js": 458,
		"./ug-cn": 459,
		"./ug-cn.js": 459,
		"./uk": 460,
		"./uk.js": 460,
		"./ur": 461,
		"./ur.js": 461,
		"./uz": 463,
		"./uz-latn": 462,
		"./uz-latn.js": 462,
		"./uz.js": 463,
		"./vi": 464,
		"./vi.js": 464,
		"./x-pseudo": 465,
		"./x-pseudo.js": 465,
		"./yo": 466,
		"./yo.js": 466,
		"./zh-cn": 467,
		"./zh-cn.js": 467,
		"./zh-hk": 468,
		"./zh-hk.js": 468,
		"./zh-mo": 469,
		"./zh-mo.js": 469,
		"./zh-tw": 470,
		"./zh-tw.js": 470
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 335;


/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    auth: __webpack_require__(1084),
	    recipient: __webpack_require__(1090),
	    company: __webpack_require__(1086),
	    campaign: __webpack_require__(1085),
	    report: __webpack_require__(1091),
	    leaderboard: __webpack_require__(1089),
	    gamification: __webpack_require__(1088),
	    ssoazure: __webpack_require__(1094),
	    appcrendantials: __webpack_require__(1083),
	    userportal: __webpack_require__(1096),
	    enduserportal: __webpack_require__(1087),
	    setting: __webpack_require__(1093),
	    teamproral: __webpack_require__(1095),
	    schduleCalendar: __webpack_require__(1092)
	};

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  messages: {
	    alpha_spaces: function alpha_spaces() {
	      return 'Only alphabets and spaces are allowed.';
	    }
	  },
	  attributes: {
	    first_name: 'first name',
	    last_name: 'last name',
	    designation: 'Job title ',
	    company: 'organisation ',
	    employ_count: 'employee number',
	    confirm_password: 're-type password',
	    agree: 'agree to the terms of service and privacy policy'
	  }
	};

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: __webpack_require__(536).default
	};

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: __webpack_require__(537).default
	};

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'HumanFirewall'
	};

/***/ }),

/***/ 776:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'VcroFormulaInfo',
	  props: {
	    level: { type: String, default: 'organisation' }
	  },
	  computed: {
	    isAggregate: function isAggregate() {
	      return ['organisation', 'department', 'group'].indexOf(this.level) !== -1;
	    },
	    levelWord: function levelWord() {
	      return this.level;
	    }
	  }
	};

/***/ }),

/***/ 786:
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(43);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(16);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(9);
	
	var _vuex = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        show: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }
	    },
	    computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['messages']), {
	        hasSuccessMessage: function hasSuccessMessage() {
	            return this.messages.success !== '';
	        },
	        hasErrorMessages: function hasErrorMessages() {
	            return this.show.hasOwnProperty('errors') && (0, _typeof3.default)(this.messages.error) === 'object' && this.messages.error.length > 0;
	        },
	        hasWarningMessages: function hasWarningMessages() {
	            return this.messages.warning !== '';
	        },
	        hasValidationMessages: function hasValidationMessages() {
	            return this.messages.validation.length > 0;
	        },
	        formatedErrorMessage: function formatedErrorMessage() {
	            return (0, _lodash.flatMapDeep)(this.messages.error).map(function (msg) {
	                return '\u2022 ' + msg;
	            }).join('<br>');
	        },
	        formatedValidationMessage: function formatedValidationMessage() {
	            return (0, _lodash.flatMapDeep)(this.messages.validation).map(function (msg) {
	                return '\u2022 ' + msg;
	            }).join('<br>');
	        }
	    }),
	    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setMessage']), {
	        dismiss: function dismiss(type) {
	            var obj = void 0;
	            if (type === 'error') {
	                obj = { type: type, message: {} };
	            } else if (type === 'validation') {
	                obj = { type: type, message: {} };
	            } else {
	                obj = { type: type, message: '' };
	            }
	            this.setMessage(obj);
	        }
	    })
	};

/***/ }),

/***/ 789:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(16);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(3);
	
	var _navbar = __webpack_require__(1414);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _sidebar = __webpack_require__(1415);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _systemAlertBanner = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    NavBar: _navbar2.default,
	    SideBar: _sidebar2.default
	  },
	  data: function data() {
	    return {
	      campaignSendFaild: "",
	      alrtshow: false,
	      alert: false,
	
	      systemAlertTypes: [],
	      systemAlertHidden: false,
	
	      systemAlertAutoHidden: false,
	      bannerAutoHideTimer: null
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["shouldShowNavigation"]), {
	    onDashboard: function onDashboard() {
	      return this.$route.name === "dashboard.index";
	    },
	    showSystemAlertBanner: function showSystemAlertBanner() {
	      return this.onDashboard && this.systemAlertTypes.length > 0 && !this.systemAlertHidden && !this.systemAlertAutoHidden;
	    }
	  }),
	
	  watch: {
	    showSystemAlertBanner: function showSystemAlertBanner(visible) {
	      if (visible) {
	        this.startBannerAutoHide();
	      } else {
	        this.clearBannerAutoHide();
	      }
	    },
	    onDashboard: function onDashboard(here) {
	      if (here) {
	        this.systemAlertAutoHidden = false;
	      }
	    }
	  },
	  beforeMount: function beforeMount() {
	    this.getCampaignsEmailAlert();
	  },
	  mounted: function mounted() {
	    this.$bus.$on("system-alerts-updated", this.onSystemAlertsUpdated);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.$bus.$off("system-alerts-updated", this.onSystemAlertsUpdated);
	    this.clearBannerAutoHide();
	  },
	
	  methods: {
	    onSystemAlertsUpdated: function onSystemAlertsUpdated(payload) {
	      if (!payload || !payload.enabled) {
	        this.systemAlertTypes = [];
	        return;
	      }
	
	      var banner = payload.banner || {};
	      this.systemAlertTypes = banner.types || [];
	      this.systemAlertHidden = (0, _systemAlertBanner.isBannerHidden)();
	    },
	    goToSystemAlerts: function goToSystemAlerts() {
	      this.$router.push({ name: "systemAlerts" }).catch(function () {});
	    },
	    goToSystemAlertType: function goToSystemAlertType(type) {
	      var _this = this;
	
	      if (!type.route) {
	        this.goToSystemAlerts();
	        return;
	      }
	
	      this.$router.push({ name: type.route, params: type.params || {} }).catch(function () {
	        return _this.goToSystemAlerts();
	      });
	    },
	    hideSystemAlertBanner: function hideSystemAlertBanner() {
	      this.systemAlertHidden = true;
	      (0, _systemAlertBanner.hideBanner)();
	    },
	    startBannerAutoHide: function startBannerAutoHide() {
	      var _this2 = this;
	
	      this.clearBannerAutoHide();
	
	      this.bannerAutoHideTimer = setTimeout(function () {
	        _this2.systemAlertAutoHidden = true;
	        _this2.bannerAutoHideTimer = null;
	      }, 30000);
	    },
	    clearBannerAutoHide: function clearBannerAutoHide() {
	      if (this.bannerAutoHideTimer) {
	        clearTimeout(this.bannerAutoHideTimer);
	        this.bannerAutoHideTimer = null;
	      }
	    },
	    goToTop: function goToTop() {
	      $("html,body").animate({ scrollTop: 0 }, "1000");
	    },
	    getCampaignsEmailAlert: function getCampaignsEmailAlert() {
	      var companyLogoData = JSON.parse(localStorage.getItem("company_logo"));
	
	      if (!companyLogoData || !companyLogoData.alert) {
	        return;
	      }
	      this.alrtshow = companyLogoData.alert.msg;
	      this.alert = companyLogoData.alert.campaignSendFaild;
	      this.campaignSendFaild = companyLogoData.alert.id;
	    },
	    campaignsEmailAlertUpdate: function campaignsEmailAlertUpdate() {
	      var _this3 = this;
	
	      var data = { id: this.campaignSendFaild };
	      this.$http.post("/setting/alert/update", data).then(function (response) {
	        _this3.alert = false;
	      });
	    }
	  }
	};
	
	
	$(window).scroll(function () {
	  if ($(this).scrollTop() > 50) {
	    $(".scrolltop:hidden").stop(true, true).fadeIn();
	  } else {
	    $(".scrolltop").stop(true, true).fadeOut();
	  }
	});

/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(18);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _keys = __webpack_require__(17);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(6);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(16);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(3);
	
	var _recipient = __webpack_require__(182);
	
	var _report = __webpack_require__(183);
	
	var _gamification = __webpack_require__(277);
	
	var _managementreport = __webpack_require__(282);
	
	var _vcro = __webpack_require__(286);
	
	var _setting = __webpack_require__(184);
	
	var _leaderboard = __webpack_require__(281);
	
	var _laggards = __webpack_require__(280);
	
	var _userportalpages = __webpack_require__(285);
	
	var _ip = __webpack_require__(278);
	
	var _system_alert_bell = __webpack_require__(1416);
	
	var _system_alert_bell2 = _interopRequireDefault(_system_alert_bell);
	
	var _storedUser = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SystemAlertBell: _system_alert_bell2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(["currentUser", "routesEmpty", "helpIconRoutes"])),
	  props: ["type", "routeHeader", "routePath", "modifyData", "refreshCampaignComponent", "suborg"],
	  data: function data() {
	    return {
	      liveOrDemoStatus: false,
	      liveOrDemo: "",
	      showOrNot: 0,
	      company_logo: "",
	      company_logo_exist: 2,
	      status: "",
	      selected_company: "",
	      company_id: "",
	      permissions: {
	        general: true
	      },
	      remaining_days: "",
	      quickmenu: "",
	      activemenu: "text-complete",
	      currentRouteName: "",
	      helpUrl: [{ message: "report/campaigns" }, { message: "/" }, { message: "/campaigns" }, { message: "/announcements" }, { message: "/announcements/create" }, { message: "/campaigns/description/" }, { message: "/campaigns/create" }],
	      managementReportQuickBtnpermissions: {
	        vulnerability_trend_new: true,
	        awareness_trend_new: true,
	        reporting_trend_new: true,
	        weakest_links_new: true,
	        strongest_links_least_compromised_new: true,
	        strongest_links_most_compromised_new: true,
	        weakest_departments_new: true
	      },
	      steps: [],
	      walkthroughSteps: {
	        dashboard: {
	          elementId: "#sidebar-dashboard",
	          intro: "Get a bird’s eye view of all important metrics.",
	          position: "right"
	        },
	        calendar: {
	          elementId: "#sidebar-calendar",
	          intro: "View and export schedule calendar.",
	          position: "right"
	        },
	        campaigns: {
	          elementId: "#sidebar-campaign",
	          intro: "Create and manage phishing campaigns.",
	          position: "right"
	        },
	        announcements: {
	          elementId: "#sidebar-announcement",
	          intro: "Use this to create and manage announcements, eAUP, or internal communication.",
	          position: "right"
	        },
	        policy: {
	          elementId: "#sidebar-policy",
	          intro: "Create and Manage Policy.",
	          position: "right"
	        },
	        adobe_acrobat: {
	          elementId: "#adobe_acrobat",
	          intro: "View and manage Adobe Acrobat.",
	          position: "right"
	        },
	        scenarios: {
	          elementId: "#sidebar-scenario",
	          intro: "Create and manage scenarios for phishing,announcement campaigns and policy.",
	          position: "right"
	        },
	        trainings: {
	          elementId: "#sidebar-training",
	          intro: "Upload, view and manage cybersecurity training modules.",
	          position: "right"
	        },
	        lms: {
	          elementId: "#sidebar-lms",
	          intro: "View and manage cybersecurity training enrolments and reports.",
	          position: "right"
	        },
	        recipients: {
	          elementId: "#sidebar-recipients",
	          intro: "View and manage recipients here.",
	          position: "right"
	        },
	        reports: {
	          elementId: "#sidebar-reports",
	          intro: "View all the old and legacy reports here.",
	          position: "right"
	        },
	        reportsnew: {
	          elementId: "#sidebar-reports-new",
	          intro: "View the new enhanced reports here.",
	          position: "right"
	        },
	        newmanagement_reports: {
	          elementId: "#sidebar-management-reports",
	          intro: "Quick access to important management reports.",
	          position: "right"
	        },
	        newvulnerability_reports: {
	          elementId: "#sidebar-vulnerability-reports",
	          intro: "Uncover the most vulnerable departments and designations in your organisation.",
	          position: "right"
	        },
	        vcronew: {
	          elementId: "#sidebar-vcro",
	          intro: "Uncover and protect the most critical and vulnerable resources with the help of your own Virtual Cyber Risk Officer.",
	          position: "right"
	        },
	        newgamification_engine: {
	          elementId: "#sidebar-gamification",
	          intro: "Increase employee engagement in cybersecurity initiatives through gamification.",
	          position: "right"
	        },
	        user_portal_new: {
	          elementId: "#sidebar-user-portal",
	          intro: "Empower your employees by giving them access to their complete cybersecurity profile through User Portal.",
	          position: "right"
	        },
	        exported_files: {
	          elementId: "#exported_files",
	          intro: "Exported Files",
	          position: "right"
	        },
	        teamportal: {
	          elementId: "#teamportal",
	          intro: "Access and manage the Team Portal.",
	          position: "right"
	        },
	        admin_log: {
	          elementId: "#admin_log",
	          intro: "View the log of user activity.",
	          position: "right"
	        },
	        settings: {
	          elementId: "#sidebar-settings",
	          intro: "Manage all common platform settings from here.",
	          position: "right"
	        },
	        ip_information: {
	          elementId: "#ip_information",
	          intro: "View and manage user IP information.",
	          position: "right"
	        },
	        active_directory: {
	          elementId: "#active_directory_nav",
	          intro: "Manage Active Directory settings here.",
	          position: "right"
	        },
	        azure_active_dir: {
	          elementId: "#sidebar-azure-active-dir",
	          intro: "Manage Azure AD settings here.",
	          position: "right"
	        },
	        faq: {
	          elementId: "#faq-btn",
	          intro: "Click this to get contextual help and answers to frequently asked questions.",
	          position: "right"
	        },
	        quickview: {
	          elementId: "#quickview-btn",
	          intro: "Quick access to management level reports.",
	          position: "right"
	        }
	      },
	      helps_route: [],
	      notificationList: [],
	      notificationCount: {}
	    };
	  },
	  created: function created() {
	    var _this = this;
	
	    var local = JSON.parse(localStorage.getItem("company_logo"));
	    if (!local || local === null) {
	      this.$http.get("/setting/company_logo").then(function (response) {
	        localStorage.setItem("company_logo", (0, _stringify2.default)(response.data.data));
	        _this.company_logo = response.data.data.logo;
	        var educateDomainUrl = response.data.data.active_educate_domain_url;
	        var activeDomainUrl = (0, _keys2.default)(educateDomainUrl).find(function (key) {
	          return educateDomainUrl[key] === true;
	        });
	        var fullDomain = "https://" + activeDomainUrl;
	        localStorage.setItem('activeEducationDomain', fullDomain);
	        if (response.data.data.active_pdf_campaign) {
	          var isActive = response.data.data.active_pdf_campaign.is_active_pdf_campaign;
	          var existingValue = JSON.parse(localStorage.getItem("pdfCampaignSetting"));
	          if (existingValue === null || existingValue !== isActive) {
	            localStorage.setItem("pdfCampaignSetting", (0, _stringify2.default)(isActive));
	          }
	        }
	      });
	    }
	    if (this.routesEmpty) this.createRouteSet();
	    var permissions = JSON.parse(localStorage.getItem("permissions"));
	    this.managementReportQuickBtnpermissions = {
	      vulnerability_trend_new: permissions && permissions.vulnerability_trend_new,
	      awareness_trend_new: permissions && permissions.awareness_trend_new,
	      reporting_trend_new: permissions && permissions.reporting_trend_new,
	      weakest_links_new: permissions && permissions.weakest_links_new,
	      strongest_links_least_compromised_new: permissions && permissions.strongest_links_least_compromised_new,
	      strongest_links_most_compromised_new: permissions && permissions.strongest_links_most_compromised_new,
	      weakest_departments_new: permissions && permissions.weakest_departments_new
	    };
	    $(document).ready(function () {
	      $(document).on("click", ".introjs-skipbutton, .introjs-donebutton, .introjs-overlay", function (e) {
	        e.preventDefault();
	        $(".page-sidebar").removeClass("active_sidebar");
	      });
	    });
	    this.$bus.$on("updateCompanyLogo", function (updatedLogo) {
	      _this.company_logo = updatedLogo;
	    });
	  },
	  beforeMount: function beforeMount() {
	    var _this2 = this;
	
	    var logindata = (0, _storedUser.readStoredUser)();
	    var quickStart = localStorage.getItem("quickStart");
	    if (!JSON.parse(localStorage.getItem("permissions"))) {
	      this.$http.get("/setting/user_modules").then(function (response) {
	        _this2.showOrNot = response.data.data.status;
	        _this2.accountType();
	      });
	    } else {
	      var user_permission = JSON.parse(localStorage.getItem("permissions"));
	      this.showOrNot = user_permission.status;
	      this.accountType();
	    }
	    if (logindata && logindata.first_time) {
	      if (quickStart == 1) {
	        setTimeout(function () {
	          $("#quickviewa").modal("show");
	          localStorage.removeItem("quickStart");
	        }, 3500);
	      }
	    }
	    var currentURL = window.location.pathname;
	    this.currentURL = currentURL;
	    var permissions = JSON.parse(localStorage.getItem("permissions"));
	    if (permissions) {
	      this.permissions.general = permissions.general;
	    }
	
	    this.remaining_days = JSON.parse(localStorage.getItem("expired_in"));
	    if (!this.currentUser) {
	      this.$router.push({ name: "auth.login" });
	    }
	    this.currentRouteName = this.$router.currentRoute.name;
	
	    this.companyLogo();
	  },
	  mounted: function mounted() {
	    this.getNotificationList();
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(["logout", "setHelpIconRoutes"]), {
	    handleLogoError: function handleLogoError() {
	      this.company_logo = "";
	      this.company_logo_exist = 0;
	    },
	    titleCase: function titleCase(value) {
	      if (!value) {
	        return "";
	      }
	      return String(value).charAt(0).toUpperCase() + String(value).slice(1).toLowerCase();
	    },
	    companyLogo: function companyLogo() {
	      var companyLogoData = JSON.parse(localStorage.getItem("company_logo"));
	
	      if (!companyLogoData) {
	        return;
	      }
	      this.company_logo_exist = 1;
	      this.company_logo = companyLogoData.logo;
	      this.company_id = companyLogoData.company_id;
	      this.status = companyLogoData.status;
	      this.selected_company = companyLogoData.selected_company;
	    },
	    accountType: function accountType() {
	      var account_type = localStorage.getItem("account-type");
	      if (parseInt(this.showOrNot) === 2 && account_type == null) {
	        this.getLiveOrDemoStatus();
	      } else {
	        this.liveOrDemo = account_type;
	        this.activeCheck();
	      }
	    },
	    changeTypeLiveDemo: function changeTypeLiveDemo() {
	      var _this3 = this;
	
	      this.$http.post("/adminlogin/switch-account-type", {
	        account_type: this.liveOrDemo
	      }).then(function (response) {
	        if (response.data.status) {
	          if (_this3.liveOrDemo === "demo") {
	            _this3.liveOrDemoStatus = true;
	          } else {
	            _this3.liveOrDemoStatus = false;
	          }
	          $("body").pgNotification({
	            message: response.data.message,
	            position: "top",
	            style: "bar",
	            timeout: 4000,
	            type: "success"
	          }).show();
	        } else {
	          $("body").pgNotification({
	            message: response.data.message,
	            position: "top",
	            style: "bar",
	            timeout: 4000,
	            type: "error"
	          }).show();
	          _this3.changeStatusFailed();
	        }
	        _this3.setliveDemoStatus();
	      });
	    },
	    showLiveOrDemo: function showLiveOrDemo() {
	      var _this4 = this;
	
	      var note = "Switching to DEMO mode means the client will only see demo data.";
	      if (this.liveOrDemo === "live") {
	        note = "Switch to LIVE mode for full access and functionality.";
	      }
	      this.$swal({
	        title: "You're about to switch " + this.currentUser.company + " to " + this.liveOrDemo + " mode.",
	        text: note,
	        type: "warning",
	        class: "swal-color",
	        showCancelButton: true,
	        confirmButtonColor: "#3085d6",
	        cancelButtonColor: "#d33",
	        confirmButtonText: "Switch"
	      }).then(function (confirm) {
	        if (confirm) {
	          this.changeTypeLiveDemo();
	        }
	      }.bind(this)).catch(function () {
	        _this4.changeStatusFailed();
	      });
	    },
	    changeStatusFailed: function changeStatusFailed() {
	      if (this.liveOrDemo === "demo") {
	        this.liveOrDemo = "live";
	        this.liveOrDemoStatus = false;
	      } else {
	        this.liveOrDemo = "demo";
	        this.liveOrDemoStatus = true;
	      }
	    },
	    getLiveOrDemoStatus: function getLiveOrDemoStatus() {
	      var _this5 = this;
	
	      this.$http.get("/adminlogin/account-type").then(function (response) {
	        if (response.data.status) {
	          _this5.liveOrDemo = response.data.account_type;
	          _this5.setliveDemoStatus();
	          _this5.activeCheck();
	        }
	      });
	    },
	    setliveDemoStatus: function setliveDemoStatus() {
	      localStorage.setItem("account-type", this.liveOrDemo);
	    },
	    activeCheck: function activeCheck() {
	      if (this.liveOrDemo === "demo") {
	        this.liveOrDemoStatus = true;
	      } else {
	        this.liveOrDemoStatus = false;
	      }
	    },
	    getNotificationList: function getNotificationList() {
	      var _this6 = this;
	
	      this.$http.get("/setting/company-notifications").then(function (response) {
	        _this6.notificationList = response.data.data;
	        _this6.notificationCount = response.data.meta.unreadCount;
	      });
	    },
	    postNotificationList: function postNotificationList(id) {
	      var _this7 = this;
	
	      this.$http.post("/setting/company-notifications-user-relations?company_notification_id=" + id).then(function (response) {
	        _this7.notificationList = response.data;
	        _this7.getNotificationList();
	      });
	    },
	    goToNotification: function goToNotification(notificationId) {
	      if (notificationId !== null) {
	        this.postNotificationList(notificationId);
	        this.$router.push({
	          name: "notificationDescription",
	          params: { id: notificationId }
	        });
	      } else {
	        this.$router.push({
	          name: "notificationDescription",
	          params: { id: "all" }
	        });
	      }
	    },
	    logoutUser: function logoutUser() {
	      this.logout();
	      localStorage.clear();
	      this.$router.push({ name: "auth.login", query: { logout: true } });
	    },
	    updateAdminLogin: function updateAdminLogin() {
	      var data = {};
	      data.admin_company_id = this.company_id;
	      this.$http.post("/adminlogin/updateadminlogin", data).then(function (response) {
	        if (response.data) {
	          location.reload();
	        }
	      });
	    },
	    quickview: function quickview() {
	      if (this.quickmenu == "open") {
	        this.quickmenu = "";
	      } else {
	        this.quickmenu = "open";
	      }
	    },
	    startWalkthrough: function startWalkthrough() {
	      var _this8 = this;
	
	      this.steps = [];
	      var sidebar_permissions = JSON.parse(localStorage.getItem("s_permissions"));
	      (0, _keys2.default)(sidebar_permissions).map(function (i) {
	        if (sidebar_permissions[i] && _this8.walkthroughSteps[i]) {
	          _this8.walkthroughSteps[i].element = document.querySelector(_this8.walkthroughSteps[i].elementId);
	          if (_this8.walkthroughSteps[i].element) _this8.steps.push(_this8.walkthroughSteps[i]);
	        }
	      });
	      $(".page-sidebar").addClass("active_sidebar");
	      $(".page-container").addClass("stop-scrolling");
	      introJs().setOptions({
	        showProgress: true,
	        steps: this.steps
	      }).start().onbeforechange(function (targetElement) {
	        if (!targetElement) introJS().nextStep();
	      }).onbeforeexit(function () {
	        $(".page-sidebar").removeClass("active_sidebar");
	        $(".page-container").removeClass("stop-scrolling");
	        return;
	      });
	    },
	    isHelpIconHidden: function isHelpIconHidden(currentPath) {
	      var basePath = currentPath.split('/').slice(0, 3).join('/');
	
	      return this.helpIconRoutes.includes(basePath);
	    },
	    createRouteSet: function createRouteSet() {
	      var routes = [].concat((0, _toConsumableArray3.default)(_recipient.routes), (0, _toConsumableArray3.default)(_report.routes), (0, _toConsumableArray3.default)(_gamification.routes), (0, _toConsumableArray3.default)(_managementreport.routes), (0, _toConsumableArray3.default)(_vcro.routes), (0, _toConsumableArray3.default)(_setting.routes), (0, _toConsumableArray3.default)(_leaderboard.routes), (0, _toConsumableArray3.default)(_laggards.routes), (0, _toConsumableArray3.default)(_userportalpages.routes), (0, _toConsumableArray3.default)(_ip.routes));
	      var helps_route = [].concat((0, _toConsumableArray3.default)(routes.map(function (route) {
	        return route.path;
	      })), ["/bulk/campaigns", "/schedule-calendar", "/companylist", "/announcements", "/campaigns", "/policy", "/scenario", "/gamification-engine/award-log", "/campaigns/schedule", "/announcements/schedule", "/policy/schedule"]);
	      this.setHelpIconRoutes(helps_route);
	    }
	  })
	};

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	var _stringify = __webpack_require__(6);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _config = __webpack_require__(2);
	
	var _storedUser = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
			data: function data() {
					return {
							showBoth: false,
							user_permission: {
									data: {
											endUserPortal: '',
											campaign_view: false,
											campaign_create: false,
											campaign_schedule: false,
											announcement_view: false,
											announcement_create: false,
											view_recepients: false,
											add_new_recepients: false,
											view_report: false,
											add_new_report: false,
											domain: false,
											general: false,
											user_management: false,
											retest_frequency: false,
											direct_learning_management: false,
											training_invitation_mail: false,
											training_login_template: false,
											data_entry_oops_page: false,
											training_mail: false,
											email_setting: false,
											userportal_active_version: {
													userportal: "v1"
											},
											app_theme: {},
											company_logo: {
													logo: ''
											},
											lmsUrl: _config.lmsUrl,
											hfv3Url: _config.hfv3Url
									}
							},
							myUserportal: '',
							myTeamportal: '',
							teamPortalStatus: {
									is_active_teamportal: false,
									status: 1,
									is_team_flag: false
							},
							needlePhishingStatus: false,
							usersType: 0,
							loader: true,
							isAdmin: 1,
							adobeAcrobatStatus: false,
							isActivePdfCampaign: false,
							adminLogsEnabled: false,
							ouSettingStatus: false,
							userRole: ''
					};
			},
			created: function created() {
					var _this = this;
	
					this.getOuSettingStatus();
					this.getAdobeAcrobatStatus();
					this.getpdfcampaignStatus();
					this.getAdminLogsStatus();
	
					this.getUserRole();
					this.$bus.$on('reloadafterPermissionUpdation', function (val) {
							_this.user_permission.data = JSON.parse(localStorage.getItem("permissions"));
							_this.showHideUserPortal();
							_this.getUserRole();
							_this.setData();
					});
					var PERMISSIONS_TTL = 5 * 60 * 1000;
					var cachedPermissions = JSON.parse(localStorage.getItem("permissions"));
					var permTimestamp = parseInt(localStorage.getItem("permissions_ts") || '0');
					var isStale = Date.now() - permTimestamp > PERMISSIONS_TTL;
	
					if (!cachedPermissions || isStale) {
							this.$http.get('/setting/user_modules').then(function (response) {
									_this.user_permission.data = response.data.data;
									_this.showHideUserPortal();
									_this.loader = false;
									_this.setData();
							});
					} else {
							this.user_permission.data = cachedPermissions;
							this.showHideUserPortal();
							this.setData();
					}
					this.getTeamPortalStatus();
					this.getNeedlePhishingStatus();
			},
			mounted: function mounted() {
					var head = document.getElementsByTagName('nav')[0];
					var script = document.createElement('script');
					script.type = 'text/javascript';
					script.src = '/static/pages/js/pages.js';
	
					head.appendChild(script);
	
					$(".modal-backdrop.fade.in").remove();
					window.onpopstate = function () {
							location.reload();
					};
					this.MyUserportalurl();
	
					var storedUser = (0, _storedUser.readStoredUser)();
					if (storedUser) {
							this.isAdmin = storedUser.status;
					}
			},
	
			methods: {
					getOuSettingStatus: function getOuSettingStatus() {
							var _this2 = this;
	
							this.$http.get('setting/ou-setting-status').then(function (response) {
									_this2.ouSettingStatus = response.data && response.data.data && response.data.data.is_active_ou_setting;
							});
					},
					getUserRole: function getUserRole() {
							var _this3 = this;
	
							this.$http.get('setting/user-role-name').then(function (response) {
									var roleName = response.data.role_name || '';
									_this3.userRole = roleName;
									localStorage.setItem('campaignUserRole', roleName);
							}).catch(function () {
									_this3.userRole = localStorage.getItem('campaignUserRole') || '';
							});
					},
					getpdfcampaignStatus: function getpdfcampaignStatus() {
							var _this4 = this;
	
							this.$http.get('setting/pdf/campaign/status').then(function (response) {
									_this4.isActivePdfCampaign = response.data.data.is_active_pdf_campaign;
							});
					},
					getAdobeAcrobatStatus: function getAdobeAcrobatStatus() {
							var _this5 = this;
	
							this.$http.get('setting/adobe-acrobat/status').then(function (response) {
									_this5.adobeAcrobatStatus = response.data.is_active_adobe_acrobat;
							});
					},
					getAdminLogsStatus: function getAdminLogsStatus() {
							var _this6 = this;
	
							this.$http.get('setting/admin-logs/status').then(function (response) {
									_this6.adminLogsEnabled = response.data.admin_logs_enabled;
							}).catch(function () {
									_this6.adminLogsEnabled = false;
							});
					},
					getTeamPortalStatus: function getTeamPortalStatus() {
							var _this7 = this;
	
							this.$http.get('setting/get/teamportal/status').then(function (response) {
									_this7.teamPortalStatus = response.data.data;
							});
					},
					getNeedlePhishingStatus: function getNeedlePhishingStatus() {
							var _this8 = this;
	
							this.$http.get('setting/needle/phishing/status').then(function (response) {
									_this8.needlePhishingStatus = response.data.data.is_active_needle_phishing;
							});
					},
					showHideUserPortal: function showHideUserPortal() {
							if (this.user_permission.data && this.user_permission.data.userportal_active_version === undefined) {
									this.showBoth = true;
							} else {
									this.showBoth = false;
							}
					},
					checkActive: function checkActive(val) {
							return val ? '' : 'not-active';
					},
					setData: function setData() {
							var userpermissions = {
									'active_directory_view_logs': this.user_permission.data.active_directory_view_logs,
									'ad_servers': this.user_permission.data.ad_servers,
									'add_new_recepients': this.user_permission.data.add_new_recepients,
									'add_scenario': this.user_permission.data.add_scenario,
									'add_suppression': this.user_permission.data.add_suppression,
									'all_reports': this.user_permission.data.all_reports,
									'announcement_campaigns_new': this.user_permission.data.announcement_campaigns_new,
									'policy_announcement_new': this.user_permission.data.policy_announcement_new,
									'announcement_create': this.user_permission.data.announcement_create,
									'announcement_reports': this.user_permission.data.announcement_reports,
									'announcement_view': this.user_permission.data.announcement_view,
									'auto_reminder_mail': this.user_permission.data.auto_reminder_mail,
									'awareness_trend': this.user_permission.data.awareness_trend,
									'awareness_trend_new': this.user_permission.data.awareness_trend_new,
									'azure_active_directory_authorization': this.user_permission.data.azure_active_directory_authorization,
									'campaign_create': this.user_permission.data.campaign_create,
									'campaign_reports': this.user_permission.data.campaign_reports,
									'campaign_schedule': this.user_permission.data.campaign_schedule,
									'campaign_view': this.user_permission.data.campaign_view,
									'policy_create': this.user_permission.data.policy_create,
									'policy_view': this.user_permission.data.policy_view,
									'dashboard': this.user_permission.data.dashboard,
									'data_entry_oops_page': this.user_permission.data.data_entry_oops_page,
									'department_compromise': this.user_permission.data.department_compromise,
									'departments_new': this.user_permission.data.departments_new,
									'departments_vcro': this.user_permission.data.departments_vcro,
									'designation_compromise': this.user_permission.data.designation_compromise,
									'designations_new': this.user_permission.data.designations_new,
									'detailed_new': this.user_permission.data.detailed_new,
									'detailed_report': this.user_permission.data.detailed_report,
									'domains': this.user_permission.data.domains,
									'email_settings': this.user_permission.data.email_settings,
									'enrolments': this.user_permission.data.enrolments,
									'general': this.user_permission.data.general,
									'groups_vcro': this.user_permission.data.groups_vcro,
									'high_risk_users': this.user_permission.data.high_risk_users,
									'hris_vsms_directory_service': this.user_permission.data.hris_vsms_directory_service,
									'hris_vsms_directory_service_logs': this.user_permission.data.hris_vsms_directory_service_logs,
									'ignore_ip_list': this.user_permission.data.ignore_ip_list,
									'import_reporters': this.user_permission.data.import_reporters,
									'import_trained_users': this.user_permission.data.import_trained_users,
									'laggardsnew': this.user_permission.data.laggardsnew,
									'landing_page_templates': this.user_permission.data.landing_page_templates,
									'leaderboard_new': this.user_permission.data.leaderboard_new,
									'leaderboard_settings': this.user_permission.data.leaderboard_settings,
									'lms': this.user_permission.data.lms,
									'manage_groups': this.user_permission.data.manage_groups,
									'notifications': this.user_permission.data.notifications,
									'organisation_vcro': this.user_permission.data.organisation_vcro,
									'passing_percentage': this.user_permission.data.passing_percentage,
									'phishing_campaigns_new': this.user_permission.data.phishing_campaigns_new,
									'reporting_trend': this.user_permission.data.reporting_trend,
									'reporting_trend_new': this.user_permission.data.reporting_trend_new,
									'security': this.user_permission.data.security,
									'settings': this.user_permission.data.settings,
									'status': this.user_permission.data.status,
									'strongest_links': this.user_permission.data.strongest_links,
									'strongest_links_least_compromised_new': this.user_permission.data.strongest_links_least_compromised_new,
									'strongest_links_most_compromised_new': this.user_permission.data.strongest_links_most_compromised_new,
									'throttling_speed': this.user_permission.data.throttling_speed,
									'training_invitation_mail': this.user_permission.data.training_invitation_mail,
									'training_login_template': this.user_permission.data.training_login_template,
									'upload_modules': this.user_permission.data.upload_modules,
									'user_management': this.user_permission.data.user_management,
									'users_vcro': this.user_permission.data.users_vcro,
									'view_laggards': this.user_permission.data.view_laggards,
									'view_leaderboard': this.user_permission.data.view_leaderboard,
									'view_modules': this.user_permission.data.view_modules,
									'is_education_editable': this.user_permission.data.is_education_editable,
									'view_recepients': this.user_permission.data.view_recepients,
									'view_scenario': this.user_permission.data.view_scenario,
									'view_suppression': this.user_permission.data.view_suppression,
									'vulnerability_trend': this.user_permission.data.vulnerability_trend,
									'vulnerability_trend_new': this.user_permission.data.vulnerability_trend_new,
									'weakest_departments': this.user_permission.data.weakest_departments,
									'weakest_departments_new': this.user_permission.data.weakest_departments_new,
									'weakest_links': this.user_permission.data.weakest_links,
									'weakest_links_new': this.user_permission.data.weakest_links_new,
									'company_id': this.user_permission.data.company_id,
									'domain': this.user_permission.data.domain,
									'retest_frequency': this.user_permission.data.retest_frequency,
									'point_configure': this.user_permission.data.point_configure,
									'education_uploader': this.user_permission.data.education_uploader,
									'change_password': this.user_permission.data.change_password,
									'company_list': this.user_permission.data.status == 2 ? true : false,
									'gamification_add_badgee': this.user_permission.data.gamification_add_badgee,
									'gamification_award_log': this.user_permission.data.gamification_award_log,
									'gamification_badges': this.user_permission.data.gamification_badges,
									'gamification_set_points': this.user_permission.data.gamification_set_points,
									'my_team_portal': this.user_permission.data.my_team_portal,
									'customise_team_portal': this.user_permission.data.customise_team_portal,
									'team_portal_view_as': this.user_permission.data.team_portal_view_as,
									'myUserportal': this.user_permission.data.myUserportal,
									'myUserportal_view_as': this.user_permission.data.myUserportal_view_as,
									'customise_user_portal': this.user_permission.data.customise_user_portal,
									'customise_login_page': this.user_permission.data.customise_login_page,
									'news_updates': this.user_permission.data.news_updates,
									'exported': this.user_permission.data.exported,
									'app_theme': this.user_permission.data.app_theme
							};
							var sidebar_permissions = {
									'dashboard': this.user_permission.data.dashboard,
									'calendar': true,
									'campaigns': this.user_permission.data.campaign_create || this.user_permission.data.campaign_view || this.user_permission.data.campaign_schedule,
									'announcements': this.user_permission.data.announcement_create || this.user_permission.data.announcement_view,
									'policy': this.user_permission.data.policy_create || this.user_permission.data.policy_view,
									'adobe_acrobat': this.adobeAcrobatStatus,
									'scenarios': this.user_permission.data.view_scenario || this.user_permission.data.add_scenario,
									'trainings': this.user_permission.data.view_modules || this.user_permission.data.upload_modules || this.user_permission.data.direct_learning_management || this.user_permission.data.education_uploader || this.user_permission.data.is_education_editable,
									'lms': this.user_permission.data.lms,
									'recipients': this.user_permission.data.view_recepients || this.user_permission.data.add_new_recepients || this.user_permission.data.manage_groups || this.user_permission.data.add_suppression || this.user_permission.data.view_suppression,
									'reports': this.user_permission.data.all_reports || this.user_permission.data.campaign_reports || this.user_permission.data.announcement_reports || this.user_permission.data.detailed_report || this.user_permission.data.view_leaderboard || this.user_permission.data.view_laggards || this.user_permission.data.vulnerability_trend || this.user_permission.data.awareness_trend || this.user_permission.data.reporting_trend || this.user_permission.data.weakest_links || this.user_permission.data.strongest_links || this.user_permission.data.weakest_departments || this.user_permission.data.high_risk_users || this.user_permission.data.department_compromise || this.user_permission.data.designation_compromise,
									'reportsnew': this.user_permission.data.phishing_campaigns_new || this.user_permission.data.announcement_campaigns_new || this.user_permission.data.policy_announcement_new || this.user_permission.data.leaderboard_new || this.user_permission.data.laggardsnew,
									'newmanagement_reports': this.user_permission.data.vulnerability_trend_new || this.user_permission.data.awareness_trend_new || this.user_permission.data.reporting_trend_new || this.user_permission.data.weakest_links_new || this.user_permission.data.strongest_links_least_compromised_new || this.user_permission.data.strongest_links_most_compromised_new || this.user_permission.data.weakest_departments_new,
									'newvulnerability_reports': this.user_permission.data.departments_new || this.user_permission.data.designations_new,
									'vcronew': this.user_permission.data.organisation_vcro || this.user_permission.data.departments_vcro || this.user_permission.data.groups_vcro || this.user_permission.data.users_vcro,
									'newgamification_engine': this.user_permission.data.gamification_add_badgee || this.user_permission.data.gamification_award_log || this.user_permission.data.gamification_badges || this.user_permission.data.gamification_set_points,
									'user_portal_new': this.user_permission && this.user_permission.data.myUserportal || this.user_permission.data.myUserportal_view_as || this.user_permission.data.customise_user_portal || this.user_permission.data.customise_login_page || this.user_permission.data.news_updates,
									'exported_files': true,
									'teamportal': true,
									'admin_log': true,
									'settings': this.user_permission.data.domain || this.user_permission.data.general || this.user_permission.data.user_management || this.user_permission.data.retest_frequency || this.user_permission.data.email_setting || this.user_permission.data.throttling_speed || this.user_permission.data.data_entry_oops_page || this.user_permission.data.landing_page_templates || this.user_permission.data.notifications || this.user_permission.data.ignore_ip_list || this.user_permission.data.passing_percentage || this.user_permission.data.leaderboard_settings || this.user_permission.data.training_login_template || this.user_permission.data.security || this.user_permission.data.change_password || this.user_permission.data.import_reporters,
									'ip_information': true,
									'active_directory': this.user_permission.data.ad_servers || this.user_permission.data.active_directory_view_logs,
									'azure_active_dir': this.user_permission.data.azure_active_directory_authorization,
									'faq': true,
									'quickview': true
	
							};
							if (this.user_permission.data && this.user_permission.data.userportal_active_version && this.user_permission.data.userportal_active_version.userportal) {
									userpermissions.userportal_active_version = {
											'userportal': this.user_permission.data.userportal_active_version.userportal
									};
							}
							localStorage.setItem("s_permissions", (0, _stringify2.default)(sidebar_permissions));
							localStorage.setItem("permissions", (0, _stringify2.default)(userpermissions));
							localStorage.setItem("permissions_ts", Date.now().toString());
							this.$bus.$emit('permissions-updated', userpermissions);
					},
					redirectToLms: function redirectToLms() {
							var user = localStorage.getItem('user');
							var permissions = localStorage.getItem('permissions');
							var userObj = JSON.parse(user);
	
							this.$http.post('setting/save_user_token', { user: user, permissions: permissions }).then(function (response) {
									window.open(_config.lmsUrl + '/lms/course?t=' + userObj.token, "_blank");
							});
					},
					redirectToHFv3: function redirectToHFv3() {
							var _this9 = this;
	
							var user = localStorage.getItem('user');
							var userObj = JSON.parse(user);
							var permissions = localStorage.getItem('permissions');
							this.$http.post('setting/save_user_token', { user: user, permissions: permissions }).then(function (response) {
									var redirecturl = _config.hfv3Url.replace('/login', '');
									var permissions = JSON.parse(localStorage.getItem("company_logo"));
									_this9.company_id = permissions.company_id;
									window.open(redirecturl + '?t=' + userObj.token + '&c=' + _this9.company_id, "_blank");
							});
					},
					MyUserportalurl: function MyUserportalurl() {
							var _this10 = this;
	
							var companyLogoData = JSON.parse(localStorage.getItem("company_logo"));
							if (companyLogoData) {
									this.myUserportal = companyLogoData.url;
									if (this.myUserportal) {
											this.endUserPortal = companyLogoData.url.replace("userportal", "userportal-v2/en");
									}
	
									this.myTeamportal = companyLogoData.team_url;
									this.usersType = companyLogoData.type;
							} else {
									setTimeout(function () {
											_this10.MyUserportalurl();
									}, 5000);
							}
					},
					redirectToMyUserportal: function redirectToMyUserportal() {
							window.open(this.myUserportal, "_blank");
					}
			}
	};

/***/ }),

/***/ 792:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'SystemAlertBell',
	
	  data: function data() {
	    return {
	      enabled: false,
	      alerts: [],
	      criticalCount: 0,
	      warningCount: 0,
	      totalCount: 0,
	
	      dismissedCount: 0,
	      pollTimer: null,
	      onVisibilityChange: null,
	      dismissingAll: false,
	
	      fetchingSummary: false,
	      summaryStale: false
	    };
	  },
	
	
	  computed: {
	    hasCritical: function hasCritical() {
	      return this.criticalCount > 0;
	    },
	    severityClass: function severityClass() {
	      if (!this.alerts.length) {
	        return 'is-dismissed';
	      }
	      return this.hasCritical ? 'has-critical' : 'has-warning';
	    },
	    iconTitle: function iconTitle() {
	      if (!this.alerts.length) {
	        return this.dismissedCount + ' dismissed issue(s), still unfixed';
	      }
	      if (this.criticalCount > 0) {
	        return this.criticalCount + ' critical configuration issue(s)';
	      }
	      return this.warningCount + ' configuration warning(s)';
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.fetchSummary();
	    this.startPolling();
	
	    this.onVisibilityChange = function () {
	      if (document.hidden) {
	        _this.stopPolling();
	      } else {
	        _this.fetchSummary();
	        _this.startPolling();
	      }
	    };
	
	    document.addEventListener('visibilitychange', this.onVisibilityChange);
	
	    this.$bus.$on('system-alerts-refresh', this.fetchSummary);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.stopPolling();
	    this.$bus.$off('system-alerts-refresh', this.fetchSummary);
	
	    if (this.onVisibilityChange) {
	      document.removeEventListener('visibilitychange', this.onVisibilityChange);
	      this.onVisibilityChange = null;
	    }
	  },
	
	
	  methods: {
	    startPolling: function startPolling() {
	      this.stopPolling();
	      this.pollTimer = setInterval(this.fetchSummary, 300000);
	    },
	    stopPolling: function stopPolling() {
	      if (this.pollTimer) {
	        clearInterval(this.pollTimer);
	        this.pollTimer = null;
	      }
	    },
	    fetchSummary: function fetchSummary() {
	      var _this2 = this;
	
	      if (this.fetchingSummary) {
	        this.summaryStale = true;
	        return;
	      }
	
	      this.fetchingSummary = true;
	      this.summaryStale = false;
	
	      this.$http.get('/system-alerts/summary', { hideLoader: true }).then(function (response) {
	        _this2.releaseSummary();
	
	        var meta = response.data && response.data.meta || {};
	
	        _this2.enabled = !!meta.enabled;
	        _this2.alerts = response.data && response.data.data || [];
	        _this2.criticalCount = meta.criticalCount || 0;
	        _this2.warningCount = meta.warningCount || 0;
	        _this2.totalCount = meta.totalCount || 0;
	        _this2.dismissedCount = meta.dismissedCount || 0;
	
	        _this2.$bus.$emit('system-alerts-updated', {
	          enabled: _this2.enabled,
	          banner: meta.banner || { total: 0, types: [] }
	        });
	      }).catch(function () {
	        _this2.releaseSummary();
	
	        _this2.enabled = false;
	        _this2.alerts = [];
	        _this2.dismissedCount = 0;
	      });
	    },
	    releaseSummary: function releaseSummary() {
	      this.fetchingSummary = false;
	
	      if (this.summaryStale) {
	        this.summaryStale = false;
	        this.fetchSummary();
	      }
	    },
	    goToAlerts: function goToAlerts() {
	      this.$router.push({ name: 'systemAlerts' }).catch(function () {});
	    },
	    goToFix: function goToFix(alert) {
	      var _this3 = this;
	
	      if (!alert.action_route) {
	        return;
	      }
	
	      this.$router.push({ name: alert.action_route, params: alert.action_params || {} }).catch(function () {
	        _this3.goToAlerts();
	      });
	    },
	    dismiss: function dismiss(alert) {
	      var _this4 = this;
	
	      this.$http.post('/system-alerts/' + alert.id + '/dismiss').then(function () {
	        return _this4.fetchSummary();
	      }).catch(function () {});
	    },
	    dismissAll: function dismissAll() {
	      var _this5 = this;
	
	      if (this.dismissingAll) {
	        return;
	      }
	
	      this.dismissingAll = true;
	
	      this.$http.post('/system-alerts/dismiss-all').then(function () {
	        return _this5.fetchSummary();
	      }).catch(function () {}).then(function () {
	        _this5.dismissingAll = false;
	      });
	    }
	  }
	};

/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(17);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            data: {
	                name: '',
	                recipients_group: {}
	            },
	            recipients: [],
	            bulk_campaign_id: this.$route.params.id,
	            publishError: '',
	            publishErrorName: '',
	            published: false,
	            publish_check: 0,
	            recipientData: [],
	            selectedRecipient: [],
	            groupValueAllowed: 0,
	            allRecipients: []
	
	        };
	    },
	
	    props: ['action', 'auto_training_checks'],
	
	    beforeMount: function beforeMount() {
	        var _this = this;
	
	        this.$http.get('recipients/customfilters').then(function (response) {
	            _this.$http.get('/bulk/campaign/' + _this.bulk_campaign_id).then(function (responsedata) {
	
	                var bulkCampaign = responsedata.data.data;
	                if (bulkCampaign.recipients) {
	                    _this.data.name = bulkCampaign.name;
	                    _this.data.recipients_group = bulkCampaign.recipients;
	                    if (bulkCampaign.status == 1) {
	                        _this.published = true;
	                    }
	                }
	                var keys = {};
	                var recipientData = [];
	                if (bulkCampaign.recipients) {
	
	                    recipientData = bulkCampaign.recipients;
	
	                    if (recipientData) {
	                        keys = (0, _keys2.default)(recipientData);
	                    }
	                    _this.recipientData = recipientData;
	                }
	                for (var j = 0; j < keys.length; j++) {
	                    var tempRecipient = recipientData[keys[j]];
	                    var length = recipientData[keys[j]].length;
	
	                    if (keys[j] == 'sheet') {
	                        for (var m = tempRecipient.length - 1; m >= 0; m--) {
	                            if (tempRecipient[m] == 99999) {
	                                _this.selectedRecipient.push("All Sheets");
	                            }
	                        }
	
	                        for (var k = 0; k < length; k++) {
	                            var data = _this.recipientData.sheet;
	                            if (!data) {
	                                data = _this.recipientData.sheets;
	                            }
	
	                            if (data) {
	                                for (var i = 0; i < data.length; i++) {
	                                    if (data[i] == tempRecipient[k]) {
	                                        _this.selectedRecipient.push(data[i] + '|' + keys[j]);
	                                        break;
	                                    }
	                                }
	                            }
	                        }
	                    } else {
	                        for (var _k = 0; _k < length; _k++) {
	                            _this.selectedRecipient.push(tempRecipient[_k] + '|' + keys[j]);
	                        }
	                    }
	                }
	
	                if (_this.selectedRecipient.includes('All Sheets')) {
	                    _this.selectedRecipient = [];
	                    _this.selectedRecipient.push('All Sheets');
	                }
	
	                _this.recipientData = response.data;
	
	                var sheets = [];
	                var filterarray = (0, _keys2.default)(_this.recipientData.filters);
	                var totalGroups = filterarray.length;
	                totalGroups = totalGroups + 1;
	                _this.groupValueAllowed = Math.ceil(200 / totalGroups);
	
	                _this.recipientData.sheets.map(function (sheet) {
	                    if (sheet.count > 0 || sheet.updatecount > 0) {
	                        sheets.push({
	                            label: sheet.name,
	                            value: sheet.id
	                        });
	                    }
	                });
	
	                if (sheets.length == 0) {
	                    $('.el-select-dropdown__item').css('display', 'none');
	                } else {
	
	                    var allsheets = sheets;
	                    var allsheetObj = {
	                        'label': 'sheet',
	                        'options': allsheets
	                    };
	                    _this.allRecipients.push(allsheetObj);
	                    var sheetslimit = sheets.slice(0, _this.groupValueAllowed);
	                }
	
	                var sheetObj = {
	                    'label': 'sheet',
	                    'options': sheetslimit
	                };
	
	                _this.recipients.push(sheetObj);
	
	                _this.addPreselectedToFilter();
	
	                for (var _i = 0; _i < filterarray.length; _i++) {
	                    var filtername = filterarray[_i];
	                    var filtersObj = _this.recipientData.filters[filtername].value.map(function (filter) {
	                        return {
	                            label: filter,
	                            value: filter
	                        };
	                    });
	
	                    var filtersObjlimited = filtersObj.slice(0, _this.groupValueAllowed);
	                    var selectedStatus = _this.filterExists(_this.recipients, filtername);
	
	                    var valuestoRemove = [];
	                    if (selectedStatus !== false) {
	                        valuestoRemove = _this.recipients[selectedStatus].options;
	
	                        filtersObjlimited = filtersObjlimited.concat(valuestoRemove);
	                        filtersObjlimited = _this.getUnique(filtersObjlimited, 'label');
	                    }
	
	                    var custumObjlimit = {
	                        'label': _this.recipientData.filters[filtername].filter_name,
	                        'options': filtersObjlimited
	                    };
	                    var groupIndex = _this.filterExists(_this.recipients, custumObjlimit.label);
	                    if (groupIndex !== false) {
	                        _this.recipients[groupIndex] = custumObjlimit;
	                    } else {
	                        _this.recipients.push(custumObjlimit);
	                    }
	                    _this.recipients = _this.getUnique(_this.recipients, 'label');
	                    var custumObj = {
	                        'label': _this.recipientData.filters[filtername].filter_name,
	                        'options': filtersObj
	                    };
	                    _this.allRecipients.push(custumObj);
	                }
	            });
	        });
	    },
	    mounted: function mounted() {
	        $("#addCampaignModal").on("hidden.bs.modal", this.clearErrorFlashContent);
	    },
	
	    methods: {
	        getUnique: function getUnique(arr, comp) {
	
	            var unique = arr.map(function (e) {
	                return e[comp];
	            }).map(function (e, i, final) {
	                return final.indexOf(e) === i && i;
	            }).filter(function (e) {
	                return arr[e];
	            }).map(function (e) {
	                return arr[e];
	            });
	
	            return unique;
	        },
	        filterExists: function filterExists(recipients, filtername) {
	            var status = false;
	            for (var i = 0; i < recipients.length; i++) {
	                if (recipients[i].label) {
	                    if (recipients[i].label == filtername) {
	                        return i;
	                    }
	                }
	            }
	            return status;
	        },
	        addPreselectedToFilter: function addPreselectedToFilter() {
	            var blankObj = {};
	            var allrecipients = [];
	            for (var i = 0; i < this.selectedRecipient.length; i++) {
	                var locVar = this.selectedRecipient[i].split("|");
	                var key = locVar[1];
	                var value = locVar[0];
	
	                var option = [];
	                var index = this.getArrayIndex(allrecipients, key);
	                if (index === false) {
	                    var filteredObj = {};
	                    filteredObj.label = key;
	                    var subfilterObj = {};
	                    subfilterObj.label = value;
	                    subfilterObj.value = value;
	                    filteredObj.options = [];
	                    filteredObj.options.push(subfilterObj);
	                    allrecipients.push(filteredObj);
	                } else {
	
	                    var subfilterObj = {};
	                    subfilterObj.label = value;
	                    subfilterObj.value = value;
	                    if (allrecipients[index].options.length < this.groupValueAllowed) {
	                        allrecipients[index].options.push(subfilterObj);
	                    }
	                }
	                this.recipients = this.recipients.concat(allrecipients);
	            }
	        },
	        remoteRecipientGroup: function remoteRecipientGroup(query) {
	            var _this2 = this;
	
	            if (query !== '') {
	                this.loading = true;
	                var allrecipients = [];
	                setTimeout(function () {
	                    _this2.loading = false;
	                    var recipients = _this2.allRecipients.filter(function (item) {
	                        item.options.filter(function (subitem) {
	                            if (subitem.label.toLowerCase().indexOf(query.toLowerCase()) > -1) {
	
	                                var index = _this2.getArrayIndex(allrecipients, item.label);
	                                if (index === false) {
	                                    var filteredObj = {};
	                                    filteredObj.label = item.label;
	                                    var subfilterObj = {};
	                                    subfilterObj.label = subitem.label;
	                                    subfilterObj.value = subitem.value;
	                                    filteredObj.options = [];
	                                    filteredObj.options.push(subfilterObj);
	                                    allrecipients.push(filteredObj);
	                                } else {
	
	                                    var subfilterObj = {};
	                                    subfilterObj.label = subitem.label;
	                                    subfilterObj.value = subitem.value;
	                                    if (allrecipients[index].options.length < _this2.groupValueAllowed) {
	                                        allrecipients[index].options.push(subfilterObj);
	                                    }
	                                }
	                            }
	                        });
	                    });
	                    _this2.recipients = allrecipients;
	                }, 100);
	            } else {
	                this.recipients = [];
	                var sheets = [];
	                this.allRecipients = [];
	                var filterarray = (0, _keys2.default)(this.recipientData.filters);
	                var totalGroups = filterarray.length;
	                totalGroups = totalGroups + 1;
	                this.groupValueAllowed = Math.ceil(100 / totalGroups);
	
	                this.recipientData.sheets.map(function (sheet) {
	                    if (sheet.count > 0 || sheet.updatecount > 0) {
	                        sheets.push({
	                            label: sheet.name,
	                            value: sheet.id
	                        });
	                    }
	                });
	
	                if (sheets.length == 0) {
	                    $('.el-select-dropdown__item').css('display', 'none');
	                } else {
	
	                    var allsheets = sheets;
	                    var allsheetObj = {
	                        'label': 'sheet',
	                        'options': allsheets
	                    };
	                    this.allRecipients.push(allsheetObj);
	                    var sheetslimit = sheets.slice(0, this.groupValueAllowed);
	                }
	
	                var sheetObj = {
	                    'label': 'sheet',
	                    'options': sheetslimit
	                };
	
	                this.recipients.push(sheetObj);
	
	                this.addPreselectedToFilter();
	
	                for (var i = 0; i < filterarray.length; i++) {
	                    var filtername = filterarray[i];
	                    var filtersObj = this.recipientData.filters[filtername].value.map(function (filter) {
	                        return {
	                            label: filter,
	                            value: filter
	                        };
	                    });
	
	                    var filtersObjlimited = filtersObj.slice(0, this.groupValueAllowed);
	
	                    var selectedStatus = this.filterExists(this.recipients, filtername);
	
	                    var valuestoRemove = [];
	                    if (selectedStatus !== false) {
	                        valuestoRemove = this.recipients[selectedStatus].options;
	
	                        filtersObjlimited = filtersObjlimited.concat(valuestoRemove);
	                    }
	
	                    filtersObjlimited = this.getUnique(filtersObjlimited, 'label');
	
	                    var custumObjlimit = {
	                        'label': this.recipientData.filters[filtername].filter_name,
	                        'options': filtersObjlimited
	                    };
	                    var groupIndex = this.filterExists(this.recipients, custumObjlimit.label);
	                    if (groupIndex !== false) {
	                        this.recipients[groupIndex] = custumObjlimit;
	                    } else {
	                        this.recipients.push(custumObjlimit);
	                    }
	                    this.recipients = this.getUnique(this.recipients, 'label');
	                    var custumObj = {
	                        'label': this.recipientData.filters[filtername].filter_name,
	                        'options': filtersObj
	                    };
	                    this.allRecipients.push(custumObj);
	                }
	            }
	        },
	        getArrayIndex: function getArrayIndex(allrecipients, label) {
	            var status = false;
	            for (var i = 0; i < allrecipients.length; i++) {
	                if (allrecipients[i].label == label) {
	                    return i;
	                }
	            }
	            return status;
	        },
	        getData: function getData() {
	            var _this3 = this;
	
	            if (this.action == 'edit') {
	                this.$http.get('/bulk/campaign/' + this.bulk_campaign_id).then(function (response) {
	                    var bulkCampaign = response.data.data;
	                    _this3.data.name = bulkCampaign.name;
	                    _this3.data.recipients_group = bulkCampaign.recipients;
	                    if (bulkCampaign.status == 1) {
	                        _this3.published = true;
	                    }
	
	                    var recipientData = bulkCampaign.recipients;
	                    var keys = {};
	                    if (recipientData) {
	                        keys = (0, _keys2.default)(recipientData);
	                    }
	                    for (var j = 0; j < keys.length; j++) {
	                        var tempRecipient = recipientData[keys[j]];
	                        var length = recipientData[keys[j]].length;
	
	                        if (keys[j] == 'sheet') {
	                            for (var i = tempRecipient.length - 1; i >= 0; i--) {
	                                if (tempRecipient[i] == 99999) {
	                                    _this3.selectedRecipient.push("All Sheets");
	                                }
	                            }
	
	                            for (var k = 0; k < length; k++) {
	                                var data = _this3.recipientData.sheets;
	                                for (var i = 0; i < data.length; i++) {
	                                    if (data[i].id == tempRecipient[k]) {
	                                        _this3.selectedRecipient.push(data[i].id + '|' + keys[j]);
	                                        break;
	                                    }
	                                }
	                            }
	                        } else {
	                            for (var _k2 = 0; _k2 < length; _k2++) {
	                                _this3.selectedRecipient.push(tempRecipient[_k2] + '|' + keys[j]);
	                            }
	                        }
	                    }
	                });
	            }
	        },
	        addBulkCampaign: function addBulkCampaign() {
	            var _this4 = this;
	
	            if (this.data.name.match("^[+=@-].*")) {
	                this.publishError = 'Name of your schedule is not valid';
	                return false;
	            }
	            var allflag = 0;
	
	            for (var l = 0; l < this.selectedRecipient.length; l++) {
	                if (this.selectedRecipient[l] == "All Sheets") {
	                    allflag = 1;break;
	                }
	            }
	            if (allflag == 0) {
	
	                var blankObj = {};
	
	                for (var i = 0; i < this.selectedRecipient.length; i++) {
	                    var locVar = this.selectedRecipient[i].split("|");
	                    var key = locVar[1];
	                    if (blankObj[key]) {
	                        blankObj[key].push(locVar[0]);
	                    } else {
	                        var array = [];
	                        array.push(locVar[0]);
	                        blankObj[key] = array;
	                    }
	                }
	                this.data.recipients_group = blankObj;
	            } else {
	                this.data.recipients_group = {};
	                this.data.recipients_group.sheet = [];
	                this.data.recipients_group.sheet.push(99999);
	            }
	
	            if (this.selectedRecipient == '' || this.selectedRecipient.length == 0) {
	                this.isRecipientSelected = true;
	                this.publishError = 'Please select recipients.';
	                return;
	            }
	
	            var postData = {
	                name: this.data.name,
	                recipients: this.data.recipients_group
	            };
	
	            this.publishErrorName = "";
	            if (this.data.name == "") {
	                this.publishErrorName = 'Please enter bulk campaign name';
	                return;
	            }
	            if (this.action == 'add') {
	
	                this.$http.post('bulk/campaign', postData).then(function (response) {
	                    _this4.$router.push({ path: '/bulk/campains/schedule/' + response.data.data.id });
	                    var options = {
	                        'message': "Your campaigns have been scheduled successfully.",
	                        'timeout': 5000,
	                        'position': 'top',
	                        'style': 'bar',
	                        'type': 'success'
	                    };
	                    $('body').pgNotification(options).show();
	                    $('#addCampaignModal').modal('hide');
	                });
	            } else {
	                this.publish_check = 0;
	
	                if (this.data.name.match("^[+=@-].*")) {
	                    this.publishError = 'Name of your schedule is not valid';
	                    return false;
	                }
	                if (this.$parent.campaigns.length == 0) {
	                    this.publish_check = 1;
	                    return false;
	                }
	                this.publishError = '';
	                var publishData = {
	                    id: this.bulk_campaign_id,
	                    auto_training_data: this.auto_training_checks,
	                    name: this.data.name,
	                    recipients: this.data.recipients_group
	                };
	                this.$http.post('/bulk/campaign/publish', publishData).then(function (response) {
	                    if (response.data) {
	                        _this4.publishError = response.data;
	                    } else {
	                        _this4.published = true;
	
	                        var options = {
	                            'message': "Your campaigns have been scheduled successfully.",
	                            'timeout': 5000,
	                            'position': 'top',
	                            'style': 'bar',
	                            'type': 'success'
	                        };
	                        $('body').pgNotification(options).show();
	                        _this4.$router.push({ path: '/campaigns' });
	                    }
	                });
	            }
	        },
	        clearErrorFlashContent: function clearErrorFlashContent() {
	            this.publishError = false;
	        }
	    }
	};

/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(6);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			var _this = this,
			    _ref;
	
			return _ref = {
				scenario: {},
				campaignAction: '',
				ActionsValue: '',
				actionArry: [],
				restraninActionArry: [],
				retestActionArry: [],
				start_at: '',
				startDatePickerOptions: {
					disabledDate: function disabledDate(date) {
	
						return _this.moment(date).isBefore(new Date(), 'day');
					}
				},
				bulk_campaign_id: this.$route.params.id,
				sendAfter: '',
				sendAfterType: ''
			}, (0, _defineProperty3.default)(_ref, 'campaignAction', ''), (0, _defineProperty3.default)(_ref, 'sendAfterError', ''), (0, _defineProperty3.default)(_ref, 'campaignActionError', ''), (0, _defineProperty3.default)(_ref, 'dateerrormessage', false), (0, _defineProperty3.default)(_ref, 'dateconflicterrormessage', false), (0, _defineProperty3.default)(_ref, 'showEditPopUp', false), (0, _defineProperty3.default)(_ref, 'days', 5), (0, _defineProperty3.default)(_ref, 'start_date', ''), (0, _defineProperty3.default)(_ref, 'previewCampaign', []), _ref;
		},
	
		props: ['campaign', 'index', 'scenarioId', 'initialStartDate', 'mainCampaignId'],
		watch: {
			initialStartDate: function initialStartDate() {
				this.changeStartEndDate();
			}
		},
		beforeMount: function beforeMount() {
			var _this2 = this;
	
			this.start_at = this.campaign.send_at;
	
			if (this.campaign.end_days) {
				this.days = this.campaign.end_days;
			}
	
			this.start_date = this.initialStartDate;
	
			var actionArry = [{
				label: 'All',
				value: '5'
			}, {
				label: 'Didn\'t Open',
				value: '1'
			}, {
				label: 'Didn\'t Click',
				value: '2'
			}, {
				label: 'Got Lured',
				value: '3'
			}, {
				label: 'Education Not Taken',
				value: '4'
			}];
	
			this.retestActionArry = actionArry;
			this.actionArry = actionArry;
			this.restrainActionArry = actionArry;
	
			if (this.campaign.action && this.campaign.action != "") {
				this.ActionsValue = [];
				_.map(actionArry, function (t) {
					if (_this2.campaign.action.indexOf(t.value) != -1) {
						_this2.ActionsValue.push(t.label);
					}
				});
				this.ActionsValue = this.ActionsValue.join(', ');
			}
	
			if (this.campaign.parent_id) {
				this.sendAfter = this.campaign.send_after;
				this.sendAfterType = this.campaign.send_after_type;
				this.campaignAction = [];
				_.map(actionArry, function (t) {
					if (_this2.campaign.action.indexOf(t.value) != -1) {
						_this2.campaignAction.push(t.value);
					}
				});
				this.changeStartEndDate();
			}
	
			this.$parent.$on('changesOnMainCampaign', function () {
				if (this) {
					this.changeStartEndDate();
				}
			}.bind(this));
	
			if (this.campaign.id == this.$parent.lastInsertedId) {
				setTimeout(function () {
					this.changeScenario(this.campaign.id, this.campaign.book.id);
				}.bind(this), 1000);
				this.$parent.lastInsertedId = 0;
			}
	
			var campaignsDetails = JSON.parse((0, _stringify2.default)(this.$parent.campaigns));
			_.map(campaignsDetails, function (t) {
				if (t.childCampaign) {
					if (t.childCampaign.id == _this2.campaign.id) {
	
						if (t.scenario.type === 'announcement') {
							_this2.actionArry = [{
								label: 'All',
								value: '5'
							}];
						}
					} else if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.id == _this2.campaign.id) {
	
						if (t.childCampaign.scenario.type === 'announcement') {
							_this2.actionArry = [{
								label: 'All',
								value: '5'
							}];
						}
					}
				}
			});
		},
	
		methods: {
			editCampaign: function editCampaign(id) {
				var _this3 = this;
	
				$('#editCampaign').modal('show');
				this.$http.get('/bulk/campaign/schedule/' + id).then(function (response) {
					_this3.$parent.scenario = response.data.data;
				});
			},
			campaign_preview: function campaign_preview(campaign_id) {
				this.routeHeader = this.$parent.routeHeader;
				this.routePath = this.$parent.routePath;
	
				this.$router.push({ path: '/bulk_campaign/preview/' + campaign_id });
			},
			campaign_preview_edit: function campaign_preview_edit(campaign_id) {
				this.routeHeader = this.$parent.routeHeader;
				this.routePath = this.$parent.routePath;
	
				this.$router.push({ path: '/bulk_campaign/preview/edit/' + campaign_id });
			},
			changeStartEndDate: function changeStartEndDate() {
				this.start_date = this.initialStartDate;
				if (this.mainCampaignId) {
					var campaigns = this.$parent.campaigns;
					_.map(campaigns, function (val) {
						if (val.id == this.mainCampaignId) {
							this.start_date = this.moment(this.start_date).add(val.end_days, 'days');
	
							if (val.childCampaign.send_after_type == 1) {
								this.start_date = this.moment(this.start_date).add(val.childCampaign.send_after, 'days');
							} else {
								this.start_date = this.moment(this.start_date).add(val.childCampaign.send_after, 'hours');
							}
							if (this.campaign.id !== val.childCampaign.id) {
								this.start_date = this.moment(this.start_date).add(val.childCampaign.end_days, 'days');
	
								if (val.childCampaign.childCampaign.send_after_type == 1) {
									this.start_date = this.moment(this.start_date).add(val.childCampaign.childCampaign.send_after, 'days');
								} else {
									this.start_date = this.moment(this.start_date).add(val.childCampaign.childCampaign.send_after, 'hours');
								}
							}
						}
					}.bind(this));
				}
			},
			changeScenario: function changeScenario(id, education_id) {
				var _this4 = this;
	
				this.$parent.campaign_id = id;
				this.$parent.isEdit = true;
				this.$parent.campaignIndex = this.index;
				this.$parent.isChangeCampapaignScenario = true;
	
				if (this.scenarioId) {
					var _data = {
						education_id: [education_id],
						scenario_id: this.scenarioId,
						no_paginate: true
					};
					this.$parent.retest = true;
	
					this.$parent.isAnnouncement = false;
					if (this.campaign.action.indexOf('5') != -1) {
						this.$parent.isAnnouncement = true;
					}
	
					var _data = {
						'types': this.$parent.checkedType,
						'methods': this.$parent.checkedMethod,
						'levels': this.$parent.checkedLevel,
						'tags': this.$parent.checkedTag
					};
	
					this.$http.post('/library/scenarios/bulkcampaign', _data).then(function (response) {
						$('#myScenarioModal').modal('show');
						_this4.$parent.filteredScenarios = response.data.data;
						_this4.$emit('changesinScenario', _this4.$parent.filteredScenarios);
					});
				} else {
					$('#myModal').modal('show');
					this.$parent.getScenarioDetail(this.type, id);
				}
			},
			changeDate: function changeDate(id) {
				var _this5 = this;
	
				if (this.start_at == "") {
					this.dateerrormessage = true;
					return false;
				}
				this.date = this.moment().diff(this.start_at, 'hours');
	
				if (this.date > -1) {
					this.dateerrormessage = true;
					return false;
				}
				this.dateerrormessage = false;
				this.dateconflicterrormessage = false;
				_.map(this.$parent.campaigns, function (t) {
					if (t.id != id) {
						var beforeTime = _this5.moment(t.send_at);
						var add_days = parseInt(t.end_days);
						var add_hours = 0;
						if (t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
							if (t.childCampaign.send_after_type == 1) {
								add_days += parseInt(t.childCampaign.send_after);
							} else {
								add_hours += parseInt(t.childCampaign.send_after);
							}
							add_days += parseInt(t.childCampaign.end_days);
	
							if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type) {
								if (t.childCampaign.childCampaign.send_after_type == 1) {
									add_days += parseInt(t.childCampaign.childCampaign.send_after);
								} else {
									add_hours += parseInt(t.childCampaign.childCampaign.send_after);
								}
								add_days += parseInt(t.childCampaign.childCampaign.end_days);
							}
						}
	
						var afterTime = _this5.moment(t.send_at).add(add_days, 'day').add(add_hours, 'hours');
						if (_this5.moment(_this5.start_at).isBetween(beforeTime, afterTime)) {
							_this5.dateconflicterrormessage = true;
							return false;
						}
					}
				});
	
				if (this.dateconflicterrormessage == true) {
					return;
				}
	
				var campaignsDetails = _.clone(this.$parent.campaigns);
				var send_at = void 0;
				var campaign_id = void 0;
				this.dateconflicterrormessage = false;
				var oldCampaign = void 0;
				_.map(campaignsDetails, function (t) {
					if (t.id == id) {
						oldCampaign = _.clone(t);
						t.send_at = _this5.start_at;
						campaign_id = t.id;
						send_at = t.send_at;
					}
				});
	
				var send_at_end;
				var send_at_start;
				_.map(campaignsDetails, function (t) {
					if (t.id == campaign_id) {
						var add_days = parseInt(t.end_days);
						var add_hours = 0;
						if (t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
	
							if (t.childCampaign.send_after_type == 1) {
								add_days += parseInt(t.childCampaign.send_after);
							} else {
								add_hours += parseInt(t.childCampaign.send_after);
							}
							add_days += parseInt(t.childCampaign.end_days);
	
							if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type) {
								if (t.childCampaign.childCampaign.send_after_type == 1) {
									add_days += parseInt(t.childCampaign.childCampaign.send_after);
								} else {
									add_hours += parseInt(t.childCampaign.childCampaign.send_after);
								}
								add_days += parseInt(t.childCampaign.childCampaign.end_days);
							}
						}
						send_at_start = _this5.moment(t.send_at).format('Y-MM-DD HH:mm:ss');
						send_at_end = _this5.moment(t.send_at).add(add_days, 'day').add(add_hours, 'hours').format('Y-MM-DD HH:mm:ss');
					}
				});
	
				_.map(campaignsDetails, function (t) {
					if (t.id != campaign_id) {
						var beforeTime = _this5.moment(t.send_at);
						var add_days = parseInt(t.end_days);
						var add_hours = 0;
						if (t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
							if (t.childCampaign.send_after_type == 1) {
								add_days += parseInt(t.childCampaign.send_after);
							} else {
								add_hours += parseInt(t.childCampaign.send_after);
							}
							add_days += parseInt(t.childCampaign.end_days);
	
							if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type) {
								if (t.childCampaign.childCampaign.send_after_type == 1) {
									add_days += parseInt(t.childCampaign.childCampaign.send_after);
								} else {
									add_hours += parseInt(t.childCampaign.childCampaign.send_after);
								}
								add_days += parseInt(t.childCampaign.childCampaign.end_days);
							}
						}
	
						var afterTime = _this5.moment(t.send_at).add(add_days, 'day').add(add_hours, 'hours');
	
						if (_this5.moment(send_at_end).isBetween(beforeTime, afterTime) || _this5.moment(send_at_start).isBetween(beforeTime, afterTime) || _this5.moment(beforeTime).isBetween(send_at_start, send_at_end)) {
							_this5.dateconflicterrormessage = true;
							return;
						}
					}
				});
	
				if (this.dateconflicterrormessage == true) {
					return;
				}
	
				var data = {
					start_at: this.moment(this.start_at).format("YYYY-MM-DD HH:mm:ss")
				};
	
				this.$http.post('bulk/campaign/schedule/update/date/' + id, data).then(function (response) {
					_this5.$parent.filteredScenarios = response.data.data;
					_this5.$parent.$emit('showUpdateSuccessFullMesssage');
				});
	
				var dateAndID = {
					start_at: this.moment(this.start_at).format("YYYY-MM-DD HH:mm:ss"),
					id: id
				};
				this.$parent.$emit('changeDateFromChild', dateAndID);
			},
			changeday: function changeday(id) {
				var _this6 = this;
	
				var campaignsDetails = _.clone(this.$parent.campaigns);
				var send_at = void 0;
				var campaign_id = void 0;
				this.dateconflicterrormessage = false;
				var oldCampaign = void 0;
				_.map(campaignsDetails, function (t) {
					if (t.id == id) {
						oldCampaign = _.clone(t);
						t.end_days = _this6.days;
						campaign_id = t.id;
						send_at = t.send_at;
					}
					if (t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
						if (t.childCampaign.id == id) {
							oldCampaign = _.clone(t.childCampaign);
							t.childCampaign.end_days = _this6.days;
							campaign_id = t.id;
							send_at = t.send_at;
						}
						if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type) {
							if (t.childCampaign.childCampaign.id == id) {
								oldCampaign = _.clone(t.childCampaign.childCampaign);
								t.childCampaign.childCampaign.end_days = _this6.days;
								campaign_id = t.id;
								send_at = t.send_at;
							}
						}
					}
				});
	
				var send_at_end;
				_.map(campaignsDetails, function (t) {
					if (t.id == campaign_id) {
						var add_days = parseInt(t.end_days);
						var add_hours = 0;
						if (t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
	
							if (t.childCampaign.send_after_type == 1) {
								add_days += parseInt(t.childCampaign.send_after);
							} else {
								add_hours += parseInt(t.childCampaign.send_after);
							}
							add_days += parseInt(t.childCampaign.end_days);
	
							if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type) {
								if (t.childCampaign.childCampaign.send_after_type == 1) {
									add_days += parseInt(t.childCampaign.childCampaign.send_after);
								} else {
									add_hours += parseInt(t.childCampaign.childCampaign.send_after);
								}
								add_days += parseInt(t.childCampaign.childCampaign.end_days);
							}
						}
						send_at_end = _this6.moment(t.send_at).add(add_days, 'day').add(add_hours, 'hours').format('Y-MM-DD HH:mm:ss');
					}
				});
	
				_.map(campaignsDetails, function (t) {
					if (t.id != campaign_id) {
						var beforeTime = _this6.moment(t.send_at);
						var add_days = parseInt(t.end_days);
						var add_hours = 0;
						if (t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
							if (t.childCampaign.send_after_type == 1) {
								add_days += parseInt(t.childCampaign.send_after);
							} else {
								add_hours += parseInt(t.childCampaign.send_after);
							}
							add_days += parseInt(t.childCampaign.end_days);
	
							if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type) {
								if (t.childCampaign.childCampaign.send_after_type == 1) {
									add_days += parseInt(t.childCampaign.childCampaign.send_after);
								} else {
									add_hours += parseInt(t.childCampaign.childCampaign.send_after);
								}
								add_days += parseInt(t.childCampaign.childCampaign.end_days);
							}
						}
	
						var afterTime = _this6.moment(t.send_at).add(add_days, 'day').add(add_hours, 'hours');
						if (_this6.moment(send_at_end).isBetween(beforeTime, afterTime)) {
							_this6.dateconflicterrormessage = true;
							return;
						}
					}
				});
	
				if (this.dateconflicterrormessage == true) {
					setTimeout(function () {
						_this6.days = oldCampaign.end_days;
						_this6.dateconflicterrormessage = false;
					}, 3000);
					return;
				}
	
				var data = {
					days: this.days,
					id: id
				};
	
				this.$http.post('bulk/campaign/changeday', data).then(function (response) {
					var dateAndID = {
						days: _this6.days,
						id: id
					};
					_this6.$parent.$emit('showUpdateSuccessFullMesssage');
					_this6.$parent.$emit('changeDaysFromChild', dateAndID);
				});
			},
			updateCampaignSchedule: function updateCampaignSchedule(id) {
				var _this7 = this;
	
				this.sendAfterError = "";
				this.campaignActionError = "";
	
				if (!this.sendAfter || this.sendAfter < 1) {
					this.sendAfterError = "Please enter valid value in send after.";
				}
				if (this.campaignAction == "") {
					this.campaignActionError = "Please select atleast 1 action.";
				}
	
				if (this.campaignActionError == "" && this.sendAfterError == "") {
					var campaignsDetails = _.clone(this.$parent.campaigns);
					var send_at = void 0;
					var campaign_id = void 0;
					this.dateconflicterrormessage = false;
					var oldCampaign = void 0;
					_.map(campaignsDetails, function (t) {
						if (t.id == id) {
							oldCampaign = _.clone(t);
							t.send_after = _this7.sendAfter;
							t.send_after_type = _this7.sendAfterType;
							campaign_id = t.id;
							send_at = t.send_at;
						}
						if (t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
							if (t.childCampaign.id == id) {
								oldCampaign = _.clone(t.childCampaign);
								t.childCampaign.send_after = _this7.sendAfter;
								t.childCampaign.send_after_type = _this7.sendAfterType;
								campaign_id = t.id;
								send_at = t.send_at;
							}
							if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type) {
								if (t.childCampaign.childCampaign.id == id) {
									oldCampaign = _.clone(t.childCampaign.childCampaign);
									t.childCampaign.childCampaign.send_after = _this7.sendAfter;
									t.childCampaign.childCampaign.send_after_type = _this7.sendAfterType;
									campaign_id = t.id;
									send_at = t.send_at;
								}
							}
						}
					});
	
					var send_at_end;
					var send_at_start;
					_.map(campaignsDetails, function (t) {
						if (t.id == campaign_id) {
							var add_days = parseInt(t.end_days);
							var add_hours = 0;
							if (t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
	
								if (t.childCampaign.send_after_type == 1) {
									add_days += parseInt(t.childCampaign.send_after);
								} else {
									add_hours += parseInt(t.childCampaign.send_after);
								}
								add_days += parseInt(t.childCampaign.end_days);
	
								if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type) {
									if (t.childCampaign.childCampaign.send_after_type == 1) {
										add_days += parseInt(t.childCampaign.childCampaign.send_after);
									} else {
										add_hours += parseInt(t.childCampaign.childCampaign.send_after);
									}
									add_days += parseInt(t.childCampaign.childCampaign.end_days);
								}
							}
							send_at_start = _this7.moment(t.send_at).format('Y-MM-DD HH:mm:ss');
							send_at_end = _this7.moment(t.send_at).add(add_days, 'day').add(add_hours, 'hours').format('Y-MM-DD HH:mm:ss');
						}
					});
	
					_.map(campaignsDetails, function (t) {
						if (t.id != campaign_id) {
							var beforeTime = _this7.moment(t.send_at);
							var add_days = parseInt(t.end_days);
							var add_hours = 0;
							if (t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
								if (t.childCampaign.send_after_type == 1) {
									add_days += parseInt(t.childCampaign.send_after);
								} else {
									add_hours += parseInt(t.childCampaign.send_after);
								}
								add_days += parseInt(t.childCampaign.end_days);
	
								if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type) {
									if (t.childCampaign.childCampaign.send_after_type == 1) {
										add_days += parseInt(t.childCampaign.childCampaign.send_after);
									} else {
										add_hours += parseInt(t.childCampaign.childCampaign.send_after);
									}
									add_days += parseInt(t.childCampaign.childCampaign.end_days);
								}
							}
	
							var afterTime = _this7.moment(t.send_at).add(add_days, 'day').add(add_hours, 'hours');
							if (_this7.moment(send_at_end).isBetween(beforeTime, afterTime) || _this7.moment(send_at_start).isBetween(beforeTime, afterTime) || _this7.moment(beforeTime).isBetween(send_at_start, send_at_end)) {
								_this7.dateconflicterrormessage = true;
								return;
							}
						}
					});
	
					if (this.dateconflicterrormessage == true) {
						setTimeout(function () {
							_this7.sendAfter = oldCampaign.send_after;
							_this7.sendAfterType = oldCampaign.send_after_type;
							_this7.dateconflicterrormessage = false;
						}, 3000);
						return;
					}
	
					var data = {
						send_after: this.sendAfter,
						send_after_type: this.sendAfterType,
						action: this.campaignAction,
						id: id
					};
					this.$http.post('/bulk/campaign/schedulecampaign/bulkedit', data).then(function (response) {
						$('#update_campaign_schedule_' + id).modal('hide');
						_this7.campaign.send_after = response.data.data.send_after;
						_this7.campaign.send_after_type = response.data.data.send_after_type;
						var campaign = response.data.data;
						_this7.$parent.$emit('showUpdateSuccessFullMesssage');
						if (campaign.action && campaign.action != "") {
							_this7.ActionsValue = [];
							_.map(_this7.actionArry, function (t) {
								if (campaign.action.indexOf(t.value) != -1) {
									_this7.ActionsValue.push(t.label);
								}
							});
							_this7.ActionsValue = _this7.ActionsValue.join(', ');
						}
	
						if (_this7.campaignAction.indexOf('5') != -1) {}
					});
					this.$parent.$emit('changeNextDaysFromChild', data);
				}
			},
			editScheduledCampaign: function editScheduledCampaign(id) {
				var _this8 = this;
	
				this.$http.get('/bulk/campaign/' + id + '/schedulenew').then(function (response) {
					_this8.previewCampaign = response.data.data[0];
					console.log(_this8.previewCampaign);
					_this8.showEditPopUp = true;
					_this8.$parent.$emit('showUpdateSuccessFullMesssage');
					setTimeout(function () {
						$('#editCampaign_' + id).modal('show');
					}, 10);
				});
			}
		}
	};

/***/ }),

/***/ 795:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            froala_config: {
	                'fullPage': true,
	                'iframe': true,
	                'height': 300,
	                'toolbarButtons': ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'spellChecker', 'help', 'html', '|', 'undo', 'redo', 'tags_selector']
	            },
	            liveCampaigns: [],
	            domain_name: '',
	            domains: [],
	            domainsList: [],
	            recp: false,
	            data: {},
	            campaignData: {}
	        };
	    },
	
	    props: ['campaign', 'id', 'scenario'],
	
	    watch: {},
	    beforeMount: function beforeMount() {
	        var _this = this;
	
	        this.$http.get('/companies/domains').then(function (response) {
	            _this.domainsList = response.data.data;
	            var domains = _this.domainsList.map(function (domain) {
	                var obj = {
	                    label: domain.name,
	                    value: domain.id
	                };
	                return obj;
	            });
	            _this.domains = domains;
	        });
	
	        this.data.emailTemplate = this.scenario.email_template;
	        this.data.landingTemplate = this.scenario.landing_template;
	        this.data.educationTemplate = this.scenario.scenario.education;
	
	        this.campaignData = this.scenario;
	    },
	    mounted: function mounted() {},
	
	    methods: {
	        editCampaignSchedule: function editCampaignSchedule() {
	            var _this2 = this;
	
	            this.$validator.validateAll().then(function (success) {
	                if (success) {
	                    var data = {
	                        send_after: _this2.campaignData.sendAfter,
	                        send_after_type: _this2.campaignData.sendAfterType,
	                        id: _this2.campaignData.id,
	                        from_name: _this2.campaignData.from_name,
	                        from_sender: _this2.campaignData.from_sender,
	                        from_domain_id: _this2.campaignData.from_domain_id,
	                        from_domain_type: _this2.campaignData.from_domain_type,
	                        landing_sub_domain: _this2.campaignData.landing_sub_domain,
	                        landing_domain_id: _this2.campaignData.landing_domain_id,
	                        landing_sub_path: _this2.campaignData.landing_sub_path,
	                        subject: _this2.campaignData.subject,
	                        send_at: _this2.campaignData.send_at
	                    };
	                    _this2.$http.post('/bulk/campaign/schedulecampaign/edit', data).then(function (response) {
	                        $('#editCampaign_' + _this2.campaignData.id).modal('hide');
	                    });
	
	                    var ELTdata = {
	                        id: _this2.campaignData.id,
	                        email_template: _this2.data.emailTemplate.file,
	                        landing_template: _this2.data.landingTemplate.file
	                    };
	                    _this2.$http.post('/bulk/campaign/schedule/' + _this2.campaignData.id, ELTdata).then(function (response) {
	                        $('#editCampaign_' + _this2.campaignData.id).modal('hide');
	                        _this2.$parent.$emit('showUpdateSuccessFullMesssage');
	                    });
	                }
	            });
	        },
	
	        click_recp: function click_recp() {
	            this.recp = this.recp ? 0 : 1;
	        },
	        place_holder: function place_holder(val) {
	            if (this.data.subject.substr(-1) == " ") {
	                this.data.subject += val + " ";
	            } else {
	                this.data.subject += " " + val + " ";
	            }
	        }
	
	    }
	};

/***/ }),

/***/ 796:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            liveCampaigns: [],
	            baseUrl: baseUrl
	        };
	    },
	
	    props: ['education'],
	    beforeMount: function beforeMount() {},
	
	    methods: {
	        getScenarioByEducation: function getScenarioByEducation(id) {
	            var _this = this;
	
	            $('#myModal').modal('hide');
	
	            var data = {
	                education_id: [id]
	            };
	
	            this.$http.post('/library/scenarios', data).then(function (response) {
	                _this.$parent.filteredScenarios = response.data.data;
	                $('#myScenarioModal').modal('show');
	            });
	        }
	    }
	};

/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(6);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            sendAfter: '',
	            sendAfterType: 1,
	            campaignAction: [],
	            sendAfterError: '',
	            campaignActionError: '',
	            dateconflicterrormessage: false,
	            actionArry: [{
	                label: 'All',
	                value: 5
	            }, {
	                label: 'Didn\'t Open',
	                value: 1
	            }, {
	                label: 'Didn\'t Click',
	                value: 2
	            }, {
	                label: 'Got Lured',
	                value: 3
	            }, {
	                label: 'Education Not Taken',
	                value: 4
	            }]
	        };
	    },
	
	    props: ['campaign', 'index'],
	    beforeMount: function beforeMount() {
	        var _this = this;
	
	        var campaignsDetails = JSON.parse((0, _stringify2.default)(this.$parent.campaigns));
	        _.map(campaignsDetails, function (t) {
	            if (t.childCampaign) {
	                if (t.childCampaign.id == _this.campaign.id) {
	
	                    if (t.scenario.type === 'announcement') {
	                        _this.actionArry = [{
	                            label: 'All',
	                            value: 5
	                        }];
	                    }
	                } else if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.id == _this.campaign.id) {
	
	                    if (t.childCampaign.scenario.type === 'announcement') {
	                        _this.actionArry = [{
	                            label: 'All',
	                            value: 5
	                        }];
	                    }
	                }
	            }
	        });
	    },
	
	    methods: {
	        updateCampaignSchedule: function updateCampaignSchedule(id, index) {
	            var _this2 = this;
	
	            this.sendAfterError = "";
	            this.campaignActionError = "";
	
	            if (!this.sendAfter || this.sendAfter < 1) {
	                this.sendAfterError = "Please enter valid value in send after.";
	            }
	            if (this.campaignAction == "") {
	                this.campaignActionError = "Please select atleast 1 action.";
	            }
	            if (this.campaignActionError == "" && this.sendAfterError == "") {
	                var campaignsDetails = JSON.parse((0, _stringify2.default)(this.$parent.campaigns));
	                var send_at = void 0;
	                var campaign_id = void 0;
	                this.dateconflicterrormessage = false;
	                _.map(campaignsDetails, function (t) {
	                    if (t.childCampaign) {
	                        if (t.childCampaign.id == id) {
	                            t.childCampaign.send_after = _this2.sendAfter;
	                            t.childCampaign.send_after_type = _this2.sendAfterType;
	
	                            campaign_id = t.id;
	                            send_at = t.send_at;
	                        } else if (t.childCampaign.childCampaign) {
	                            if (t.childCampaign.childCampaign.id == id) {
	                                t.childCampaign.childCampaign.send_after = _this2.sendAfter;
	                                t.childCampaign.childCampaign.send_after_type = _this2.sendAfterType;
	                                campaign_id = t.id;
	                                send_at = t.send_at;
	                            }
	                        }
	                    }
	                });
	
	                var send_at_end;
	                _.map(campaignsDetails, function (t) {
	                    if (t.id == campaign_id) {
	                        var add_days = parseInt(t.end_days);
	                        var add_hours = 0;
	                        if (t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
	
	                            if (t.childCampaign.send_after_type == 1) {
	                                add_days += parseInt(t.childCampaign.send_after);
	                            } else {
	                                add_hours += parseInt(t.childCampaign.send_after);
	                            }
	                            add_days += parseInt(t.childCampaign.end_days);
	
	                            if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type) {
	                                if (t.childCampaign.childCampaign.send_after_type == 1) {
	                                    add_days += parseInt(t.childCampaign.childCampaign.send_after);
	                                } else {
	                                    add_hours += parseInt(t.childCampaign.childCampaign.send_after);
	                                }
	                                add_days += parseInt(t.childCampaign.childCampaign.end_days);
	                            }
	                        }
	                        send_at_end = _this2.moment(t.send_at).add(add_days, 'day').add(add_hours, 'hours').format('Y-MM-DD HH:mm:ss');
	                    }
	                });
	
	                _.map(campaignsDetails, function (t) {
	                    if (t.id != campaign_id) {
	                        var beforeTime = _this2.moment(t.send_at);
	                        var add_days = parseInt(t.end_days);
	                        var add_hours = 0;
	                        if (t.childCampaign && t.childCampaign.send_after && t.childCampaign.send_after_type) {
	                            if (t.childCampaign.send_after_type == 1) {
	                                add_days += parseInt(t.childCampaign.send_after);
	                            } else {
	                                add_hours += parseInt(t.childCampaign.send_after);
	                            }
	                            add_days += parseInt(t.childCampaign.end_days);
	
	                            if (t.childCampaign.childCampaign && t.childCampaign.childCampaign.send_after && t.childCampaign.childCampaign.send_after_type) {
	                                if (t.childCampaign.childCampaign.send_after_type == 1) {
	                                    add_days += parseInt(t.childCampaign.childCampaign.send_after);
	                                } else {
	                                    add_hours += parseInt(t.childCampaign.childCampaign.send_after);
	                                }
	                                add_days += parseInt(t.childCampaign.childCampaign.end_days);
	                            }
	                        }
	
	                        var afterTime = _this2.moment(t.send_at).add(add_days, 'day').add(add_hours, 'hours');
	                        if (_this2.moment(send_at_end).isBetween(beforeTime, afterTime)) {
	                            _this2.dateconflicterrormessage = true;
	                            return;
	                        }
	                    }
	                });
	
	                if (this.dateconflicterrormessage == true) {
	                    return false;
	                } else {
	                    var data = {
	                        send_after: this.sendAfter,
	                        send_after_type: this.sendAfterType,
	                        action: this.campaignAction,
	                        id: id
	                    };
	                    this.$http.post('/bulk/campaign/schedulecampaign/bulkedit', data).then(function (response) {
	                        $('#campaign_schedule_' + index).modal('hide');
	                        _this2.$parent.$emit('showUpdateSuccessFullMesssage');
	                        _this2.$parent.getCampaignById(id);
	                    });
	                }
	            }
	        }
	    }
	};

/***/ }),

/***/ 799:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            bulk_campaign_id: this.$route.params.id,
	            baseUrl: baseUrl,
	            preview_scenario: '',
	            filter: {
	                showCheck: false
	            }
	        };
	    },
	
	    props: ['scenario', 'isEdit', 'campaignIndex', 'isChangeScenario', 'campaign_id', 'retest', 'campaigns'],
	    beforeMount: function beforeMount() {
	        this.showCheckMessage();
	
	        this.$on('changesinScenario', function (value) {
	            this.showCheckMessage();
	        });
	    },
	
	    watch: {
	        campaigns: function campaigns(val) {
	            this.showCheckMessage();
	        },
	        scenario: function scenario(val) {
	            this.showCheckMessage();
	        }
	    },
	    ready: function ready() {},
	
	    methods: {
	        showCheckMessage: function showCheckMessage() {
	            var _this = this;
	
	            this.scenario.showCheck = false;
	            _.map(this.campaigns, function (maincamp) {
	                if (maincamp.scenario_id == _this.scenario.id) {
	                    _this.scenario.showCheck = true;
	                } else {
	                    if (maincamp.childCampaign.send_after && maincamp.childCampaign.send_after != '' && maincamp.childCampaign.scenario_id == _this.scenario.id) {
	                        _this.scenario.showCheck = true;
	                    } else if (maincamp.childCampaign.send_after && maincamp.childCampaign.send_after != '' && maincamp.childCampaign.childCampaign.send_after && maincamp.childCampaign.childCampaign.send_after != '' && maincamp.childCampaign.childCampaign.scenario_id == _this.scenario.id) {
	                        _this.scenario.showCheck = true;
	                    }
	                }
	            });
	        },
	        cloneCampaign: function cloneCampaign(id) {},
	        selectScenario: function selectScenario(id) {
	            var _this2 = this;
	
	            var data = {
	                scenario_id: id,
	                bulk_campaign_id: this.bulk_campaign_id,
	                send_at: this.moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
	            };
	
	            if (this.isChangeScenario && this.isEdit) {
	                data.id = this.campaign_id;
	            }
	
	            var url = '/bulk/campaign/schedule';
	            if (this.retest) {
	                data.id = this.campaign_id;
	                url = '/bulk/campaign/edit/schedule';
	            }
	            this.$http.post(url, data).then(function (response) {
	                $('#myModal').modal('hide');
	                $('#myScenarioModal').modal('hide');
	
	                _this2.$parent.getCampaignById();
	                _this2.$parent.$emit('showUpdateSuccessFullMesssage');
	            });
	        },
	        showPreview: function showPreview(id) {
	            var _this3 = this;
	
	            this.$http.get('/library/scenarios/' + id).then(function (response) {
	                _this3.preview_scenario = response.data.scenario;
	                if (_this3.preview_scenario.email_template.data) {
	                    _this3.preview_scenario.email_template.data = JSON.parse(_this3.preview_scenario.email_template.data);
	                }
	                if (_this3.preview_scenario.landing_page_template.data) {
	                    _this3.preview_scenario.landing_page_template.data = JSON.parse(_this3.preview_scenario.landing_page_template.data);
	                }
	                $('#preview_model_' + id).modal('show');
	            });
	        }
	    }
	};

/***/ }),

/***/ 800:
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(803);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var HRISandVSMS = function HRISandVSMS(r) {
	    return __webpack_require__.e/* nsure */(12, function () {
	        return r(__webpack_require__(1173));
	    });
	};
	var HRISandVSMSlogs = function HRISandVSMSlogs(r) {
	    return __webpack_require__.e/* nsure */(12, function () {
	        return r(__webpack_require__(1174));
	    });
	};
	var HRISandVSMsingleLogs = function HRISandVSMsingleLogs(r) {
	    return __webpack_require__.e/* nsure */(12, function () {
	        return r(__webpack_require__(1175));
	    });
	};
	
	exports.default = [{
	    name: 'HRISandVSMS',
	    path: '/setting/HRIS-VSMS',
	    component: HRISandVSMS
	}, {
	    name: 'HRISandVSMSlogs',
	    path: '/setting/HRIS-VSMS-logs',
	    component: HRISandVSMSlogs
	}, {
	    name: 'HRISandVSMsingleLogs',
	    path: '/setting/HRIS-VSMS-logs/:id',
	    component: HRISandVSMsingleLogs
	}];

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(805);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var adminLogs = function adminLogs(r) {
	  return __webpack_require__.e/* nsure */(17, function () {
	    return r(__webpack_require__(1176));
	  });
	};
	
	exports.default = [{
	  name: 'adminLogs',
	  path: '/admin-logs',
	  component: adminLogs,
	  meta: {
	    requiresAuth: true
	  }
	}];

/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(808);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var adn = function adn(r) {
	  return __webpack_require__.e/* nsure */(29, function () {
	    return r(__webpack_require__(1177));
	  });
	};

/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(810);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(813);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var addAgreement = function addAgreement(r) {
		return __webpack_require__.e/* nsure */(9, function () {
			return r(__webpack_require__(1178));
		});
	};
	var Details = function Details(r) {
		return __webpack_require__.e/* nsure */(9, function () {
			return r(__webpack_require__(1181));
		});
	};
	var adobeAuth = function adobeAuth(r) {
		return __webpack_require__.e/* nsure */(9, function () {
			return r(__webpack_require__(1179));
		});
	};
	var viewFiles = function viewFiles(r) {
		return __webpack_require__.e/* nsure */(9, function () {
			return r(__webpack_require__(1182));
		});
	};
	var agreementDetails = function agreementDetails(r) {
		return __webpack_require__.e/* nsure */(9, function () {
			return r(__webpack_require__(1180));
		});
	};
	exports.default = [{
		name: 'adobeAuth',
		path: '/adobe-auth',
		component: adobeAuth
	}, {
		name: 'addAgreement',
		path: '/add-agreement',
		component: addAgreement
	}, {
		name: 'Details',
		path: '/agreement-details',
		component: Details
	}, {
		name: 'viewFiles',
		path: '/view-agreements',
		component: viewFiles
	}, {
		name: 'agreement.details',
		path: '/agreement/:id/details',
		component: agreementDetails
	}];

/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setCheckedSettings = undefined;
	
	var _mutationTypes = __webpack_require__(266);
	
	var TYPES = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var setCheckedSettings = exports.setCheckedSettings = function setCheckedSettings(_ref, settings) {
	    var commit = _ref.commit;
	
	    commit(TYPES.CAMPAING_CHECKED_SETTINGS, settings);
	};

/***/ }),

/***/ 812:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getCheckedSettings = exports.getCheckedSettings = function getCheckedSettings(state) {
	  return state.checkedSettings;
	};
	var getCampaignSettings = exports.getCampaignSettings = function getCampaignSettings(state) {
	  return state.campaignSettings;
	};

/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(815);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(814);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(811);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(812);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = { state: _state2.default, mutations: _mutations2.default, actions: actions, getters: getters };
	
	exports.default = { module: _module };

/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(266);
	
	var TYPES = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _defineProperty3.default)({}, TYPES.CAMPAING_CHECKED_SETTINGS, function (state, checkedSettings) {
	    state.checkedSettings = checkedSettings;
	});

/***/ }),

/***/ 815:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    campaignSettings: ['not_opened', 'delivered', 'bounced'],
	    checkedSettings: []
	};

/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var Auth = {
	    login: function login(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(1187));
	        });
	    },
	
	    saml: function saml(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(241));
	        });
	    },
	    register: function register(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(1190));
	        });
	    },
	    verification: function verification(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(1194));
	        });
	    },
	    'learning': function learning(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(1185));
	        });
	    },
	    'learningdashboard': function learningdashboard(r) {
	        return __webpack_require__.e/* nsure */(19, function () {
	            return r(__webpack_require__(1222));
	        });
	    },
	    'learningreport': function learningreport(r) {
	        return __webpack_require__.e/* nsure */(18, function () {
	            return r(__webpack_require__(1223));
	        });
	    },
	    'registered': function registered(r) {
	        return __webpack_require__.e/* nsure */(25, function () {
	            return r(__webpack_require__(1191));
	        });
	    },
	    'logout': function logout(r) {
	        return __webpack_require__.e/* nsure */(26, function () {
	            return r(__webpack_require__(1188));
	        });
	    },
	    'userportalLogin': function userportalLogin(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(1193));
	        });
	    },
	    'bekaertUserportalLogin': function bekaertUserportalLogin(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(1183));
	        });
	    },
	    'lmsSso': function lmsSso(r) {
	        return __webpack_require__.e/* nsure */(6, function () {
	            return r(__webpack_require__(1186));
	        });
	    }
	};
	
	var ForgetPassword = function ForgetPassword(r) {
	    return __webpack_require__.e/* nsure */(27, function () {
	        return r(__webpack_require__(1184));
	    });
	};
	var PrivacyPolicy = function PrivacyPolicy(r) {
	    return __webpack_require__.e/* nsure */(28, function () {
	        return r(__webpack_require__(1189));
	    });
	};
	var termsAndConditions = function termsAndConditions(r) {
	    return __webpack_require__.e/* nsure */(24, function () {
	        return r(__webpack_require__(1192));
	    });
	};
	
	exports.default = [{
	    name: 'auth.login',
	    path: '/login',
	    component: Auth.login,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.register',
	    path: '/register',
	    component: Auth.register,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.saml',
	    path: '/saml',
	    component: Auth.saml,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.registered',
	    path: '/registered',
	    component: Auth.registered,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.learning',
	    path: '/learning/login/:id',
	    component: Auth.learning,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.learningdashboard',
	    path: '/learning/dashboard/:id',
	    component: Auth.learningdashboard,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.learningreport',
	    path: '/learning/reports/:id',
	    component: Auth.learningreport,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.verification',
	    path: '/verification',
	    component: Auth.verification,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.reset',
	    path: '/reset',
	    component: ForgetPassword,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.privacypolicy',
	    path: '/privacypolicy',
	    component: PrivacyPolicy,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.termsAndConditions',
	    path: '/TermsAndConditions',
	    component: termsAndConditions,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.licenceexpire',
	    path: '/licenceexpire',
	    component: Auth.licenceexpire,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.registered',
	    path: '/registered',
	    component: Auth.registered,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.logout',
	    path: '/logout',
	    component: Auth.logout
	}, {
	    name: 'auth.userportalLogin',
	    path: '/userportal/login',
	    component: Auth.userportalLogin,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.bekaertUserportalLogin',
	    path: '/bekaert/userportal/login',
	    component: Auth.bekaertUserportalLogin,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.lmsSso',
	    path: '/lms-sso',
	    component: Auth.lmsSso,
	    meta: { requiresAuth: false }
	}];

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadUser = exports.checkUserToken = exports.setToken = exports.setUser = exports.logout = exports.attemptVerification = exports.loginUser = exports.attemptRegister = exports.attemptLearningLogin = exports.attemptLogin = undefined;
	
	var _promise = __webpack_require__(68);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(6);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _localforage = __webpack_require__(236);
	
	var _localforage2 = _interopRequireDefault(_localforage);
	
	var _config = __webpack_require__(2);
	
	var _storedUser = __webpack_require__(190);
	
	var _lodash = __webpack_require__(9);
	
	var _mutationsTypes = __webpack_require__(177);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	var _services = __webpack_require__(89);
	
	var services = _interopRequireWildcard(_services);
	
	var _systemAlertBanner = __webpack_require__(191);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var attemptLogin = exports.attemptLogin = function attemptLogin(_ref, payload) {
	  var dispatch = _ref.dispatch;
	  return services.postLogin(payload).then(function (response) {
	    return response;
	  });
	};
	
	var attemptLearningLogin = exports.attemptLearningLogin = function attemptLearningLogin(_ref2, payload) {
	  var dispatch = _ref2.dispatch;
	  return services.postLearningLogin(payload).then(function (response) {
	    return response;
	  });
	};
	
	var attemptRegister = exports.attemptRegister = function attemptRegister(_ref3, payload) {
	  var dispatch = _ref3.dispatch;
	  return services.postRegister(payload).then(function (response) {
	    return response;
	  });
	};
	
	var loginUser = exports.loginUser = function loginUser(_ref4, response) {
	  var dispatch = _ref4.dispatch;
	
	  dispatch('setToken', response.data.token);
	  dispatch('setUser', response.data);
	  localStorage.setItem('user', (0, _stringify2.default)(response.data));
	};
	
	var attemptVerification = exports.attemptVerification = function attemptVerification(_ref5, payload) {
	  var dispatch = _ref5.dispatch;
	  return services.postVerification(payload).then(function (response) {
	    dispatch('setToken', null);
	    dispatch('setToken', response.data.token);
	    dispatch('setUser', response.data);
	    localStorage.setItem('user', (0, _stringify2.default)(response.data));
	    localStorage.setItem('quickStart', 1);
	
	    return response;
	  });
	};
	
	var logout = exports.logout = function logout(_ref6) {
	  var dispatch = _ref6.dispatch;
	
	  services.revokeToken();
	
	  var existingCookies = document.cookie.split(";");
	
	  for (var i = 0; i < existingCookies.length; i++) {
	    var cookiePair = existingCookies[i].trim();
	
	    var cookieName = cookiePair.split("=")[0];
	
	    if (cookieName.indexOf("df_") === 0) {
	      var hostname = window.location.hostname;
	      var mainDomain = hostname.split(".").slice(-2).join(".");
	      console.log(hostname);
	
	      document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
	      document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + mainDomain;
	      document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=." + mainDomain;
	    }
	  }
	
	  (0, _systemAlertBanner.resetBanner)();
	
	  return _promise2.default.all([dispatch("setToken", null), dispatch("setUser", {})]);
	};
	
	var setUser = exports.setUser = function setUser(_ref7, user) {
	  var commit = _ref7.commit;
	
	  commit(TYPES.SET_USER, user);
	
	  _promise2.default.resolve(user);
	};
	
	var setToken = exports.setToken = function setToken(_ref8, payload) {
	  var commit = _ref8.commit;
	
	  var token = (0, _lodash.isEmpty)(payload) ? null : payload.token || payload;
	
	  commit(TYPES.SET_TOKEN, token);
	
	  return _promise2.default.resolve(token);
	};
	
	var checkUserToken = exports.checkUserToken = function checkUserToken(_ref9) {
	  var dispatch = _ref9.dispatch,
	      state = _ref9.state;
	
	  if (!(0, _lodash.isEmpty)(state.token)) {
	    return _promise2.default.resolve(state.token);
	  }
	
	  return _localforage2.default.getItem(_config.userTokenStorageKey).then(function (token) {
	    if ((0, _lodash.isEmpty)(token)) {
	      return _promise2.default.reject('NO_TOKEN');
	    }
	
	    return dispatch('setToken', token);
	  }).then(function () {
	    return dispatch('loadUser');
	  });
	};
	
	var loadUser = exports.loadUser = function loadUser(_ref10) {
	  var dispatch = _ref10.dispatch;
	
	  var user = (0, _storedUser.readStoredUser)();
	  return _promise2.default.resolve(dispatch('setUser', user));
	};

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.currentUser = exports.isLogged = undefined;
	
	var _lodash = __webpack_require__(9);
	
	var isLogged = exports.isLogged = function isLogged(_ref) {
	  var token = _ref.token;
	  return !(0, _lodash.isEmpty)(token);
	};
	var currentUser = exports.currentUser = function currentUser(_ref2) {
	  var user = _ref2.user;
	  return user;
	};

/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(822);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(820);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _plugin = __webpack_require__(821);
	
	var _plugin2 = _interopRequireDefault(_plugin);
	
	var _actions = __webpack_require__(817);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(818);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = { state: _state2.default, mutations: _mutations2.default, actions: actions, getters: getters };
	
	exports.default = { module: _module, plugin: _plugin2.default };

/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TYPES$SET_TOKEN$TYPE;
	
	var _mutationsTypes = __webpack_require__(177);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_TYPES$SET_TOKEN$TYPE = {}, (0, _defineProperty3.default)(_TYPES$SET_TOKEN$TYPE, TYPES.SET_TOKEN, function (state, value) {
	  state.token = value;
	}), (0, _defineProperty3.default)(_TYPES$SET_TOKEN$TYPE, TYPES.SET_USER, function (state, value) {
	  state.user = value;
	}), _TYPES$SET_TOKEN$TYPE);

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _localforage = __webpack_require__(236);
	
	var _localforage2 = _interopRequireDefault(_localforage);
	
	var _config = __webpack_require__(2);
	
	var _http = __webpack_require__(4);
	
	var _mutationsTypes = __webpack_require__(177);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscribe = function subscribe(store) {
	  store.subscribe(function (mutation, _ref) {
	    var Auth = _ref.Auth;
	
	    if (TYPES.SET_TOKEN === mutation.type) {
	      (0, _http.setToken)(Auth.token);
	
	      _localforage2.default.setItem(_config.userTokenStorageKey, Auth.token);
	    }
	  });
	};
	
	exports.default = function (store) {
	  subscribe(store);
	};

/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(189);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  user: {},
	  token: null
	};

/***/ }),

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var campaigns = function campaigns(r) {
	    return __webpack_require__.e/* nsure */(4, function () {
	        return r(__webpack_require__(1198));
	    });
	};
	
	var previewScenario = function previewScenario(r) {
	    return __webpack_require__.e/* nsure */(20, function () {
	        return r(__webpack_require__(1199));
	    });
	};
	
	var bulk_campaign_preview = function bulk_campaign_preview(r) {
	    return __webpack_require__.e/* nsure */(4, function () {
	        return r(__webpack_require__(1195));
	    });
	};
	
	var bulk_campaign_preview_edit = function bulk_campaign_preview_edit(r) {
	    return __webpack_require__.e/* nsure */(4, function () {
	        return r(__webpack_require__(1196));
	    });
	};
	
	var manageCampaign = {
	
	    create: function create(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(1197));
	        });
	    }
	
	};
	
	exports.default = [{
	    name: 'bulk_campaigns',
	    path: '/bulk/campaigns',
	
	    component: campaigns
	
	}, {
	    name: 'bulk_campaigns.schedule',
	    path: '/bulk/campains/schedule/:id',
	
	    component: manageCampaign.create
	}, {
	    name: 'previewScenario',
	    path: '/previewScenario/:id',
	    component: previewScenario
	}, {
	    name: 'bulkcampaign_preview',
	    path: '/bulk_campaign/preview/:id',
	    component: bulk_campaign_preview
	}, {
	    name: 'bulkcampaign_preview_edit',
	    path: '/bulk_campaign/preview/edit/:id',
	    component: bulk_campaign_preview_edit
	}];

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var campaigns = function campaigns(r) {
	    return __webpack_require__.e/* nsure */(4, function () {
	        return r(__webpack_require__(1204));
	    });
	};
	
	var preview = function preview(r) {
	    return __webpack_require__.e/* nsure */(4, function () {
	        return r(__webpack_require__(1212));
	    });
	};
	var bulkpreview = function bulkpreview(r) {
	    return __webpack_require__.e/* nsure */(4, function () {
	        return r(__webpack_require__(1201));
	    });
	};
	var manageCampaign = {
	    index: function index(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(1211));
	        });
	    },
	    create: function create(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(1205));
	        });
	    },
	    description: function description(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(1206));
	        });
	    },
	    email: function email(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(167));
	        });
	    },
	    sms: function sms(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(167));
	        });
	    },
	    team: function team(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(167));
	        });
	    },
	    whatsapp: function whatsapp(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(167));
	        });
	    },
	    landing: function landing(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(1208));
	        });
	    },
	    education: function education(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(1207));
	        });
	    },
	    schedule: function schedule(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(1210));
	        });
	    },
	    review: function review(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(1209));
	        });
	    }
	};
	var scheduleCalendar = function scheduleCalendar(r) {
	    return __webpack_require__.e/* nsure */(4, function () {
	        return r(__webpack_require__(1213));
	    });
	};
	var createNeedlePhishing = function createNeedlePhishing(r) {
	    return __webpack_require__.e/* nsure */(4, function () {
	        return r(__webpack_require__(1202));
	    });
	};
	var creatorWorkspace = function creatorWorkspace(r) {
	    return __webpack_require__.e/* nsure */(4, function () {
	        return r(__webpack_require__(1203));
	    });
	};
	var approverWorkspace = function approverWorkspace(r) {
	    return __webpack_require__.e/* nsure */(4, function () {
	        return r(__webpack_require__(1200));
	    });
	};
	exports.default = [{
	    name: 'create_needle_phishing',
	    path: '/create-needle-phishing',
	    component: createNeedlePhishing
	}, {
	    name: 'schedule_calendar',
	    path: '/schedule-calendar',
	    component: scheduleCalendar
	}, {
	    name: 'campaigns',
	    path: '/campaigns',
	
	    alias: ['/announcements', '/policy'],
	    component: campaigns
	}, {
	    name: 'campaigns.index',
	    path: '/campaigns/create',
	
	    alias: ['/announcements/create', '/policy/create'],
	    component: manageCampaign.index,
	    redirect: { name: 'campaigns.create' },
	    children: [{
	        name: 'campaigns.create',
	        path: '/campaigns/create',
	        alias: ['/announcements/create', '/policy/create'],
	        component: manageCampaign.create
	    }, {
	        name: 'campaigns.edit.description',
	        path: '/campaigns/description/:id',
	        alias: ['/announcements/description/:id', '/policy/description/:id'],
	        component: manageCampaign.description
	    }, {
	        name: 'campaigns.edit.email',
	        path: '/campaigns/email/:id',
	        alias: ['/announcements/email/:id', '/policy/email/:id'],
	        component: manageCampaign.email
	    }, {
	        name: 'campaigns.edit.team',
	        path: '/campaigns/team/:id',
	        alias: '/announcements/team/:id',
	        component: manageCampaign.team
	    }, {
	        name: 'campaigns.edit.whatsapp',
	        path: '/campaigns/whatsapp/:id',
	        alias: '/announcements/whatsapp/:id',
	        component: manageCampaign.whatsapp
	    }, {
	        name: 'campaigns.edit.sms',
	        path: '/campaigns/sms/:id',
	        alias: ['/announcements/sms/:id', '/policy/sms/:id'],
	        component: manageCampaign.sms
	    }, {
	        name: 'campaigns.edit.landing',
	        path: '/campaigns/landing/:id',
	        alias: ['/announcements/landing/:id', '/policy/landing/:id'],
	        component: manageCampaign.landing
	    }, {
	        name: 'campaigns.edit.education',
	        path: '/campaigns/education/:id',
	        alias: ['/announcements/education/:id', '/policy/education/:id'],
	        component: manageCampaign.education
	    }, {
	        name: 'campaigns.edit.schedule',
	        path: '/campaigns/schedule/:id',
	        alias: ['/announcements/schedule/:id', '/policy/schedule/:id'],
	        component: manageCampaign.schedule
	    }, {
	        name: 'campaigns.edit.review',
	        path: '/campaigns/review/:id',
	        alias: ['/announcements/review/:id', '/policy/review/:id'],
	        component: manageCampaign.review
	    }]
	}, {
	    name: 'preview',
	    path: '/campaigns/preview/:id',
	    alias: ['/announcements/preview/:id', '/policy/preview/:id'],
	    component: preview
	}, {
	    name: 'bulk/preview',
	    path: '/campaigns/bulk/preview/:id',
	    component: bulkpreview
	}, {
	    name: 'creatorWorkspace',
	    path: '/campaigns/creator-workspace',
	    alias: ['/announcements/creator-workspace', '/policy/creator-workspace'],
	    component: creatorWorkspace
	}, {
	    name: 'approverWorkspace',
	    path: '/campaigns/approver-workspace',
	    alias: ['/announcements/approver-workspace', '/policy/approver-workspace'],
	    component: approverWorkspace
	}];

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setCheckedSettings = undefined;
	
	var _mutationTypes = __webpack_require__(270);
	
	var TYPES = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var setCheckedSettings = exports.setCheckedSettings = function setCheckedSettings(_ref, settings) {
	    var commit = _ref.commit;
	
	    commit(TYPES.CAMPAING_CHECKED_SETTINGS, settings);
	};

/***/ }),

/***/ 826:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getCheckedSettings = exports.getCheckedSettings = function getCheckedSettings(state) {
	  return state.checkedSettings;
	};
	var getCampaignSettings = exports.getCampaignSettings = function getCampaignSettings(state) {
	  return state.campaignSettings;
	};

/***/ }),

/***/ 827:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(829);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(828);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(825);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(826);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = { state: _state2.default, mutations: _mutations2.default, actions: actions, getters: getters };
	
	exports.default = { module: _module };

/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationTypes = __webpack_require__(270);
	
	var TYPES = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _defineProperty3.default)({}, TYPES.CAMPAING_CHECKED_SETTINGS, function (state, checkedSettings) {
	    state.checkedSettings = checkedSettings;
	});

/***/ }),

/***/ 829:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    campaignSettings: ['not_opened', 'delivered', 'bounced'],
	    checkedSettings: []
	};

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var domains = function domains(r) {
	    return __webpack_require__.e/* nsure */(23, function () {
	        r(__webpack_require__(1217));
	    });
	};
	
	exports.default = [{
	    name: 'company.domains',
	    path: '/company/domains',
	    component: domains
	}];

/***/ }),

/***/ 831:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setDomains = exports.LOAD_DOMAIN_LIST = exports.addCompanyDomain = undefined;
	
	var _promise = __webpack_require__(68);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _services = __webpack_require__(273);
	
	var services = _interopRequireWildcard(_services);
	
	var _mutationsTypes = __webpack_require__(274);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	var _state = __webpack_require__(275);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addCompanyDomain = exports.addCompanyDomain = function addCompanyDomain(_ref, payload) {
	  var dispatch = _ref.dispatch;
	  return services.addNewDomain(payload).then(function (_ref2) {
	    var message = _ref2.message,
	        status_code = _ref2.status_code;
	
	    console.log(message, status_code);
	  });
	};
	
	var LOAD_DOMAIN_LIST = exports.LOAD_DOMAIN_LIST = function LOAD_DOMAIN_LIST(_ref3) {
	  var dispatch = _ref3.dispatch;
	
	
	  services.getDomains().then(function (response) {
	    console.log('state', _state2.default);
	
	    dispatch('setDomains', response.data);
	    return _promise2.default.resolve(response);
	  }).catch(function (error) {
	
	    console.log('error', error);
	    return _promise2.default.reject('FAIL_IN_LOAD_COMPANY_DOMAINS');
	  });
	};
	
	var setDomains = exports.setDomains = function setDomains(_ref4, list) {
	  var commit = _ref4.commit;
	
	  console.log('commiter', commit);
	  console.log('list', list);
	
	  commit(TYPES.SET_DOMAIN_LIST, list);
	
	  console.log(_state2.default);
	
	  return _promise2.default.resolve(list);
	};

/***/ }),

/***/ 832:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDomains = exports.getDomains = function getDomains(_ref) {
	  var state = _ref.state;
	  return state.domains;
	};

/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(275);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(834);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(831);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(832);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = { state: _state2.default, actions: actions, mutations: _mutations2.default, getters: getters };
	
	exports.default = { module: _module };

/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationsTypes = __webpack_require__(274);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _defineProperty3.default)({}, TYPES.SET_DOMAIN_LIST, function (state, list) {
	    state.domains = list;
	});

/***/ }),

/***/ 835:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var Dashboard = function Dashboard(r) {
	  return __webpack_require__.e/* nsure */(10, function () {
	    return r(__webpack_require__(1219));
	  });
	};
	var CompanyList = function CompanyList(r) {
	  return __webpack_require__.e/* nsure */(10, function () {
	    return r(__webpack_require__(1218));
	  });
	};
	var ReportedPluginUsers = function ReportedPluginUsers(r) {
	  return __webpack_require__.e/* nsure */(10, function () {
	    return r(__webpack_require__(1220));
	  });
	};
	var WeakestLinkUser = function WeakestLinkUser(r) {
	  return __webpack_require__.e/* nsure */(10, function () {
	    return r(__webpack_require__(1221));
	  });
	};
	
	exports.default = [{
	  name: 'dashboard.index',
	  path: '/',
	  component: Dashboard
	}, {
	  name: 'pluginusers',
	  path: '/reported/pluginusers',
	  component: ReportedPluginUsers
	}, {
	  name: 'dashboard.companylist',
	  path: '/companylist',
	  component: CompanyList
	}, {
	  name: 'dashboard.weakestlinkuser',
	  path: '/weakestlink',
	  component: WeakestLinkUser
	}];

/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var Badges = function Badges(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1228));
	    });
	};
	var Points = function Points(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1230));
	    });
	};
	var addBadge = function addBadge(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1224));
	    });
	};
	var awardLog = function awardLog(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1225));
	    });
	};
	var gamification_notification = function gamification_notification(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1229));
	    });
	};
	
	exports.default = [{
	    name: 'gamification.badges',
	    path: '/gamification-engine/badges',
	    component: Badges
	}, {
	    name: 'gamification.add_badge',
	    path: '/gamification-engine/add-badge',
	    component: addBadge
	}, {
	    name: 'gamification.edit_badge',
	    path: '/gamification-engine/edit-badge/:id',
	    component: addBadge
	}, {
	    name: 'gamification.points',
	    path: '/gamification-engine/points',
	    component: Points
	}, {
	    name: 'gamification.award_log_all',
	    path: '/gamification-engine/award-log/',
	    component: awardLog
	}, {
	    name: 'gamification.award_log',
	    path: '/gamification-engine/award-log/:id/',
	    component: awardLog
	}, {
	    name: 'gamification.gamification_notification',
	    path: '/gamification-engine/default-notification-email-settings',
	    component: gamification_notification
	}];

/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var ip = {
	    index: function index(r) {
	        return __webpack_require__.e/* nsure */(13, function () {
	            return r(__webpack_require__(1232));
	        });
	    },
	    announcementIp: function announcementIp(r) {
	        return __webpack_require__.e/* nsure */(13, function () {
	            return r(__webpack_require__(1231));
	        });
	    }
	};
	exports.default = [{
	    name: 'ip.index',
	    path: '/ip-information/campaign',
	    component: ip.index
	}, {
	    name: 'ip.announcementIp',
	    path: '/ip-information/announcement',
	    component: ip.announcementIp
	}];

/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	var laggards = {
			index: function index(r) {
					return __webpack_require__.e/* nsure */(2, function () {
							return r(__webpack_require__(1234));
					});
			},
			edit: function edit(r) {
					return __webpack_require__.e/* nsure */(2, function () {
							return r(__webpack_require__(1233));
					});
			},
			LaggardsNew: function LaggardsNew(r) {
					return __webpack_require__.e/* nsure */(2, function () {
							return r(__webpack_require__(1235));
					});
			}
	};
	
	exports.default = [{
			name: 'reports.laggards',
			path: '/reports/laggards',
			component: laggards.index
	}, {
			name: 'laggards.edit',
			path: '/laggards/:id',
			component: laggards.edit
	}, {
			name: 'laggards',
			path: '/laggards',
			component: laggards.LaggardsNew
	}];

/***/ }),

/***/ 839:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	
	var leaderboard = {
			index: function index(r) {
					return __webpack_require__.e/* nsure */(2, function () {
							return r(__webpack_require__(1237));
					});
			},
			edit: function edit(r) {
					return __webpack_require__.e/* nsure */(2, function () {
							return r(__webpack_require__(1236));
					});
			},
			LeaderboardNew: function LeaderboardNew(r) {
					return __webpack_require__.e/* nsure */(2, function () {
							return r(__webpack_require__(1238));
					});
			}
	};
	
	exports.default = [{
			name: 'reports.leaderboard',
			path: '/reports/leaderboard',
			component: leaderboard.index
	}, {
			name: 'leaderboard.edit',
			path: '/leaderboard/:id',
			component: leaderboard.edit
	}, {
			name: 'leaderboard',
			path: '/leaderboard',
			component: leaderboard.LeaderboardNew
	}];

/***/ }),

/***/ 840:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(841);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var logs = function logs(r) {
	    return __webpack_require__.e/* nsure */(21, function () {
	        return r(__webpack_require__(1239));
	    });
	};
	exports.default = [{
	    name: 'logs',
	    path: '/logs/index',
	    component: logs
	}];

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PhishingVulnerabilityTrend = exports.PhishingVulnerabilityTrend = function PhishingVulnerabilityTrend(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1246));
	  });
	};
	var AwarenessTrendsLook = exports.AwarenessTrendsLook = function AwarenessTrendsLook(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1241));
	  });
	};
	var ReportingTrend = exports.ReportingTrend = function ReportingTrend(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1249));
	  });
	};
	var Weekest = exports.Weekest = function Weekest(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1258));
	  });
	};
	var Strongest = exports.Strongest = function Strongest(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1251));
	  });
	};
	var Deparmentweakest = exports.Deparmentweakest = function Deparmentweakest(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1243));
	  });
	};
	var Highrisk = exports.Highrisk = function Highrisk(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1245));
	  });
	};
	var Deparmentcompromise = exports.Deparmentcompromise = function Deparmentcompromise(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1242));
	  });
	};
	var Designationcompromise = exports.Designationcompromise = function Designationcompromise(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1244));
	  });
	};
	
	var phishingvulnerabilitytrend = exports.phishingvulnerabilitytrend = function phishingvulnerabilitytrend(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1247));
	  });
	};
	var cybersecurityawarenesstrend = exports.cybersecurityawarenesstrend = function cybersecurityawarenesstrend(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1240));
	  });
	};
	var phishingreportingtrend = exports.phishingreportingtrend = function phishingreportingtrend(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1250));
	  });
	};
	var WeekestLinkNew = exports.WeekestLinkNew = function WeekestLinkNew(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1259));
	  });
	};
	var StrongestLinkNew = exports.StrongestLinkNew = function StrongestLinkNew(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1252));
	  });
	};
	var DeparmentWeakestLink = exports.DeparmentWeakestLink = function DeparmentWeakestLink(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1256));
	  });
	};
	var VulnerabilityReportDepartmentWise = exports.VulnerabilityReportDepartmentWise = function VulnerabilityReportDepartmentWise(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1254));
	  });
	};
	var VulnerabilityReportDesignationWise = exports.VulnerabilityReportDesignationWise = function VulnerabilityReportDesignationWise(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1255));
	  });
	};
	var StrongestLinkReported = exports.StrongestLinkReported = function StrongestLinkReported(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1253));
	  });
	};
	var Weakestdepartments = exports.Weakestdepartments = function Weakestdepartments(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1257));
	  });
	};
	var RepeatOffenders = exports.RepeatOffenders = function RepeatOffenders(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1248));
	  });
	};

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _components = __webpack_require__(843);
	
	var component = _interopRequireWildcard(_components);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = [{
	  name: 'managementreport.phishingvulnerability',
	  path: '/managementreport/phishingvulnerability',
	  component: component.PhishingVulnerabilityTrend
	}, {
	  name: 'managementreport.awarenesstrendslook',
	  path: '/managementreport/awarenesstrendslook',
	  component: component.AwarenessTrendsLook
	}, {
	  name: 'managementreport.reportingtrend',
	  path: '/managementreport/reportingtrend',
	  component: component.ReportingTrend
	}, {
	  name: 'managementreport.weakest',
	  path: '/managementreport/weakest',
	  component: component.Weekest
	}, {
	  name: 'managementreport.strongest',
	  path: '/managementreport/strongest',
	  component: component.Strongest
	}, {
	  name: 'managementreport.departmentweakest',
	  path: '/managementreport/departmentweakest',
	  component: component.Deparmentweakest
	}, {
	  name: 'managementreport.highrisk',
	  path: '/managementreport/highrisk',
	  component: component.Highrisk
	}, {
	  name: 'managementreport.departmentcompromise',
	  path: '/managementreport/departmentcompromise',
	  component: component.Deparmentcompromise
	}, {
	  name: 'managementreport.designationcompromise',
	  path: '/managementreport/designationcompromise',
	  component: component.Designationcompromise
	}, {
	  name: 'managementreport.phishingvulnerabilitytrend',
	  path: '/managementreport/phishingvulnerabilitytrend',
	  component: component.phishingvulnerabilitytrend
	}, {
	  name: 'managementreport.cybersecurityawarenesstrend',
	  path: '/managementreport/cybersecurityawarenesstrend',
	  component: component.cybersecurityawarenesstrend
	}, {
	  name: 'managementreport.phishingreportingtrend',
	  path: '/managementreport/phishingreportingtrend',
	  component: component.phishingreportingtrend
	}, {
	  name: 'managementreport.weakestlinks',
	  path: '/managementreport/weakestlinks',
	  component: component.WeekestLinkNew
	}, {
	  name: 'managementreport.strongestlinks-least-compromised',
	  path: '/managementreport/strongestlinks-least-compromised',
	  component: component.StrongestLinkNew
	}, {
	  name: 'managementreport.strongestlinks-most-reported',
	  path: '/managementreport/strongestlinks-most-reported',
	  component: component.StrongestLinkReported
	}, {
	  name: 'managementreport.weakest_deparment_new',
	  path: '/managementreport/weakest_deparment_new',
	  component: component.DeparmentWeakestLink
	}, {
	  name: 'newreports.VulnerabilityReport-DepartmentWiseUniqueEmployees',
	  path: '/newreports/VulnerabilityReport-DepartmentWiseUniqueEmployees',
	  component: component.VulnerabilityReportDepartmentWise
	}, {
	  name: 'newreports.VulnerabilityReport-DesignationWiseUniqueEmployees',
	  path: '/newreports/VulnerabilityReport-DesignationWiseUniqueEmployees',
	  component: component.VulnerabilityReportDesignationWise
	}, {
	  name: 'managementreport.weakestdepartments',
	  path: '/managementreport/weakestdepartments',
	  component: component.Weakestdepartments
	}, {
	  name: 'managementreport.repeatoffenders',
	  path: '/reports/repeatoffenders',
	  component: component.RepeatOffenders
	}];

/***/ }),

/***/ 845:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	
	var recipients = {
		index: function index(r) {
			return __webpack_require__.e/* nsure */(2, function () {
				return r(__webpack_require__(1267));
			});
		},
		imports: function imports(r) {
			return __webpack_require__.e/* nsure */(2, function () {
				return r(__webpack_require__(1261));
			});
		},
		edit: function edit(r) {
			return __webpack_require__.e/* nsure */(2, function () {
				return r(__webpack_require__(1260));
			});
		},
		suppressionlist: function suppressionlist(r) {
			return __webpack_require__.e/* nsure */(2, function () {
				return r(__webpack_require__(1270));
			});
		},
		UploadCsv: function UploadCsv(r) {
			return __webpack_require__.e/* nsure */(2, function () {
				return r(__webpack_require__(1272));
			});
		},
		MatchFields: function MatchFields(r) {
			return __webpack_require__.e/* nsure */(2, function () {
				return r(__webpack_require__(1264));
			});
		},
		Organize: function Organize(r) {
			return __webpack_require__.e/* nsure */(2, function () {
				return r(__webpack_require__(1265));
			});
		},
		Review: function Review(r) {
			return __webpack_require__.e/* nsure */(2, function () {
				return r(__webpack_require__(1268));
			});
		},
		Thanks: function Thanks(r) {
			return __webpack_require__.e/* nsure */(2, function () {
				return r(__webpack_require__(1271));
			});
		},
		Lists: function Lists(r) {
			return __webpack_require__.e/* nsure */(2, function () {
				return r(__webpack_require__(1262));
			});
		},
		Group: function Group(r) {
			return __webpack_require__.e/* nsure */(2, function () {
				return r(__webpack_require__(1263));
			});
		},
		ouSetting: function ouSetting(r) {
			return __webpack_require__.e/* nsure */(2, function () {
				return r(__webpack_require__(1266));
			});
		},
		suppression: {
			imports: function imports(r) {
				return __webpack_require__.e/* nsure */(2, function () {
					return r(__webpack_require__(1269));
				});
			}
		}
	};
	
	exports.default = [{
		name: 'recipients.ouSetting',
		path: '/recipients/ou-settings',
		component: recipients.ouSetting
	}, {
		name: 'recipients.upload_csv',
		path: '/recipients/upload-csv',
		component: recipients.UploadCsv
	}, {
		name: 'recipients.match_fields',
		path: '/recipients/match-fields',
		component: recipients.MatchFields
	}, {
		name: 'recipients.organize',
		path: '/recipients/organize',
		component: recipients.Organize
	}, {
		name: 'recipients.review',
		path: '/recipients/review',
		component: recipients.Review
	}, {
		name: 'recipients.thanks',
		path: '/recipients/thanks',
		component: recipients.Thanks
	}, {
		name: 'recipients.lists',
		path: '/recipients/lists',
		component: recipients.Lists
	}, {
		name: 'recipients.manage_groups',
		path: '/recipients/manage-groups',
		component: recipients.Group
	}, {
		name: 'recipients',
		path: '/recipients',
		component: recipients.index
	}, {
		name: 'recipients.group',
		path: '/group/recipients/:id',
		component: recipients.index
	}, {
		name: 'suppression',
		path: '/suppression',
		component: recipients.suppressionlist
	}, {
		name: 'recipients.imports',
		path: '/import/recipients',
		component: recipients.imports
	}, {
		name: 'recipients.suppression.imports',
		path: '/imports/suppression',
		component: recipients.suppression.imports
	}, {
		name: 'recipients.edit',
		path: '/recipients/:id',
		component: recipients.edit
	}];

/***/ }),

/***/ 846:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var campaignsDetailedReport = exports.campaignsDetailedReport = function campaignsDetailedReport(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1280));
	  });
	};
	var ReportingNew = exports.ReportingNew = function ReportingNew(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1290));
	  });
	};
	var Reporting = exports.Reporting = function Reporting(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1288));
	  });
	};
	var ReportingsNew = exports.ReportingsNew = function ReportingsNew(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1289));
	  });
	};
	var RepeatAffender = exports.RepeatAffender = function RepeatAffender(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1287));
	  });
	};
	var campaignReporting = exports.campaignReporting = function campaignReporting(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1277));
	  });
	};
	var campaignReportingNew = exports.campaignReportingNew = function campaignReportingNew(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1278));
	  });
	};
	var compareReportingNew = exports.compareReportingNew = function compareReportingNew(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1281));
	  });
	};
	var recipientListing = exports.recipientListing = function recipientListing(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1286));
	  });
	};
	var recipientListingLogs = exports.recipientListingLogs = function recipientListingLogs(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1276));
	  });
	};
	var campaignDetailedReporting = exports.campaignDetailedReporting = function campaignDetailedReporting(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1274));
	  });
	};
	var hcsa = exports.hcsa = function hcsa(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1283));
	  });
	};
	var campaignReportingScenario = exports.campaignReportingScenario = function campaignReportingScenario(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1279));
	  });
	};
	var PhishingCampaignsPerformance = exports.PhishingCampaignsPerformance = function PhishingCampaignsPerformance(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1284));
	  });
	};
	var AnnouncementCampaignsPerformance = exports.AnnouncementCampaignsPerformance = function AnnouncementCampaignsPerformance(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1273));
	  });
	};
	var PolicyCampaignsPerformance = exports.PolicyCampaignsPerformance = function PolicyCampaignsPerformance(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1285));
	  });
	};
	var SavedReports = exports.SavedReports = function SavedReports(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1291));
	  });
	};
	var UserActivityReports = exports.UserActivityReports = function UserActivityReports(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1292));
	  });
	};
	var campaignFiledReports = exports.campaignFiledReports = function campaignFiledReports(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1275));
	  });
	};
	var exportedFiles = exports.exportedFiles = function exportedFiles(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1282));
	  });
	};
	var ViewLog = exports.ViewLog = function ViewLog(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1294));
	  });
	};
	var UserPortalTraffic = exports.UserPortalTraffic = function UserPortalTraffic(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(1293));
	  });
	};

/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _components = __webpack_require__(846);
	
	var component = _interopRequireWildcard(_components);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = [{
	  name: 'report.campaignsnew',
	  path: '/report/campaignsnew',
	  component: component.ReportingNew,
	  meta: { requiresAuth: true }
	}, {
	  name: 'report.campaigns',
	  path: '/report/campaigns',
	  component: component.ReportingsNew
	}, {
	  name: 'report.allcampaigns',
	  path: '/report/allcampaigns',
	  component: component.ReportingsNew
	}, {
	  name: 'report.allannouncements',
	  path: '/report/allannouncements',
	  component: component.ReportingsNew
	}, {
	  name: 'report.campaigns.new',
	  path: '/report/campaigns/new',
	  component: component.ReportingsNew
	}, {
	  name: 'report.repeatAffender',
	  path: '/report/repeatAffender',
	  component: component.RepeatAffender
	}, {
	  name: 'report.campaignreporting',
	  path: '/report/campaigns/:id',
	  component: component.campaignReportingNew
	}, {
	  name: 'report.comparereporting',
	  path: '/report/compare/:id',
	  component: component.compareReportingNew
	}, {
	  name: 'report.campaignreporting.new',
	  path: '/report/campaigns/new/:id',
	  component: component.campaignReportingNew
	}, {
	  name: 'report.campaignfiledreports',
	  path: '/report/campaigns/failed/:id',
	  component: component.campaignFiledReports
	}, {
	  name: 'report.recipientlisting',
	  path: '/report/campaigns/:id/:type',
	  component: component.recipientListing
	}, {
	  name: 'report.recipientlistinglogs',
	  path: '/report/campaigns/logs/:id/:type',
	  component: component.recipientListingLogs
	}, {
	  name: 'report.detailedreporting',
	  path: '/report/detailed',
	  component: component.campaignDetailedReporting
	}, {
	  name: 'report.hcsa',
	  path: '/report/hcsa_hisp',
	  component: component.hcsa
	}, {
	  name: 'report.campaignreportingScenario',
	  path: '/scenarioreport/campaigns',
	  component: component.campaignReportingScenario
	}, {
	  name: 'reports.announcementcampaignsperformance',
	  path: '/reports/announcementcampaignsperformance',
	  component: component.AnnouncementCampaignsPerformance
	}, {
	  name: 'reports.policyannouncementperformance',
	  path: '/reports/policyannouncementperformance',
	  component: component.PolicyCampaignsPerformance
	}, {
	  name: 'reports.phishingcampaignsperformance',
	  path: '/reports/phishingcampaignsperformance',
	  component: component.PhishingCampaignsPerformance
	}, {
	  name: 'report.campaigns-detailed-report',
	  path: '/reports/campaigns-detailed-report',
	  component: component.campaignsDetailedReport
	}, {
	  name: 'report.reports',
	  path: '/reports',
	  component: component.SavedReports
	}, {
	  name: 'report.UserActivity',
	  path: '/reports/UserActivity',
	  component: component.UserActivityReports
	}, {
	  name: 'report.exported_files',
	  path: '/exported-files',
	  component: component.exportedFiles
	}, {
	  name: 'report.view_log',
	  path: '/reports/phishing-campaign/view-log/:id',
	  component: component.ViewLog
	}, {
	  name: 'report.userportaltraffic',
	  path: '/reports/portal-logins',
	  component: component.UserPortalTraffic
	}];

/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(18);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _dashboard = __webpack_require__(276);
	
	var _company = __webpack_require__(272);
	
	var _bulk_campaign = __webpack_require__(268);
	
	var _recipient = __webpack_require__(182);
	
	var _campaign = __webpack_require__(269);
	
	var _report = __webpack_require__(183);
	
	var _setting = __webpack_require__(184);
	
	var _scenario = __webpack_require__(849);
	
	var _leaderboard = __webpack_require__(281);
	
	var _laggards = __webpack_require__(280);
	
	var _managementreport = __webpack_require__(282);
	
	var _adn = __webpack_require__(807);
	
	var _vcro = __webpack_require__(286);
	
	var _HRISandVSMS = __webpack_require__(802);
	
	var _gamification = __webpack_require__(277);
	
	var _userportalpages = __webpack_require__(285);
	
	var _ip = __webpack_require__(278);
	
	var _teamportalpages = __webpack_require__(854);
	
	var _logs = __webpack_require__(840);
	
	var _adobeAcrobat = __webpack_require__(809);
	
	var _adminlogs = __webpack_require__(804);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = [].concat((0, _toConsumableArray3.default)(_company.routes), (0, _toConsumableArray3.default)(_recipient.routes), (0, _toConsumableArray3.default)(_campaign.routes), (0, _toConsumableArray3.default)(_bulk_campaign.routes), (0, _toConsumableArray3.default)(_report.routes), (0, _toConsumableArray3.default)(_setting.routes), (0, _toConsumableArray3.default)(_scenario.routes), (0, _toConsumableArray3.default)(_laggards.routes), (0, _toConsumableArray3.default)(_dashboard.routes), (0, _toConsumableArray3.default)(_leaderboard.routes), (0, _toConsumableArray3.default)(_adn.routes), (0, _toConsumableArray3.default)(_managementreport.routes), (0, _toConsumableArray3.default)(_vcro.routes), (0, _toConsumableArray3.default)(_HRISandVSMS.routes), (0, _toConsumableArray3.default)(_gamification.routes), (0, _toConsumableArray3.default)(_userportalpages.routes), (0, _toConsumableArray3.default)(_teamportalpages.routes), (0, _toConsumableArray3.default)(_ip.routes), (0, _toConsumableArray3.default)(_logs.routes), (0, _toConsumableArray3.default)(_adobeAcrobat.routes), (0, _toConsumableArray3.default)(_adminlogs.routes));

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(850);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var scenario = function scenario(r) {
	    return __webpack_require__.e/* nsure */(16, function () {
	        return r(__webpack_require__(1296));
	    });
	};
	
	var manageScenario = {
	    index: function index(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(1301));
	        });
	    },
	
	    description: function description(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(1297));
	        });
	    },
	    email: function email(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(168));
	        });
	    },
	    whatsapp: function whatsapp(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(168));
	        });
	    },
	    team: function team(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(168));
	        });
	    },
	    sms: function sms(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(168));
	        });
	    },
	    landing: function landing(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(1299));
	        });
	    },
	    education: function education(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(1298));
	        });
	    },
	    review: function review(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(1300));
	        });
	    }
	};
	
	exports.default = [{
	    name: 'scenario',
	    path: '/scenario',
	    component: scenario
	}, {
	    name: 'scenario.index',
	    path: '/scenario/create',
	    component: manageScenario.index,
	    redirect: { name: 'scenario.create' },
	    children: [{
	        name: 'scenario.description',
	        path: '/scenario/description',
	        component: manageScenario.description
	    }, {
	        name: 'scenario.edit.description',
	        path: '/scenario/description/:id',
	        component: manageScenario.description
	    }, {
	        name: 'scenario.edit.email',
	        path: '/scenario/email/:id',
	        component: manageScenario.email
	    }, {
	        name: 'scenario.edit.sms',
	        path: '/scenario/sms/:id',
	        component: manageScenario.sms
	    }, {
	        name: 'scenario.edit.team',
	        path: '/scenario/team/:id',
	        component: manageScenario.team
	    }, {
	        name: 'scenario.edit.whatsapp',
	        path: '/scenario/whatsapp/:id',
	        component: manageScenario.whatsapp
	    }, {
	        name: 'scenario.edit.landing',
	        path: '/scenario/landing/:id',
	        component: manageScenario.landing
	    }, {
	        name: 'scenario.edit.education',
	        path: '/scenario/education/:id',
	        component: manageScenario.education
	    }, {
	        name: 'scenario.edit.review',
	        path: '/scenario/review/:id',
	        component: manageScenario.review
	    }]
	}];

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var general = function general(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1324));
	    });
	};
	var usermanagement = function usermanagement(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1367));
	    });
	};
	var directlearning = function directlearning(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1317));
	    });
	};
	var directlearning_recipient = function directlearning_recipient(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1318));
	    });
	};
	var campaign = function campaign(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1312));
	    });
	};
	var email = function email(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1322));
	    });
	};
	var credentials = function credentials(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1315));
	    });
	};
	var landing = function landing(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1329));
	    });
	};
	var adform = function adform(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1308));
	    });
	};
	var listad = function listad(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1332));
	    });
	};
	var adlogs = function adlogs(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1309));
	    });
	};
	var alladlogs = function alladlogs(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1311));
	    });
	};
	var oopspage = function oopspage(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1330));
	    });
	};
	
	var trainingmail = function trainingmail(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(482));
	    });
	};
	var dl_invitation_mail = function dl_invitation_mail(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1319));
	    });
	};
	var dl_login_link_mail = function dl_login_link_mail(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1320));
	    });
	};
	var dl_login_with_password_mail = function dl_login_with_password_mail(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1321));
	    });
	};
	var security = function security(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1343));
	    });
	};
	var azure = function azure(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1344));
	    });
	};
	
	var appCredentials = function appCredentials(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1302));
	    });
	};
	var O365Setup = function O365Setup(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1303));
	    });
	};
	
	var books = function books(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1304));
	    });
	};
	
	var changepassword = function changepassword(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1314));
	    });
	};
	var bulkeducation = function bulkeducation(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1305));
	    });
	};
	var point_configure = function point_configure(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1341));
	    });
	};
	var reminder = function reminder(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1342));
	    });
	};
	var leaderboardsetting = function leaderboardsetting(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1331));
	    });
	};
	var welcome_mail = function welcome_mail(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1368));
	    });
	};
	var trainingmodule = function trainingmodule(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1365));
	    });
	};
	var trainingModuleAdmin = function trainingModuleAdmin(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1362));
	    });
	};
	var master_landing = function master_landing(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1336));
	    });
	};
	var reminder_template = function reminder_template(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(482));
	    });
	};
	var throttling_sending_speed = function throttling_sending_speed(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1369));
	    });
	};
	var courses = function courses(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1306));
	    });
	};
	var training_settings = function training_settings(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1364));
	    });
	};
	var import_reporters = function import_reporters(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1327));
	    });
	};
	var ImportTrainedUsers = function ImportTrainedUsers(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1328));
	    });
	};
	var ExternalTrainingModules = function ExternalTrainingModules(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1323));
	    });
	};
	var Notifications = function Notifications(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1338));
	    });
	};
	var SystemAlerts = function SystemAlerts(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1361));
	    });
	};
	var IgnoreList = function IgnoreList(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1325));
	    });
	};
	var AddSource = function AddSource(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1307));
	    });
	};
	var UpdateLog = function UpdateLog(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1366));
	    });
	};
	var IgnoredActivities = function IgnoredActivities(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1326));
	    });
	};
	var SuppressionList = function SuppressionList(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1360));
	    });
	};
	var Personlaization = function Personlaization(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1340));
	    });
	};
	var manageSmtp = function manageSmtp(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1334));
	    });
	};
	var manageSmtpDomains = function manageSmtpDomains(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1335));
	    });
	};
	var manageLandingPageDomains = function manageLandingPageDomains(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1333));
	    });
	};
	var customizeAdminLogin = function customizeAdminLogin(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1316));
	    });
	};
	var notificationDescription = function notificationDescription(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1337));
	    });
	};
	var aiSettings = function aiSettings(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1310));
	    });
	};
	var pdfCampaign = function pdfCampaign(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1339));
	    });
	};
	var campaignUserRole = function campaignUserRole(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1313));
	    });
	};
	var training_languages = function training_languages(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(1363));
	    });
	};
	exports.default = [{
	    name: 'notificationDescription',
	    path: '/notification/:id',
	    component: notificationDescription
	}, {
	    name: 'customizeAdminLogin',
	    path: '/setting/customize-admin-login',
	    component: customizeAdminLogin
	}, {
	    name: 'courses',
	    path: '/setting/courses',
	    component: courses
	}, {
	    name: 'general',
	    path: '/setting/general',
	    component: general
	}, {
	    name: 'throttling_sending_speed',
	    path: '/setting/throttling_sending_speed',
	    component: throttling_sending_speed
	}, {
	    name: 'master_landing',
	    path: '/setting/master_landing',
	    component: master_landing
	}, {
	    name: 'trainingmoduleAdmin',
	    path: '/trainingmoduleAdmin',
	    component: trainingModuleAdmin
	}, {
	    name: 'training_languages',
	    path: '/setting/training-languages',
	    component: training_languages
	}, {
	    name: 'trainingmodule',
	    path: '/trainingmodule',
	    component: trainingmodule
	}, {
	    name: 'leaderboardsetting',
	    path: '/setting/leaderboardsetting',
	    component: leaderboardsetting
	}, {
	    name: 'usermanagement',
	    path: '/setting/usermanagement',
	    component: usermanagement
	}, {
	    name: 'directlearning',
	    path: '/setting/directlearning',
	    component: directlearning
	}, {
	    name: 'directlearning_recipient',
	    path: '/setting/directlearning/:id/:type',
	    component: directlearning_recipient
	}, {
	    name: 'retest',
	    path: '/setting/campaign',
	    component: campaign
	}, {
	    name: 'email',
	    path: '/setting/email',
	    component: email
	}, {
	    name: 'credentials',
	    path: '/setting/reply-to-credentials',
	    component: credentials
	}, {
	    name: 'landing',
	    path: '/setting/landing',
	    component: landing
	}, {
	    name: 'adform',
	    path: '/setting/adform',
	    component: adform
	}, {
	    name: 'listad',
	    path: '/setting/listad',
	    component: listad
	}, {
	    name: 'adlogs',
	    path: '/setting/adlogs/:id',
	    component: adlogs
	}, {
	    name: 'alladlogs',
	    path: '/setting/alladlogs',
	    component: alladlogs
	}, {
	    name: 'oopspage',
	    path: '/setting/oopspage',
	    component: oopspage
	}, {
	    name: 'trainingmail',
	    path: '/setting/trainingmail',
	    component: trainingmail
	}, {
	    name: 'dl_invitation_mail',
	    path: '/setting/dl_invitation_mail',
	    component: dl_invitation_mail
	}, {
	    name: 'dl_login_link_mail',
	    path: '/setting/dl_login_link_mail',
	    component: dl_login_link_mail
	}, {
	    name: 'dl_login_link_mail',
	    path: '/setting/dl_login_link_mail',
	    component: dl_login_link_mail
	}, {
	    name: 'dl_login_with_password_mail',
	    path: '/setting/dl_login_with_password_mail',
	    component: dl_login_with_password_mail
	}, {
	    name: 'notifications',
	    path: '/settings/notifications',
	    component: Notifications
	}, {
	    name: 'systemAlerts',
	    path: '/settings/system-alerts',
	    component: SystemAlerts
	}, {
	    name: 'ignore_list',
	    path: '/settings/ignore-list',
	    component: IgnoreList
	}, {
	    name: 'add_source',
	    path: '/settings/ignore-list/add-source',
	    component: AddSource
	}, {
	    name: 'update_log',
	    path: '/settings/ignore-list/audit-log',
	    component: UpdateLog
	}, {
	    name: 'ignored_activities',
	    path: '/settings/ignore-list/ignored-activities',
	    component: IgnoredActivities
	}, {
	    name: 'suppression_list',
	    path: '/settings/ignore-list/suppression-logs',
	    component: SuppressionList
	}, {
	    name: 'personlaization',
	    path: '/settings/personlaization',
	    component: Personlaization
	}, {
	    name: 'security',
	    path: '/setting/security',
	    component: security
	}, {
	    name: 'azure',
	    path: '/setting/azure',
	    component: azure
	}, {
	    name: 'appCredentials',
	    path: '/setting/channel-credentials',
	    component: appCredentials
	}, {
	    name: 'O365Setup',
	    path: '/setting/O365Setup',
	    component: O365Setup
	}, {
	    name: 'aiSettings',
	    path: '/settings/ai-setting',
	    component: aiSettings
	}, {
	    name: 'books',
	    path: '/setting/books',
	    component: books
	}, {
	    name: 'changepassword',
	    path: '/setting/changepassword',
	    component: changepassword
	}, {
	    name: 'bulkeducation',
	    path: '/bulkeducation',
	    component: bulkeducation
	}, {
	    name: 'point_configure',
	    path: '/setting/point_configure',
	    component: point_configure
	}, {
	    name: 'reminder',
	    path: '/setting/reminder',
	    component: reminder
	}, {
	    name: 'welcome_mail',
	    path: '/setting/welcome_mail',
	    component: welcome_mail
	}, {
	    name: 'training_settings',
	    path: '/training_settings',
	    component: training_settings
	}, {
	    name: 'import_reporters',
	    path: '/import_reporters',
	    component: import_reporters
	}, {
	    name: 'import_trained_users',
	    path: '/settings/import-trained-users',
	    component: ImportTrainedUsers
	}, {
	    name: 'external_training_modules',
	    path: '/settings/external-training-modules',
	    component: ExternalTrainingModules
	}, {
	    name: 'manage_smtp',
	    path: '/settings/manage-smtp',
	    component: manageSmtp
	}, {
	    name: 'manage_smtp_domains',
	    path: '/settings/manage-smtp-domains',
	    component: manageSmtpDomains
	}, {
	    name: 'manage_landing_page_domains',
	    path: '/settings/manage-landing-page-domains',
	    component: manageLandingPageDomains
	}, {
	    name: 'pdfCampaign',
	    path: '/settings/pdf-campaign',
	    component: pdfCampaign
	}, {
	    name: 'campaignUserRole',
	    path: '/settings/campaign-user-role',
	    component: campaignUserRole
	}];

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(853);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var TeamPortal = function TeamPortal(r) {
	    return __webpack_require__.e/* nsure */(15, function () {
	        return r(__webpack_require__(1378));
	    });
	};
	var TeamPortalSaml = function TeamPortalSaml(r) {
	    return __webpack_require__.e/* nsure */(22, function () {
	        return r(__webpack_require__(1377));
	    });
	};
	exports.default = [{
	    name: 'teamportal',
	    path: '/teamportal',
	    component: TeamPortal,
	    props: function props(route) {
	        return { uuid: route.query.uuid };
	    }
	}, {
	    name: 'teamportal-saml',
	    path: '/teamportal/saml',
	    component: TeamPortalSaml,
	    meta: { requiresAuth: false },
	    props: function props(route) {
	        return { uuid: route.query.uuid, code: route.query.code };
	    }
	}];

/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(855);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var viewasTeamportal = function viewasTeamportal(r) {
	    return __webpack_require__.e/* nsure */(14, function () {
	        return r(__webpack_require__(1380));
	    });
	};
	var customizeTeamportal = function customizeTeamportal(r) {
	    return __webpack_require__.e/* nsure */(14, function () {
	        return r(__webpack_require__(1379));
	    });
	};
	exports.default = [{
	    name: 'viewasTeamportal',
	    path: '/teamportal/view-as',
	    component: viewasTeamportal
	}, {
	    name: 'customizeTeamportal',
	    path: '/teamportal/customise',
	    component: customizeTeamportal
	}];

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(857);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var userportal = function userportal(r) {
	    return __webpack_require__.e/* nsure */(11, function () {
	        return r(__webpack_require__(1389));
	    });
	};
	
	var Enduserportal = function Enduserportal(r) {
	    return __webpack_require__.e/* nsure */(11, function () {
	        return r(__webpack_require__(1381));
	    });
	};
	var Enduserportal2 = function Enduserportal2(r) {
	    return __webpack_require__.e/* nsure */(11, function () {
	        return r(__webpack_require__(1382));
	    });
	};
	exports.default = [{
	    name: 'userportal',
	    path: '/userportal/:id',
	    meta: { requiresAuth: false },
	    component: userportal
	}, {
	    name: 'Enduserportal',
	    path: '/userportal-v2/en/:id',
	    meta: { requiresAuth: false },
	    component: Enduserportal
	}, {
	    name: 'Enduserportal2',
	    path: '/userportal-v2/ar/:id',
	    meta: { requiresAuth: false },
	    component: Enduserportal2
	}];

/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var viewas = function viewas(r) {
	    return __webpack_require__.e/* nsure */(8, function () {
	        return r(__webpack_require__(1400));
	    });
	};
	var viewasNew = function viewasNew(r) {
	    return __webpack_require__.e/* nsure */(8, function () {
	        return r(__webpack_require__(1401));
	    });
	};
	var customize = function customize(r) {
	    return __webpack_require__.e/* nsure */(8, function () {
	        return r(__webpack_require__(1396));
	    });
	};
	var newsUpdates = function newsUpdates(r) {
	    return __webpack_require__.e/* nsure */(8, function () {
	        return r(__webpack_require__(1399));
	    });
	};
	var customizeLogin = function customizeLogin(r) {
	    return __webpack_require__.e/* nsure */(8, function () {
	        return r(__webpack_require__(1397));
	    });
	};
	var customize_new = function customize_new(r) {
	    return __webpack_require__.e/* nsure */(8, function () {
	        return r(__webpack_require__(1398));
	    });
	};
	exports.default = [{
	    name: 'viewas',
	    path: '/userportal/view-as',
	    component: viewas
	}, {
	    name: 'viewasNew',
	    path: '/userportal-v2/view-as',
	    component: viewasNew
	}, {
	    name: 'customize',
	    path: '/userportal/customise',
	    component: customize
	}, {
	    name: 'customize_login',
	    path: '/userportal/customise-login-page',
	    component: customizeLogin
	}, {
	    name: 'news_updates',
	    path: '/userportal/news-updates',
	    component: newsUpdates
	}, {
	    name: 'news_updates_new',
	    path: '/userportal-v2/news-updates',
	    component: newsUpdates
	}, {
	    name: 'customize_new',
	    path: '/userportal-v2/customise',
	    component: customize_new
	}, {
	    name: 'customize_login_new',
	    path: '/userportal-v2/customise-login-page',
	    component: customizeLogin
	}];

/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	
	
	var vcro = {
	      userRiskScore: function userRiskScore(r) {
	            return __webpack_require__.e/* nsure */(7, function () {
	                  return r(__webpack_require__(1409));
	            });
	      },
	      organisationRiskScore: function organisationRiskScore(r) {
	            return __webpack_require__.e/* nsure */(7, function () {
	                  return r(__webpack_require__(1408));
	            });
	      },
	      departmentRiskScore: function departmentRiskScore(r) {
	            return __webpack_require__.e/* nsure */(7, function () {
	                  return r(__webpack_require__(1406));
	            });
	      },
	      alldepartment: function alldepartment(r) {
	            return __webpack_require__.e/* nsure */(7, function () {
	                  return r(__webpack_require__(1403));
	            });
	      },
	      allgroup: function allgroup(r) {
	            return __webpack_require__.e/* nsure */(7, function () {
	                  return r(__webpack_require__(1404));
	            });
	      },
	      allusers: function allusers(r) {
	            return __webpack_require__.e/* nsure */(7, function () {
	                  return r(__webpack_require__(1405));
	            });
	      },
	      groupRiskScore: function groupRiskScore(r) {
	            return __webpack_require__.e/* nsure */(7, function () {
	                  return r(__webpack_require__(1407));
	            });
	      }
	};
	
	exports.default = [{
	      name: 'vcro.user_risk_score',
	      path: '/vcro/user-risk-score/:id',
	      component: vcro.userRiskScore
	}, {
	      name: 'vcro.organisation_risk_score',
	      path: '/vcro/organisation-risk-score',
	      component: vcro.organisationRiskScore
	}, {
	      name: 'vcro.department_risk_score',
	      path: '/vcro/department-risk-score/:id',
	      component: vcro.departmentRiskScore
	}, {
	      name: 'vcro.all_department_risk_score',
	      path: '/vcro/all-departments-risk-score',
	      component: vcro.alldepartment
	}, {
	      name: 'vcro.all_group_risk_score',
	      path: '/vcro/all-groups-risk-score',
	      component: vcro.allgroup
	}, {
	      name: 'vcro.all_user_risk_score',
	      path: '/vcro/all-users-risk-score',
	      component: vcro.allusers
	}, {
	      name: 'vcro.group_risk_score',
	      path: '/vcro/group-risk-score/:id',
	      component: vcro.groupRiskScore
	}];

/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(18);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(16);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _keys = __webpack_require__(17);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(9);
	
	var _auth = __webpack_require__(267);
	
	var _campaign = __webpack_require__(269);
	
	var _company = __webpack_require__(272);
	
	var _recipient = __webpack_require__(182);
	
	var _bulk_campaign = __webpack_require__(268);
	
	var _dashboard = __webpack_require__(276);
	
	var _report = __webpack_require__(183);
	
	var _setting = __webpack_require__(184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vuex = { Auth: _auth.vuex, campaign: _campaign.vuex, Company: _company.vuex };
	var keys = (0, _keys2.default)(vuex);
	
	var modules = keys.reduce(function (acc, key) {
	  return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, key, vuex[key].module));
	}, {});
	var plugins = keys.reduce(function (acc, key) {
	  return [].concat((0, _toConsumableArray3.default)(acc), [vuex[key].plugin]);
	}, []).filter(_lodash.isFunction);
	exports.default = { modules: modules, plugins: plugins };

/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment2 = __webpack_require__(1);
	
	var _moment3 = _interopRequireDefault(_moment2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.mixin({
	    data: function data() {
	        return { loader: false };
	    },
	    methods: {
	        toggleLoader: function toggleLoader() {
	            this.loader = this.loader ? false : true;
	        },
	        moment: function moment() {
	            return _moment3.default.apply(undefined, arguments);
	        }
	    }
	});

/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(16);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(3);
	
	var _alerts = __webpack_require__(1411);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _vueSweetalert = __webpack_require__(1694);
	
	var _vueSweetalert2 = _interopRequireDefault(_vueSweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueSweetalert2.default);
	
	_vue2.default.mixin({
	    components: {
	        Alerts: _alerts2.default
	    },
	    computed: (0, _vuex.mapState)(['messages', 'fetching']),
	    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setMessage', 'resetMessages']), {
	        updateErrors: function updateErrors($response) {
	
	            var backendErrors = $response.response.data.errors;
	
	            for (var index in backendErrors) {
	                this.errors.add(index, backendErrors[index][0]);
	            }
	        }
	    })
	});

/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1157);

/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperties = __webpack_require__(289);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	exports.default = install;
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bus = new _vue2.default();
	
	function install(Vue) {
	  (0, _defineProperties2.default)(Vue.prototype, {
	    $bus: {
	      get: function get() {
	        return bus;
	      }
	    }
	  });
	}

/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(43);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(68);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _regenerator = __webpack_require__(34);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(33);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _lodash = __webpack_require__(9);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _services = __webpack_require__(89);
	
	var services = _interopRequireWildcard(_services);
	
	var _index = __webpack_require__(4);
	
	var _setColor = __webpack_require__(877);
	
	var _lmsRedirect = __webpack_require__(78);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var systemAlertRefreshTimer = null;
	
	function signalSystemAlertRefresh(config) {
	    if (!config || !config.method) {
	        return;
	    }
	
	    var method = String(config.method).toLowerCase();
	
	    if (method === 'get' || method === 'head' || method === 'options') {
	        return;
	    }
	
	    var path = String(config.url || '').split('?')[0];
	
	    if (path === '/system-alerts' || path.indexOf('/system-alerts/') === 0) {
	        return;
	    }
	
	    var bus = _vue2.default.prototype.$bus;
	
	    if (!bus) {
	        return;
	    }
	
	    if (systemAlertRefreshTimer) {
	        clearTimeout(systemAlertRefreshTimer);
	    }
	
	    systemAlertRefreshTimer = setTimeout(function () {
	        systemAlertRefreshTimer = null;
	        bus.$emit('system-alerts-refresh');
	    }, 7000);
	}
	
	exports.default = function (http, store, router) {
	    http.interceptors.request.use(function () {
	        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(config) {
	            var currentPath, fullUrl, token;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            (0, _setColor.setColorCode)();
	                            if (!config.hideLoader) {
	                                $('.pace').removeClass('pace-inactive');
	                                $('.pace').addClass('pace-active');
	                            }
	                            if (config.url.includes('/auth_token/revoke')) {
	                                config.headers['Clear-Site-Data'] = '"cache", "cookies", "storage"';
	                            }
	                            if (typeof window !== 'undefined' && window.location) {
	                                currentPath = window.location.pathname || '/';
	                                fullUrl = window.location.origin + currentPath;
	
	                                config.headers['X-Page-URL'] = fullUrl;
	                            }
	                            token = store.state.Auth && store.state.Auth.token;
	
	                            if (!token) {
	                                token = localStorage.getItem('auth_token');
	                            }
	
	                            if (!(!token && !config.url.includes('/auth/login') && !config.url.includes('/auth/verify') && !config.url.includes('/public/'))) {
	                                _context.next = 16;
	                                break;
	                            }
	
	                            _context.prev = 7;
	                            _context.next = 10;
	                            return store.dispatch('checkUserToken');
	
	                        case 10:
	                            token = store.state.Auth && store.state.Auth.token;
	                            _context.next = 16;
	                            break;
	
	                        case 13:
	                            _context.prev = 13;
	                            _context.t0 = _context['catch'](7);
	
	                            console.warn('Token check failed', _context.t0);
	
	                        case 16:
	
	                            if (token) {
	                                config.headers['Authorization'] = 'Bearer ' + token;
	                            }
	
	                            store.dispatch('setFetching', { fetching: true });
	                            return _context.abrupt('return', config);
	
	                        case 19:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[7, 13]]);
	        }));
	
	        return function (_x) {
	            return _ref.apply(this, arguments);
	        };
	    }(), function (error) {
	        return _promise2.default.reject(error);
	    });
	
	    http.interceptors.response.use(function (response) {
	        if (!response.config.hideLoader) {
	            $('.pace').removeClass('pace-active');
	            $('.pace').addClass('pace-inactive');
	        }
	
	        store.dispatch('setFetching', { fetching: false });
	
	        signalSystemAlertRefresh(response.config);
	
	        return response;
	    }, function (error) {
	
	        if (!error.config.hideLoader) {
	            $('.pace').removeClass('pace-active');
	            $('.pace').addClass('pace-inactive');
	        }
	
	        var response = error.response;
	
	        if (response.status == 401) {
	            try {
	                var intended401 = router.currentRoute && router.currentRoute.fullPath || '';
	                if ((0, _lmsRedirect.safePostLoginRedirect)(intended401)) {
	                    sessionStorage.setItem(_lmsRedirect.POST_LOGIN_REDIRECT_KEY, intended401);
	                }
	            } catch (e) {}
	            store.dispatch('setToken', null);
	            store.dispatch('setUser', {});
	            localStorage.clear();
	            var base64String = 'WW91ciBzZXNzaW9uIGhhcyBiZWVuIGV4cGlyZWQuIFBsZWFzZSBsb2dpbiBhZ2Fpbi4=';
	            if (router.currentRoute.path.includes('/userportal-v2') || router.currentRoute.path.includes('/userportal')) {
	                router.push({ name: 'auth.userportalLogin', query: { errorCode: base64String } });
	            } else {
	                router.push({ name: 'auth.login', query: { errorCode: base64String } });
	            }
	        }
	
	        store.dispatch('resetMessages');
	
	        if (response && response.data) {
	            if (response.data.errors && (0, _typeof3.default)(response.data.errors) === 'object') {
	                store.dispatch('setMessage', { type: 'error', message: response.data.errors });
	            } else if (response.data.message) {
	                store.dispatch('setMessage', { type: 'warning', message: response.data.message });
	            }
	        }
	
	        store.dispatch('setFetching', { fetching: false });
	
	        return _promise2.default.reject(error);
	    });
	};

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(188);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _permissions = __webpack_require__(876);
	
	var _services = __webpack_require__(89);
	
	var _config = __webpack_require__(2);
	
	var _lmsRedirect = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function preservePendingDeeplink(to) {
	    try {
	        var target = to && (to.fullPath || to.path) || '';
	        if ((0, _lmsRedirect.safePostLoginRedirect)(target) && !localStorage.getItem('permissions')) {
	            sessionStorage.setItem(_lmsRedirect.POST_LOGIN_REDIRECT_KEY, target);
	        }
	    } catch (e) {}
	}
	
	function getSubdomain() {
	    var regexParse = new RegExp("([a-z\\-0-9]{2,63})\\.([a-z\\.]{2,5})$");
	    var urlParts = regexParse.exec(window.location.hostname);
	    if (!urlParts) {
	        return "";
	    }
	    var domain = urlParts[1];
	    var type = urlParts[2];
	    return window.location.hostname.replace(domain + "." + type, "").slice(0);
	}
	
	function checkAdAutoRedirect(to, next) {
	    var query = to.query || {};
	
	    if (query.errorCode || query.logout === 'true' || query.logout === true) {
	        next();
	        return;
	    }
	
	    var subdomain = getSubdomain();
	    (0, _services.getUserPortalDetials)({ subdomain: subdomain }).then(function (response) {
	        window.__userPortalDetailsCache = response;
	        if (response.data && response.data.value && response.data.value.enable_ad_auth_redirect == true) {
	            window.location.href = _config.recipientAdUrl + "/" + btoa(subdomain);
	        } else {
	            next();
	        }
	    }).catch(function () {
	        next();
	    });
	}
	
	function checkAdminAdAutoRedirect(to, next) {
	    var query = to.query || {};
	
	    if (query.errorCode || query.logout === 'true' || query.logout === true) {
	        next();
	        return;
	    }
	
	    var subdomain = getSubdomain();
	    (0, _services.getLoginDetails)({ subdomain: subdomain }).then(function (response) {
	        window.__adminLoginDetailsCache = response;
	        if (response.data && response.data.value && response.data.value.enable_ad_auth_redirect == true) {
	            window.location.href = _config.adUrl + "/" + btoa(subdomain);
	        } else {
	            next();
	        }
	    }).catch(function () {
	        next();
	    });
	}
	
	var beforeEach = function beforeEach(to, from, next) {
	    var permissions = (0, _permissions.setPermissions)();
	
	    var auth = to.meta.requiresAuth == undefined;
	    window.scrollTo(0, 0);
	
	    _store2.default.dispatch('resetMessages');
	
	    if (auth !== true) {
	        if (to.name === 'auth.userportalLogin') {
	            checkAdAutoRedirect(to, next);
	            return;
	        }
	
	        if (to.name === 'auth.login') {
	            checkAdminAdAutoRedirect(to, next);
	            return;
	        }
	
	        var userLogin = JSON.parse(localStorage.getItem('user'));
	        var notAuthorizedRoutes = ['/login', '/register', '/verification', '/reset', '/saml'];
	        if (userLogin !== null || userLogin) {
	            if (notAuthorizedRoutes.includes(to.path)) {
	                next({ name: 'dashboard.index' });
	            } else {
	                next();
	            }
	        } else {
	            next();
	        }
	        return;
	    }
	
	    _store2.default.dispatch('checkUserToken').then(function () {
	        try {
	            var userPerms = _store2.default.state.permissions && _store2.default.state.permissions();
	            var path = to.path || '';
	
	            if (path.indexOf('/announcements') === 0) {
	                if (userPerms && (userPerms.announcement_create || userPerms.announcement_view)) {
	                    next();
	                } else {
	                    preservePendingDeeplink(to);
	                    next({ name: 'dashboard.index' });
	                }
	                return;
	            }
	
	            if (path.indexOf('/policy') === 0) {
	                if (userPerms && (userPerms.policy_create || userPerms.policy_view)) {
	                    next();
	                } else {
	                    preservePendingDeeplink(to);
	                    next({ name: 'dashboard.index' });
	                }
	                return;
	            }
	        } catch (e) {}
	        if (permissions[to.path]) {
	            next();
	        } else {
	            try {
	                if (permissions[to.name]) {
	                    next();
	                } else {
	                    preservePendingDeeplink(to);
	                    next({ name: 'dashboard.index' });
	                }
	            } catch (e) {}
	        }
	    }).catch(function () {
	        try {
	            var intended = to.fullPath || to.path || '';
	            if ((0, _lmsRedirect.safePostLoginRedirect)(intended)) {
	                sessionStorage.setItem(_lmsRedirect.POST_LOGIN_REDIRECT_KEY, intended);
	                localStorage.clear();
	                next({ name: 'auth.login' });
	                return;
	            }
	        } catch (e) {}
	
	        next({ name: 'auth.userportalLogin' });
	        localStorage.clear();
	    });
	};
	
	exports.default = beforeEach;

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(18);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _vue = __webpack_require__(21);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _auth = __webpack_require__(1410);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _main = __webpack_require__(1413);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _user = __webpack_require__(1423);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _vueRouter = __webpack_require__(1692);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _beforeEach = __webpack_require__(868);
	
	var _beforeEach2 = _interopRequireDefault(_beforeEach);
	
	var _userportal = __webpack_require__(856);
	
	var _teamportal = __webpack_require__(852);
	
	var _auth3 = __webpack_require__(267);
	
	var _app = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{
	    name: 'auth',
	    path: '/auth',
	    component: _auth2.default,
	    meta: { requiresAuth: false },
	    children: [].concat((0, _toConsumableArray3.default)(_auth3.routes)),
	    redirect: { name: 'auth.login' }
	}, {
	    name: 'teamPortal',
	    path: '/teamportal',
	    component: _user2.default,
	
	    children: [].concat((0, _toConsumableArray3.default)(_teamportal.routes))
	}, {
	    path: '/',
	    component: _main2.default,
	    meta: { requiresAuth: true },
	    children: [].concat((0, _toConsumableArray3.default)(_app.routes)),
	    redirect: { name: 'dashboard.index' }
	}, {
	    name: 'userPortal',
	    path: '/userPortal',
	    component: _user2.default,
	    meta: { requiresAuth: true },
	    children: [].concat((0, _toConsumableArray3.default)(_userportal.routes)),
	    redirect: { name: 'auth.userportalLogin' }
	}, {
	    name: 'catchall',
	    path: '*',
	    redirect: { name: 'dashboard.index' }
	}];
	
	var router = new _vueRouter2.default({
	    routes: routes,
	    linkActiveClass: 'active',
	    mode: 'history' });
	
	router.beforeEach(_beforeEach2.default);
	
	exports.default = router;

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _types = __webpack_require__(288);
	
	var TYPES = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	    setFetching: function setFetching(_ref, obj) {
	        var commit = _ref.commit;
	
	        commit(TYPES.MAIN_SET_FETCHING, obj);
	    },
	    setMessage: function setMessage(_ref2, obj) {
	        var commit = _ref2.commit;
	
	        commit(TYPES.MAIN_SET_MESSAGE, obj);
	    },
	    resetMessages: function resetMessages(_ref3) {
	        var commit = _ref3.commit;
	
	        commit(TYPES.MAIN_SET_MESSAGE, { type: 'success', message: '' });
	        commit(TYPES.MAIN_SET_MESSAGE, { type: 'error', message: {} });
	        commit(TYPES.MAIN_SET_MESSAGE, { type: 'warning', message: '' });
	        commit(TYPES.MAIN_SET_MESSAGE, { type: 'validation', message: {} });
	    },
	    setHelpIconRoutes: function setHelpIconRoutes(_ref4, payload) {
	        var commit = _ref4.commit;
	
	        commit(TYPES.SET_HELP_ICON_ROUTES, payload);
	    }
	};

/***/ }),

/***/ 871:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var isAuthPage = exports.isAuthPage = function isAuthPage(_ref) {
	    var route = _ref.route;
	
	    if (route.path.indexOf('/auth') !== -1) return true;
	
	    if (route.path.indexOf('/login') !== -1) return true;
	
	    if (route.path.indexOf('/register') !== -1) return true;
	
	    if (route.path.indexOf('/reset/') !== -1) return true;
	
	    if (route.path.indexOf('/verification') !== -1) return true;
	
	    return false;
	};
	
	var shouldShowNavigation = exports.shouldShowNavigation = function shouldShowNavigation(_ref2, getters) {
	    var route = _ref2.route;
	    return route.path ? !getters.isAuthPage : false;
	};
	
	var helpIconRoutes = exports.helpIconRoutes = function helpIconRoutes(state) {
	    return state.help_icon_route;
	};
	var routesEmpty = exports.routesEmpty = function routesEmpty(state) {
	    return state.help_icon_route.length === 0;
	};

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(16);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _app = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _extends3.default)({}, _app.vuex.modules);

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(10);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TYPES$MAIN_SET_FETCH;
	
	var _types = __webpack_require__(288);
	
	var TYPES = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_TYPES$MAIN_SET_FETCH = {}, (0, _defineProperty3.default)(_TYPES$MAIN_SET_FETCH, TYPES.MAIN_SET_FETCHING, function (state, obj) {
	  state.fetching = obj.fetching;
	}), (0, _defineProperty3.default)(_TYPES$MAIN_SET_FETCH, TYPES.MAIN_SET_MESSAGE, function (state, obj) {
	  state.messages[obj.type] = obj.message;
	}), (0, _defineProperty3.default)(_TYPES$MAIN_SET_FETCH, TYPES.SET_HELP_ICON_ROUTES, function (state, routes) {
	  state.help_icon_route = routes;
	}), _TYPES$MAIN_SET_FETCH);

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(18);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _app = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [].concat((0, _toConsumableArray3.default)(_app.vuex.plugins));

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _store = __webpack_require__(188);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setPermissions() {
	    var permissions = _store2.default.state.permissions();
	    return updatePermissions(permissions);
	}
	
	function updatePermissions(permissions) {
	    return {
	        '/': permissions && permissions.dashboard || true,
	        '/companylist': permissions && permissions.company_list,
	        '/announcements/create': permissions && permissions.announcement_create,
	        '/setting/alladlogs': permissions && permissions.active_directory_view_logs,
	        'adlogs': permissions && permissions.active_directory_view_logs,
	        '/setting/listad': permissions && permissions.ad_servers,
	        '/import/recipients': permissions && permissions.add_new_recepients,
	        '/scenario/description': permissions && permissions.add_scenario,
	        'scenario.edit.description': permissions && permissions.add_scenario,
	        'scenario.edit.email': permissions && permissions.add_scenario,
	        'scenario.edit.sms': permissions && permissions.add_scenario,
	        'scenario.edit.team': permissions && permissions.add_scenario,
	        'scenario.edit.whatsapp': permissions && permissions.add_scenario,
	        'scenario.edit.landing': permissions && permissions.add_scenario,
	        'scenario.edit.education': permissions && permissions.add_scenario,
	        'scenario.edit.review': permissions && permissions.add_scenario,
	        '/suppression': permissions && permissions.add_suppression,
	        '/report/campaigns': permissions && permissions.all_reports,
	        'report.comparereporting': permissions && permissions.all_reports,
	        'report.recipientlisting': permissions && permissions.all_reports,
	
	        '/reports/portal-logins': permissions && permissions.all_reports,
	        'report.userportaltraffic': permissions && permissions.all_reports,
	        '/reports/announcementcampaignsperformance': permissions && permissions.announcement_campaigns_new,
	        '/reports/policyannouncementperformance': permissions && permissions.policy_announcement_new,
	        '/report/allannouncements': permissions && permissions.announcement_reports,
	        '/announcements': permissions && permissions.announcement_view,
	        '/setting/trainingmail': permissions && permissions.auto_reminder_mail,
	        '/managementreport/awarenesstrendslook': permissions && permissions.awareness_trend,
	        '/managementreport/cybersecurityawarenesstrend': permissions && permissions.awareness_trend_new,
	        '/setting/azure': permissions && permissions.azure_active_directory_authorization,
	        '/campaigns/create': permissions && permissions.campaign_create,
	        'campaigns.edit.description': permissions && permissions.campaign_create,
	        'campaigns.edit.email': permissions && permissions.campaign_create,
	        'campaigns.edit.sms': permissions && permissions.campaign_create,
	        'campaigns.edit.team': permissions && permissions.campaign_create,
	        'campaigns.edit.whatsapp': permissions && permissions.campaign_create,
	        'campaigns.edit.landing': permissions && permissions.campaign_create,
	        'campaigns.edit.education': permissions && permissions.campaign_create,
	        'campaigns.edit.schedule': permissions && permissions.campaign_create,
	        'campaigns.edit.review': permissions && permissions.campaign_create,
	        '/report/allcampaigns': permissions && permissions.campaign_reports,
	        '/bulk/campaigns': permissions && permissions.campaign_schedule,
	        'bulk_campaigns.schedule': permissions && permissions.campaign_schedule,
	        '/campaigns': permissions && permissions.campaign_view,
	        'report.recipientlistinglogs': permissions && permissions.campaign_view,
	        'preview': permissions && permissions.campaign_view,
	        'report.campaignreporting': permissions && permissions.campaign_view,
	        '/setting/oopspage': permissions && permissions.data_entry_oops_page,
	        '/managementreport/departmentcompromise': permissions && permissions.department_compromise,
	        '/newreports/VulnerabilityReport-DepartmentWiseUniqueEmployees': permissions && permissions.departments_new,
	        '/vcro/all-departments-risk-score': permissions && permissions.departments_vcro,
	        'vcro.department_risk_score': permissions && permissions.departments_vcro,
	        '/managementreport/designationcompromise': permissions && permissions.designation_compromise,
	        '/newreports/VulnerabilityReport-DesignationWiseUniqueEmployees': permissions && permissions.designations_new,
	        '/reports/campaigns-detailed-report': permissions && permissions.detailed_new,
	        '/report/detailed': permissions && permissions.detailed_report,
	        '/company/domains': permissions && permissions.domains,
	        '/setting/email': permissions && permissions.email_settings,
	        '/setting/reply-to-credentials': permissions && permissions.email_settings,
	        '/setting/directlearning': permissions && permissions.enrolments,
	        'directlearning_recipient': permissions && permissions.enrolments,
	        '/setting/general': permissions && permissions.general,
	        '/vcro/all-groups-risk-score': permissions && permissions.groups_vcro,
	        'vcro.group_risk_score': permissions && permissions.groups_vcro,
	        '/managementreport/highrisk': permissions && permissions.high_risk_users,
	        '/setting/HRIS-VSMS': permissions && permissions.hris_vsms_directory_service,
	        '/setting/HRIS-VSMS-logs': permissions && permissions.hris_vsms_directory_service_logs,
	        'HRISandVSMsingleLogs': permissions && permissions.hris_vsms_directory_service_logs,
	        '/settings/ignore-list': permissions && permissions.ignore_ip_list,
	
	        '/import_reporters': permissions && permissions.import_reporters,
	        '/settings/import-trained-users': permissions && permissions.import_trained_users,
	        '/settings/external-training-modules': permissions && permissions.import_trained_users,
	        '/reports/laggards': permissions && permissions.laggardsnew,
	        '/setting/master_landing': permissions && permissions.landing_page_templates,
	        '/reports/leaderboard': permissions && permissions.leaderboard_new,
	        '/setting/leaderboardsetting': permissions && permissions.leaderboard_settings,
	        'lms': permissions && permissions.lms,
	        '/recipients/manage-groups': permissions && permissions.manage_groups,
	        '/settings/notifications': permissions && permissions.notifications,
	
	        '/settings/system-alerts': true,
	        'systemAlerts': true,
	        '/vcro/organisation-risk-score': permissions && permissions.organisation_vcro,
	        '/setting/books': permissions && permissions.passing_percentage,
	        '/reports/phishingcampaignsperformance': permissions && permissions.phishing_campaigns_new,
	        '/managementreport/reportingtrend': permissions && permissions.reporting_trend,
	        '/managementreport/phishingreportingtrend': permissions && permissions.reporting_trend_new,
	        '/setting/security': permissions && permissions.security,
	        '/training_settings': permissions && permissions.settings,
	        '/managementreport/strongest': permissions && permissions.strongest_links,
	        '/managementreport/strongestlinks-least-compromised': permissions && permissions.strongest_links_least_compromised_new,
	        '/managementreport/strongestlinks-most-reported': permissions && permissions.strongest_links_most_compromised_new,
	        '/setting/throttling_sending_speed': permissions && permissions.throttling_speed,
	        '/setting/training-languages': true,
	        'training_languages': true,
	        '/setting/dl_invitation_mail': permissions && permissions.training_invitation_mail,
	        '/setting/dl_login_with_password_mail': permissions && permissions.training_login_template,
	        '/bulkeducation': permissions && permissions.upload_modules,
	        '/setting/usermanagement': permissions && permissions.user_management,
	        '/vcro/all-users-risk-score': permissions && permissions.users_vcro,
	        'vcro.user_risk_score': permissions && permissions.users_vcro,
	        '/laggards': permissions && permissions.view_laggards,
	        '/leaderboard': permissions && permissions.view_leaderboard,
	        'trainingmoduleAdmin': permissions && permissions.is_education_editable,
	        '/trainingmodule': permissions && permissions.view_modules,
	        '/recipients': permissions && permissions.view_recepients,
	        'recipients.group': permissions && permissions.view_recepients,
	        'recipients.edit': permissions && permissions.view_recepients,
	        '/scenario': permissions && permissions.view_scenario,
	        '/imports/suppression': permissions && permissions.view_suppression,
	        '/managementreport/phishingvulnerability': permissions && permissions.vulnerability_trend,
	        '/managementreport/phishingvulnerabilitytrend': permissions && permissions.vulnerability_trend_new,
	        '/managementreport/departmentweakest': permissions && permissions.weakest_departments,
	        '/managementreport/weakestdepartments': permissions && permissions.weakest_departments_new,
	        '/managementreport/weakest': permissions && permissions.weakest_links,
	        '/managementreport/weakestlinks': permissions && permissions.weakest_links_new,
	        '/setting/changepassword': permissions && permissions.change_password,
	        'dashboard.weakestlinkuser': permissions && permissions.dashboard,
	        '/report/hcsa_hisp': permissions && permissions.dashboard,
	        '/reported/pluginusers': permissions && permissions.dashboard,
	        '/gamification-engine/badges': permissions && permissions.gamification_badges,
	        '/gamification-engine/add-badge': permissions && permissions.gamification_add_badgee,
	        'gamification.edit_badge': permissions && permissions.gamification_add_badgee,
	        'gamification-engine/award-log': permissions && permissions.gamification_award_log,
	        '/gamification-engine/points': permissions && permissions.gamification_set_points,
	        'gamification.award_log': permissions && permissions.gamification_award_log,
	        'gamification.award_log_all': permissions && permissions.gamification_award_log,
	        'userportal_new': permissions && permissions.dashboard || true,
	        '/userportal/view-as': permissions && permissions.dashboard || true,
	        '/userportal/customise': permissions && permissions.dashboard || true,
	        '/gamification-engine/default-notification-email-settings': permissions && permissions.dashboard || true,
	        'report.campaignfiledreports': true,
	        'managementreport.repeatoffenders': true,
	        '/userportal/news-updates': permissions && permissions.dashboard || true,
	        '/userportal/customise-login-page': permissions && permissions.dashboard || true,
	        '/logs/index': permissions && permissions.dashboard || true,
	        '/exported-files': permissions && permissions.dashboard || true,
	        '/settings/ignore-list/audit-log': true,
	        '/settings/ignore-list/ignored-activities': true,
	        '/settings/ignore-list/add-source': true,
	        '/settings/ignore-list/suppression-logs': true,
	        'report.view_log': true,
	        '/teamportal': true,
	        '/teamportal/customise': true,
	        '/teamportal/view-as': true,
	        '/announcementslive': true,
	        '/userportal-v2/en': true,
	        '/userportal-v2/ar': true,
	        '/userportal-v2/customise': permissions && permissions.dashboard || true,
	        '/userportal-v2/view-as': permissions && permissions.dashboard || true,
	        '/userportal-v2/news-updates': permissions && permissions.dashboard || true,
	        '/userportal-v2/customise-login-page': permissions && permissions.dashboard || true,
	        '/setting/channel-credentials': true,
	        '/schedule-calendar': true,
	        '/policy/create': permissions && permissions.policy_create,
	        '/policy': permissions && permissions.policy_view,
	        '/setting/customize-admin-login': true,
	        'notificationDescription': true,
	        'O365Setup': true,
	        '/create-needle-phishing': true,
	        '/settings/ai-setting': true,
	        '/add-agreement': true,
	        '/agreement-details': true,
	        '/adobe-auth': true,
	        '/view-agreements': true,
	        'agreement.details': true,
	        '/settings/pdf-campaign': true,
	        '/recipients/ou-settings': true,
	        '/ip-information/campaign': true,
	        '/ip-information/announcement': true,
	        '/settings/campaign-user-role': true,
	        '/creator-workspace': true,
	        '/approver-workspace': true,
	        '/campaigns/creator-workspace': true,
	        '/campaigns/approver-workspace': true,
	        '/announcements/creator-workspace': true,
	        '/announcements/approver-workspace': true,
	        '/policy/creator-workspace': true,
	        '/policy/approver-workspace': true
	
	    };
	}
	
	module.exports = {
	    setPermissions: setPermissions
	};

/***/ }),

/***/ 877:
/***/ (function(module, exports) {

	"use strict";
	
	function setColorCode() {
	    var storedColorCode = JSON.parse(localStorage.getItem("colorCode"));
	    var stroedColorInPermissiom = JSON.parse(localStorage.getItem("permissions"));
	}
	
	module.exports = {
	    setColorCode: setColorCode
	};

/***/ }),

/***/ 1043:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1055:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1066:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1067:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1083:
/***/ (function(module, exports) {

	module.exports = {"common":{"breadcrumb":{"home":"HOME","Directory":"Channel","server":"Channel Details","create_azure_ad_btn":"Add Channel Credentials"}},"create_azure_ad":{"title":{"header":"Channel credentials","desc":""},"btn":{"save":"Add","close":"Close","validate":"Validate"},"inputs":{"clientId":{"label":"Client Id","placeholder":"Enter Client Id"},"objectId":{"label":"Object Id","placeholder":"Enter Object Id"},"secretKey":{"label":"Secret Value","placeholder":"Enter Secret Value"},"status":{"label":"Status"}}},"update_azure_btn":{"update":"Update"}}

/***/ }),

/***/ 1084:
/***/ (function(module, exports) {

	module.exports = {"login":{"heading":{"login":"Login","forgot_password":"Forgot Password"},"humans_are_the_weakest_link":"Humans are the weakest link in Cyber Security.","now_make_it_the_strongest":"Now make it the strongest by deploying the HumanFirewall.","last_year_the_threat":"LAST YEAR THREAT VIA PHISHING ATTACKS INCREASED BY 400%!","email":"EMAIL","password":"PASSWORD","keep_me_logged_in":"Keep Me Logged In","forgot_password":"Forgot password?","error":"Error!","login":"Login","learning_login":"Request for Password","start_a_free_trial":"Start A Free Trial","email_address":"Email Address","please_check_your_email_password_reset":"Please check your email for instructions to reset your password.","reset_password":"Send Reset Instructions","back_to_login":"Back to Login","success":"Success: ","already_registered_with_us":"If you have already registered with us, you will receive an email with password reset instructions shortly.","your_registered_email_address":"Your registered email address","your_super_secret_password":"Your password","please_enter_your_email_here":"Please enter your email address"},"register":{"start_a_free_trial":"Register for Free Trial","register_secure_organization":"Register & Secure your organisation against phishing.","your_first_name":"Your First name","your_last_name":"Your Last Name","your_job_title":"Your Job Title","your_organisation":"Organization Name","number_of_employee":"Number of Employees","country":"Country","timezone":"Time Zone","lets_setup_your_account":"Let's setup your account credentials","email":"Email","password":"Password","re_type_password":"Confirm Password","i_agree":"By signing up, you agree to our ","terms":"","and":"","policy":"Terms & Privacy Policy.","create_a_new_account":"Create a new account","if_you_already_account":"If you already have an account","sign_in":"Login here","please_enter_your_first_name_here":"Please enter your first name","please_enter_your_last_name_here":"Please enter your last name","please_enter_your_job_title_here":"Please enter your job title","your_company_or_brand_name":"Your Company or Brand name","you_can_also_enter_a_guessed_value":"Please enter the number of employees","your_residence_country":"Your country","please_enter_your_email_here":"Please enter your email","please_enter_your_password_here":"Please enter your password","Please_re_type_your_password_here":"Please re-enter your password","domain_already_verified":"This domain is already verified and cannot be used again."},"verification":{"two_factor_authentication":"Two factor authentication","please_scan_this_qr_Code_image":"Please scan this QR Code in Google Authenticator App on your phone and enter the code generated.","please_enter_the_code_generated":"Please enter the code generated by Google Authenticator App.","you_can_download":"You can download the app for","ios_here":"iOS here","and_for":"and for ","android_here":"Android here","verification_code":"Verification code","activate_2fa_now":"Activate 2FA Now","skip_setup_2fa_later":"Skip & Setup 2FA Later","verify_proceed":"Verify & Proceed","please_enter_your_verification_code_here":"Please enter your verification code here.","something_went_wrong":"OOPS!! It seems something is not right!! Please try again."},"forgotpassword":{"new_password":"New Password","confirm_password":"Confirm Password","submit":"Submit","cancel":"Cancel","please_enter_your_password_here":"Please enter your password","please_re_type_your_password here":"Please re-enter your password"}}

/***/ }),

/***/ 1085:
/***/ (function(module, exports) {

	module.exports = {"import":{"name_not_entered":"Please enter file name.","file_not_selected":"Please select a file.","only_csv_file_is_allowed":"Only csv file is allowed."},"description":{"title_1":"Title","title_2":"title","description":"Description","proceed":"PROCEED","example_header":"Example:","example":{"title_header":"Example: {campaign} Title","title":"Phishing Training- Level 1 users - Finance Team","description_header":"Example: {campaign} Description","description":"This {campaign} is meant to train users to recognise Phishing emails by using URL recognition, specifically identifying the primary domain.","note":"Giving a unique name to your {campaign} will help you identify which email you sent, to which set of users and what was the objective of the campaign. "},"copyright":"Copyright &copy;","humanFirewall":"HumanFirewall","tm":"TM","all_rights_reserved":"All rights reserved.","www_humanfirewall":"www.humanfirewall.io"},"education":{"you_can_skip":"You can Skip this step.","skip_this_step":"Skip this step","learning":"Learning","super_hign_risk":"Super High Risks","basic_portlet_tools":"Basic Portlet tools include a slide toggle button ,refresh button  and a close button. All these are fully customizable and come with callback functions to integrate with your code. Clicking on the refresh button will simulate an AJAX call.","preview":"Preview","use_this":"Use This"},"email":{"please_select_any_recipient":"Please select Recipients for this {campaign}","please_select_atleast_recipient":"Please select at least one sheet.","sender_name":"Sender Name","email_subject":"Subject of the mail","sender":"Sender","email_domain":"Email Domain","please_select_a_domain_name":"Please select a domain name","please_select_reply_to email":"Please select a Reply to Email","personalise_subject_email":"You can personalise subject & email by adding custom tags","click_here_to_see_complete_list":"Click here to see the complete list of available tags","flag_email_as_urgent":"Flag email as urgent to get more attention from recipients","attachment_name":"Attachment Name","attachment_type":"Attachment Type","adobe_pdf":"Adobe PDF (.pdf)","microsoft_word":"Microsoft Word (.doc)","microsoft_excel":"Microsoft Excel (.xls)","preview_email_in_a_new_tab":"Preview email in a new tab","send_a_preview_email":"Send a test email","save_and_proceed":"SAVE AND PROCEED","send_test_email":"Send Test Email","name":"name","email":"Email","cancel":"Cancel","add_one_more_tester":"Add another email?","send_test_emails":"Send Test mail","select_recipients":"Select Recipients","a_make_believe_from_name":"Please enter sender's name","pick_a_domain_name_from_list":"Choose a domain name from the list","name_your_attachment_file":"Choose a name for your attachment ","email_sender_error":"Space is not allowed in sender","required":"Required"},"sms":{"from_name":"From Name","template":"Sms Template","preview_email_in_a_new_tab":"Preview SMS in a new tab"},"landing":{"you_can_skip_this_step":"You can skip this step.","skip_this_step":"SKIP THIS STEP","specify_landing_url":"Specify Landing URL","subdomain":"Subdomain","domain_name":"Domain Name","please_select_any_domain_name":"Please select a Domain Name","subdirectory_file":"Subdirectory / File","landing_content":"Landing Content","edit_landing_page":"Edit landing page","preview_in_a_new_tab":"Preview in a new tab","save_and_proceed":"SAVE AND PROCEED","a_make_believe_subdomain_name":"Please enter a subdomain name","pick_a_domain_name_from_list":"Choose a domain name from the list","a_make_believe_sub_directory_name":"Please enter a sub directory name"},"schedule":{"send_on":"Send On :","send_between":"Send Between","to":"to","send_count_per_day":"Send Count (per day)","how_long_do_you_want_scenario_active":"How long do you want this campaign to stay active?","how_long_do_you_want_announcement_active":"How long do you want this Announcement to stay active?","explain":"(explain)","your_scenario_content_tracking_active":"Your campaign's content and tracking will be available as long as your campaign is active.","while_we_typically_suggest_keeping_scenarios":"While we recommend keeping campaigns active for 5 to 7 days, we can accommodate as little as 1 day and as many as 30 days should your needs vary.","while_we_typically_suggest_keeping_announcement":"While we recommend keeping Announcement active for 5 to 7 days, we can accommodate as little as 1 day and as many as 30 days should your needs vary.","ok":"OK","please_select_one":"Please select one","total_number_of_recipients":"Total Number of recipients","i_agree_to_the":"I agree to the","terms_and_conditions":"terms & conditions","receive_daily_scenario":"Receive daily summary via email","receive_pdf_summary_report":"Receive PDF summary report","please_have_a_support1":"Please have a support professional review this scenario. NOTE: We will need atleast one full business day. We may need more time depending upon","please_have_a_support2":"your support plan! ","send_a_test_mail":"Send a Test Mail","send_a_test_campaign":"Send a Test Campaign","send_a_test_announcement":"Send a Test Announcement","email_summary":"E-mail Summary","send":"Send","action":"Action","now":"Now","schedule":"REVIEW & SCHEDULE","send_test_email":"Send Test Email","send_a_test_sms":"Send Test Message","name_1":"Name","email":"Email","sms":"Sms","phone":"Phone","name_2":"Name","cancel":"Cancel","add_one_more_tester":"Add another email?","add_one_more_sms_tester":"Add another SMS?","send_test_emails":"Send Test Email","send_test_sms":"Send Test SMS","auto_reminder_message":"Auto Reminder for mandatory training to be sent to people who"},"create":{"super_high_risk":"SUPER HIGH RISK","level":"Level","use_this":"Use This","preview":"Preview","filters_1":"FILTERS","filters_2":"Filters","method":"Method","data_entry":"Data Entry","qrcode":"QR Code","replybased":"Reply Based","attachment":"Attachment","click":"Click","announcement":"Announcement","levels":"Levels","level_1":"Level 1","level_2":"Level 2","level_3":"Level 3","level_4":"Level 4","level_5":"Level 5","apply":"Apply","close":"Close","motivator":"Motivator","general":"General","category":"Category","no_scenario":"No scenario found.","type":{"campaign_type":"Campaign Type","email":"Email","sms":"Sms","team":"Microsoft Teams","whatsapp":"Whatsapp"}},"index1":{"launch_a_new":" Add","prepare_your_organisation":"Create a new phishing attack simulation campaign ","prepare_your_organisation_announcement":"Create a new announcement ","pick_a_scenario":"Choose a Scenario","pick_a_scenario_campaign":"Choose Scenario","title_description":"Title & Description","email":"Email","team":"Microsoft Teams","sms":"Sms","whatsapp":"Whatsapp Message","landing_page":"Landing Page","education":"Education","schedule_publish":"Schedule","cancel":"Cancel"},"index2":{"back_to_campaigns":"Back to Campaigns","back_to_announcements":"Back to Announcements","manage":"Manage","no_recipient_added":"You have not added a recipient yet:","add_recipients":"Add Recipients","launch_a_new":"New Campaign","create_new_phishing_campaign":"Create a new phishing campaign.","launch_a_new_announcement":"New Announcement","draft":"Draft","you_have":"You have","ending_soon":"ending soon","launched_on":"STARTS","launched_for":"ENDS","title":"Title","description":"Description","email_sent":"Email Sent","sent":"Sent","channel":"Channel","opened":"Opened","not_opened":"Not Opened","clicked":"Clicked","submitted":"Submitted","compromised":"Compromised","acknowledged":"Acknowledged","trained":"Trained","level":"Level","status":"Status","edit":"Edit","no":"No","launched_yet":"launched yet.","found":"Found.","live":"Live","past":"Past","you_have_launched":"You have launched","in_total":"in total","recipient_count":"Recipients","before_loading":"Please wait while your campaigns load","before_loading_announcement":"Please wait while your announcements load","not_sent":"Not Sent","delivered":"Delivered","bounces":"Bounces","field":"Failed"},"test_mail":{"error_in_test_mail":"Error in sending test mail.","error_in_test_sms":"Error in sending test message.","success_in_test_mail":"Test mail sent successfully.","success_in_test_sms":"Test message sent successfully."},"bulk_campaign":{"error_in_date_conflict":"Campaign dates are confliciting.Please check and update dates.","error_early_schedule":"You cannot schedule campaigns within 1 hours of current time. Please reschedule the campaign","only_announcement_message":"You can select only announcements"},"scenario":{"before_loading":"Please wait while your scenarios load","file_select_error":"Please select thumbnail image."}}

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

	module.exports = {"index":{"add":"Add","add_new_domain":"Add New Domain","action":"Action","create_new_domain":"Please enter the name of your domain.","click_on_download_button":"Download the TXT file by clicking on the download button. You can upload the file using your preferred FTP client.","click_on_verify_button":"Then click on the verify button","close":"Close","domain_name":"Domain Name","domain_link":"Domain URL","domain":"Domain","download":"Download","domains_1":"Domains","domains_2":"domains.","domain_verification_steps":"Domain Verification Steps","enter_your_domain":"Enter your Domain details.","entries":"entries","home":"Home","new":"Add New","of":"of","step_1":"Step:1","step_2":"Step:2","step_3":"Step:3","showing":"Showing","sr_no":"Sr. No.","you_have_added":"You have added","verification_status":"Verification Status","1_to":"1 to","name_of_your_domain":"Domain Name","example_www_yourdomain_com":"Example: www.yourdomain.com"}}

/***/ }),

/***/ 1087:
/***/ (function(module, exports) {

	module.exports = {"common":{"home":"Home","userPortal":"User Portal","customise":"Customise"},"customize":{"customiseUserPortal":"Customise User Portal","infoHeading1":"This common customisation applies to the User Portal of all users.","infoHeading2":"Set the cover image, enable/disable sections that you would like to display on the User Portal.","coverImage":"Cover Image","imageInfo":"Upload a cover image that you would like to be displayed as the cover image on the User Portal.","changeImage":"Change image","supportedFormats":"Supported formats: jpg, jpeg, png. Maximum file size: 2MB. Best fit size: 1920x280 px.","employeeDetails":"Employee Details","employeeDetailsInfo":"Enable/disable the display of employee details information blocks that you would like to be displayed on the User Portal.","department":"Department","points":"Points","riskScore":"Risk Score","certificates":"Certificates","awardedBadges":"Awarded Badges","awardedSections":"Enable/disable the display of badges awarded sections.","Total_Leaderboard_Points_Earned":"Total Leaderboard Points Earned","Completed_Training_Module":"Completed Training Module","Total_Phishing_Campaign_Email_Reported":"Total Phishing Campaign Email Reported","Total_Real_Phishing_Email_Reported":"Total Real Phishing Email Reported","Total_Training_Modules_Completed":"Total Training Modules Completed","Used_Reporter_Button_First_Time":"Used Reporter Button First Time","myCourses":"My Courses","trainingModulesSections":"Enable/disable the display of sections related to training modules.","assigned":"Assigned","pending":"Pending","completed":"Completed","notStarted":"Not Started","inProgress":"In Progress","ExpiredDeleted":"Expired","leaderboard":"Leaderboard","leaderboardPoints":"Enable/disable the display of sections related to leaderboard points.","organisation":"Organisation","allDepartments":"All Departments","activitiesPoints":"Activities & Points","activitiesPointsDesc":"Enable/disable the display of the ‘Activities & Points’ section. This section displays all the activities of the employee for which s/he was awarded points.","badges":"Badges","badgesDesc":"Enable/disable the display of the ‘Badges’ section. This section displays a list of all the badges awarded to the employee.","certificatesDesc":"Enable/disable the display of the ‘Certificates’ section. This section displays a list of all the certificates awarded to the employee.","pleaseWait":"Please Wait...","save":"Save"}}

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

	module.exports = {"common":{"breadcrumb":{"home":"HOME","settings":"SETTINGS","gamification_engine":"GAMIFICATION ENGINE"}},"badges":{"breadcrumb":{"badges":"BADGES"},"title":{"header":"Badges - Gamification Engine","desc":"Manage badges and their association with events. Badges will be awarded to employees based on the associations defined here."},"btn":{"points":"Set points","award_log":"View award log","badges":"BADGE"},"table":{"header":{"status":{"title":"STATUS","desc":"Status of the badge."},"name_desc":{"title":"BADGE NAME & DESCRIPTION","desc":"Name and description of the badge."},"event":{"title":"EVENT","desc":"The associated milestone event based on which the badge will be awarded."},"total":{"title":"TOTAL","desc":"Total points or the total number of milestone events. The badge will be awarded to employees when they achieve this."},"training_module":{"title":"TRAINING MODULE NAME","desc":"Name of the training module associated with the badge. The badge will be awarded to employees when they complete the associated training module."},"awarded":{"title":"AWARDED TO","desc":"Number of employees to whom this badge has been awarded."},"created_on":{"title":"CREATED ON","desc":"Date and time when the badge was created."},"created_by":{"title":"CREATED BY","desc":"Name and Email ID of the user who created the badge."}}}},"add_badges":{"breadcrumb":{"add_badges":"ADD BADGE"},"title":{"header":"Add Badge - Gamification Engine","desc":"Add a badge and associate it to the event. The badge will be awarded to an employee on the occurrence of the associated event."},"btn":{"save":"Save","reset":"Reset","upload_new_badge":"Upload New Badge Icon","change_certi":"Change"},"inputs":{"badge_name":{"label":"BADGE NAME","placeholder":"Enter the badge name"},"description":{"label":"DESCRIPTION","placeholder":"Enter a meaningful description that will help explain the purpose of this badge"},"selected_badege":{"label":"Selected Badge","placeholder":""},"badge_library":{"label":"Badge Image Library","placeholder":""},"select_event":{"label":"SELECT EVENT","placeholder":"","desc":"Select the event to which you would like to associate the badge."},"total_points":{"label":"TOTAL POINTS","total":"TOTAL","placeholder":"","Total Leaderboard Points Earned":"Enter total points earned.","Total Training Modules Completed":" ","Total Phishing Campaign Email Reported":"Enter total phishing campaigns reported.","Total Real Phishing Email Reported":" "},"training_module_name":{"label":"Training Module Name","placeholder":"","desc":"Select the name of the training module."},"sender_name":{"label":"SENDER NAME","placeholder":""},"sender_email":{"label":"SENDER EMAIL ID","placeholder":""},"smtp":{"label":"SMTP","placeholder":""},"subject":{"label":"SUBJECT","placeholder":""},"messages":{"label":"MESSAGES","placeholder":""},"userName":{"label":"User Name","placeholder":""},"userNameXposition":{"label":"X Position","placeholder":""},"userNameYposition":{"label":"Y Position","placeholder":""},"badgeName":{"label":"Badge Name","placeholder":""},"badgeXpostion":{"label":"X Position","placeholder":""},"badgeYpostion":{"label":"Y Position","placeholder":""}},"inner_heading_event":{"badge":"Badge","event":"Event","desc":"Associate the badge to a milestone event of the employee."},"inner_heading_Notify":{"notify":"Notify Employee","desc":"Notify employees when badge is awarded to them."},"inner_heading_Certificate":{"Certificate":"Badge Award Certificate","desc":"Enable this to send a certificate along with the notification email. The certificate template pdf must have the following five placeholder fields - employee_name, badge_name, award_date, company_logo, badge_image. Please contact your customer success manager if you need assistance."},"inner_heading_CertificateXYPosition":{"Certificate":"Use fixed x,y position on the certificate template.","desc":"It's recommended to use fixed x,y positions on the certificate template to properly align Employee Name & Badge Name on the certificate for the languages that use the right-to-left script.","desc1":" Please do not change the default values of x,y position if you are using the default certificate.","desc2":"If you are using customised certificate template, please set these values accordingly."}},"edit_badges":{"breadcrumb":{"add_badges":"EDIT BADGES"},"title":{"header":"Edit Badge - Gamification Engine","desc":"Edit the badge and its association with the event. The badge will be awarded to an employee on the occurrence of the associated event."}},"award_log":{"breadcrumb":{"award_log":"Award Log"},"title":{"header":"Award Log - Gamification Engine","desc":"Log of all the badges and points awards. Detailed log of when the badge or points was awarded, to whom it was awarded, and for what activity or milestone event it was awarded."},"tab_header":{"badge":"Badge Award Log","point":"Points Award Log"}},"points_log":{"btn":{"add_filter":"Add Filter","clearValInFilter":"Clear","addValueInFilter":"Add","applyDateFilter":"Apply","applyFilter":"Apply"},"tableHeader":{"date&time":{"header":"Date & Time","title":""},"points":{"header":"Points","title":""},"employee_name":{"header":"Employee Name","title":""},"activity":{"header":"Activity","title":""},"activity_source":{"header":"ACTIVITY SOURCE","title":""},"activity_source_name":{"header":"ACTIVITY SOURCE NAME","title":""},"training_module_name":{"header":"TRAINING MODULE NAME","title":""},"email_subject":{"header":"EMAIL SUBJECT","title":""}}},"badge_log":{"btn":{"add_filter":"Add Filter","clearValInFilter":"Clear","addValueInFilter":"Add","applyDateFilter":"Apply","applyFilter":"Apply"},"tableHeader":{"date&time":{"header":"Date & Time","title":"Date and time when the badge was awarded."},"badgeName":{"header":"BADGE NAME","title":"Name of the badge."},"employee_name":{"header":"Employee Name","title":"Name of the employee."},"event":{"header":"EVENT","title":"Name of the associated milestone event for which the badge was awarded."},"total":{"header":"TOTAL","title":"Total of the associated milestone event achieved by the employee. Total points earned or total phishing campaign emails reported or total real phishing email reported."},"training_module_name":{"header":"TRAINING MODULE NAME","title":"Name of the training module completed when the associated milestone event is ‘Completed Training Module’."}}},"points":{"breadcrumb":{"points":"POINTS"},"title":{"header":"Points, Gamification Engine - Settings","desc":"Manage points for employee activities and remediation action of employee reported emails. Points will be awarded to employees based on their activities on HumanFirewall and for the remediation actions performed by the Information Security team through the EmailRemediator platform on the emails reported by the employee based on the points specified here."},"phishing":{"header":"PHISHING CAMPAIGN","desc":"Set the points to be awarded for user's activities on phishing campaigns.","open":{"label":"OPEN","placeholder":"0"},"click":{"label":"CLICK","placeholder":"0"},"compromised":{"label":"COMPROMISED","placeholder":"0"},"reported":{"label":"REPORTED","placeholder":"0"},"trained":{"label":"TRAINED","placeholder":"0"},"evaluated":{"label":"EVALUATED","placeholder":"0"},"risk_level":{"label":"RISK LEVEL","placeholder":"0"}},"announcement":{"header":"ANNOUNCEMENT CAMPAIGN","desc":"Set the points to be awarded for user's activities on announcement campaigns.","open":{"label":"OPEN","placeholder":"0"},"click":{"label":"CLICK / ACKNOWLEDGED","placeholder":"0"},"trained":{"label":"TRAINED","placeholder":"0"},"evaluated":{"label":"EVALUATED","placeholder":"0"}},"reporting":{"header":"REPORTING/REMEDIATION ACTION","desc":"Set the points to be awarded for reporting suspicious emails by the user based on the remediation action taken.","OPEN":{"label":"OPEN","placeholder":"0"},"delete":{"label":"DELETE","placeholder":"0"},"trash":{"label":"TRASH","placeholder":"0"},"quarantine":{"label":"QUARANTINE","placeholder":"0"},"label":{"label":"LABEL","placeholder":"0"},"archive":{"label":"ARCHIVE","placeholder":"0"},"report_to_soc":{"label":"REPORT TO SOC","placeholder":"0"}}}}

/***/ }),

/***/ 1089:
/***/ (function(module, exports) {

	module.exports = {"leaderboard":{"add_recipient_1st":"add recipient","department":"Department","designation":"Designation","email":"Email","filter_by_loction":"Filter by loction","filter_by_department":"Filter by Department","filter_by_designation":"Filter by Designation","name":"Name","import_recipients":"Import Recipients","last_name":"Last Name","location":"Location","no_recipient":"No Recipient","leader_1":"Leaderboard","recipients_2":"recipients","recipient":"recipient","registered_with_us":"registered with us.","s_no":"Sr.no","to_run_phishing_before_text":"Please","to_run_phishing_after_text":"before running Phishing, Simulation or Announcements.","you_have":"You have","search":"Search","by_location":"By Location","by_department":"By Department","by_designation":"By Designation","error_on_location":"Please enter your location","error_on_designation":"Please enter your designation","error_on_department":"Please enter your department","error_on_sheet":"Please enter a name for the sheet","action":"Action","total_score":"Total Score","domain_verify":"Please verify your domain before uploading the recipient list."},"import":{"add":"Add","action":"Action","close":"Close","download":"Download","download_sample_sheet":"Download sample sheet","imported_sheets":"View Recipents Lists","import_new_sheet":"Import New Sheet","imported_by":"Imported By","imported_on":"Imported On","in_total":"in total","import_sheet":"Import Sheet","import_your_sheet":"Import your sheet","name":"name","no_sheet":"no sheet","please_download_sample_sheet":"Please download the sample sheet before uploading. Please ensure that you do not remove the headers.","recipients_count":"Add Count","recipients_update_count":"Update Count","sheet":"sheet","sheets":"sheets","sheet_name":"Sheet Name","status":"Status","you_have_imported":"You have imported","name_of_sheet":"Name of sheet"},"edit":{"action":"Action","campaign_name":"Campaign Name","cancel":"Cancel","designation":"Designation","department":"Department","edit":"Edit","email_id":"Email ID","export":"Export","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","edit_user_information":"Edit User Information","first_name":"First Name","filter_by_date":"Filter by date","id":"Id","location":"Location","last_name":"Last Name","phone_no":"Phone No.","report_list":"Report List","submit":"Submit","time_in_gmt":"Time","no_results":"No results found.","search":"Search","pick_a_date":"Pick a date","clicked":"Clicked","report":"Report","trained":"Trained","compromised":"Compromised","total":"Total"}}

/***/ }),

/***/ 1090:
/***/ (function(module, exports) {

	module.exports = {"recipient":{"add_recipient_1st":"add recipients","department":"Department","designation":"Designation","email":"Email","number":"Mobile Number","filter_by_loction":"Filter by loction","filter_by_department":"Filter by Department","filter_by_designation":"Filter by Designation","first_name":"First Name","import_recipients":"Import Recipients","last_name":"Last Name","location":"Location","no_recipient":"No Recipient","recipients_1":"Recipients","recipients_2":"recipients","recipient":"recipient","registered_with_us":"registered with us.","s_no":"S.no","to_run_phishing_before_text":"Please","to_run_phishing_after_text":"before creating campaign.","you_have":"You have","search":"Search","by_location":"By Location","by_department":"By Department","by_designation":"By Designation","error_on_location":"Please enter your location","error_on_designation":"Please enter your designation","error_on_department":"Please enter your department","error_on_sheet":"Please enter a name for the sheet","action":"Action","domain_verify":"Please verify your domain before uploading the recipient list."},"import":{"add":"Next","action":"Action","close":"Close","download":"Download","download_sample_sheet":"Download sample sheet","imported_sheets":"View Recipents Lists","import_new_sheet":"Import New Sheet","imported_by":"Imported By","imported_on":"Imported On","in_total":"in total","import_sheet":"Import Sheet","import_your_sheet":"Import your sheet","name":"name","no_sheet":"no sheet","please_download_sample_sheet":"Please download the sample sheet before uploading. Please ensure that you do not remove the headers.","recipients_count":"Add Count","recipients_update_count":"Update Count","sheet":"sheet","sheets":"sheets","sheet_name":"Sheet Name","status":"Status","you_have_imported":"You have imported","name_of_sheet":"Name of sheet"},"edit":{"action":"Action","campaign_name":"Campaign Name","cancel":"Cancel","designation":"Designation","department":"Department","reporting_manager_email":"Reporting Manager Email ID","edit":"Edit","email_id":"Email ID","export":"Export","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","edit_user_information":"Edit User Information","first_name":"First Name","filter_by_date":"Filter by date","id":"Id","location":"Location","last_name":"Last Name","phone_no":"Phone No.","report_list":"Report List","submit":"Submit","time_in_gmt":"Time","no_results":"No results found.","search":"Search","pick_a_date":"Pick a date","pleaseWait":"Please Wait"}}

/***/ }),

/***/ 1091:
/***/ (function(module, exports) {

	module.exports = {"campaignreporting":{"campaigns":"Campaigns","filter_by_date":"Filter by date","export":"Export","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","date":"Date","sent":"Sent","open":"Open","click":"Click","compromise":"Compromise","learning":"Learning","pick_a_date":"Select a date"},"recipientlisting":{"export":"Export","filter_by_date":"Filter by date","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","id":"Id","recipient_name":"Recipient Name","recipient_email":"Recipient Email","department":"Department","location":"Location","action":"Action","view_log":"View Log","search":"Search","pick_a_date":"Select a date"},"repeataffender":{"campaigns_report":"Campaigns Report","campaign_type":"Campaign Type","camapigns":"Camapigns","repeat_offenders":"Repeat Offenders","not_tested_yet":"Not Tested Yet","hi_3":"hi 3","campaigns_reporting":"Campaigns Reporting.","filter_by_status":"Filter by Status","sr_no":"Sr. No","title_description":"Title / Description","started":"Started","open":"Open","click":"Click","status":"Status","search":"Search","select_campaign":"Select Campaign"},"reporting":{"campaigns_report":"Campaigns Report","campaign_type":"Campaign Type","camapigns":"Camapigns","repeat_offenders":"Repeat Offenders","not_tested_yet":"Not Tested Yet","hi_3":"hi 3","campaigns_reporting":"Campaigns Reporting..","filter_by_status":"Filter by Status","sr_no":"Sr. No","title_description":"Title / Description","started":"Started","sent":"Sent","open":"Open","click":"Click","compromise":"Compromise","learning":"Learning","status":"Status","search":"Search","select_campaign":"Select Campaign"}}

/***/ }),

/***/ 1092:
/***/ (function(module, exports) {

	module.exports = {"breadcrumb":{"home":"HOME","directory":"Schedule Calendar"},"Heading":{"title":"Schedule Calendar","desc":"View, plan and manage your cybersecurity awareness campaigns more effectively with the help of Schedule Calendar."},"campaign_types":{"type1":"Phishing Campaigns","type2":"Announcement Campaigns","type3":"Training Enrollments(LMS)"}}

/***/ }),

/***/ 1093:
/***/ (function(module, exports) {

	module.exports = {"ignoreList":{"home":"Home","settings":"Settings","ignore_list":"Ignore List","manage_ignore_list":"Manage Ignore List","manage_ignore_list_title":"View and Manage Sandbox/Bot/Security Software False Positive Clicks or Actions to exclude or ignore those from your reports.","add_entity":"Add Entity","add_entity_title":"Add a new entity to Ignore List.","view_audit_log":"View Audit Log","view_audit_log_tooltip":"View Ignore List audit log."},"add_source":{"home":"Home","settings":"Settings","ignore_list":"Ignore List","title":"Add Source","title_desc":"Add a new source to the Ignore List.","desc":"Add a new source (IP Address) to the Ignore List. All user activities such as click, compromise etc. originating from the sources in the Ignore List will be ignored.","heading":"Add a new source to the Ignore List","heading_title":"Select the type of the source that you want to add to the Ignore List.","select_value":"Select Source Type","text_value":"IP Address","text_value_toletip":"IP Address.","text_placeholder":"Enter the IP Address in comma separated","ip_address_example":"Enter the IP Address in comma separated Ex: 127.0.0.1,126.0.0.1","add_title":"Add the source to the Ignore List","camapign_name_with_details":"(Campaign Name - Sent Datetime - Recepients Count)","camapign_name_with_details_text":" Select the campaign that you want to ignore activity from the given IP address.","select_campaign":"Please select campaign.","add":"Add","command_error":"Comments is required","comment_info":"Please specify the reason you want to add this IP address to the Ignore List.","text_value_error":"Enter a valid IP Address.","select_campagins":"Select Campaign"},"audit_log":{"title":"Audit Log","desc":"View the Ignore List update log to get detailed information  about any addition/removal of entities (IP Address) to the Ignored List","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","id":"Id","recipient_name":"Recipient Name","recipient_email":"Recipient Email","department":"Department","location":"Location","action":"Action","view_log":"View Log","search":"Search","pick_a_date":"Select a date"},"repeataffender":{"campaigns_report":"Campaigns Report","campaign_type":"Campaign Type","camapigns":"Camapigns","repeat_offenders":"Repeat Offenders","not_tested_yet":"Not Tested Yet","hi_3":"hi 3","campaigns_reporting":"Campaigns Reporting.","filter_by_status":"Filter by Status","sr_no":"Sr. No","title_description":"Title / Description","started":"Started","open":"Open","click":"Click","status":"Status","search":"Search","select_campaign":"Select Campaign"},"reporting":{"campaigns_report":"Campaigns Report","campaign_type":"Campaign Type","camapigns":"Camapigns","repeat_offenders":"Repeat Offenders","not_tested_yet":"Not Tested Yet","hi_3":"hi 3","campaigns_reporting":"Campaigns Reporting..","filter_by_status":"Filter by Status","sr_no":"Sr. No","title_description":"Title / Description","started":"Started","sent":"Sent","open":"Open","click":"Click","compromise":"Compromise","learning":"Learning","status":"Status","search":"Search","select_campaign":"Select Campaign"}}

/***/ }),

/***/ 1094:
/***/ (function(module, exports) {

	module.exports = {"common":{"breadcrumb":{"home":"HOME","Directory":"Azure Active Directory","server":"Azure Active Directory Details","create_azure_ad_btn":"Add Azure App Credentials"}},"create_azure_ad":{"title":{"header":"Azure app credentials","desc":""},"btn":{"save":"Add","close":"Close","validate":"Validate"},"inputs":{"clientId":{"label":"Client Id","placeholder":"Enter Client Id"},"objectId":{"label":"Object Id","placeholder":"Enter Object Id"},"secretKey":{"label":"Secret Value","placeholder":"Enter Secret Value"},"status":{"label":"Status"}}},"update_azure_btn":{"update":"Update"}}

/***/ }),

/***/ 1095:
/***/ (function(module, exports) {

	module.exports = {"common":{"home":"Home","title":"TEAM PORTAL","desc":" (You) team’s performance dashboard, org chart, phishing, training, leaderboard and risk score reports.","updates":"Updates"},"customize":{"title":"Customise Team Portal","desc":"Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit.","infoHeading2":"Set the cover image, enable/disable sections that you would like to display on the User Portal.","coverImage":"Cover Image","imageInfo":"Upload a cover image that you would like to be displayed as the cover image on the User Portal.","changeImage":"Change image","supportedFormats":"Supported formats: jpg, jpeg, png. Maximum file size: 2MB. Best fit size: 1920x280 px.","employeeDetails":"Employee Details","employeeDetailsInfo":"Enable/disable the display of employee details information blocks that you would like to be displayed on the User Portal.","department":"Department","points":"Points","riskScore":"Risk Score","certificates":"Certificates","awardedBadges":"Awarded Badges","awardedSections":"Enable/disable the display of badges awarded sections.","Total_Leaderboard_Points_Earned":"Total Leaderboard Points Earned","Completed_Training_Module":"Completed Training Module","Total_Phishing_Campaign_Email_Reported":"Total Phishing Campaign Email Reported","Total_Real_Phishing_Email_Reported":"Total Real Phishing Email Reported","Total_Training_Modules_Completed":"Total Training Modules Completed","Used_Reporter_Button_First_Time":"Used Reporter Button First Time","myCourses":"My Courses","trainingModulesSections":"Enable/disable the display of sections related to training modules.","assigned":"Assigned","pending":"Pending","completed":"Completed","notStarted":"Not Started","inProgress":"In Progress","ExpiredDeleted":"Expired","leaderboard":"Leaderboard","leaderboardPoints":"Enable/disable the display of sections related to leaderboard points.","organisation":"Organisation","allDepartments":"All Departments","activitiesPoints":"Activities & Points","activitiesPointsDesc":"Enable/disable the display of the ‘Activities & Points’ section. This section displays all the activities of the employee for which s/he was awarded points.","badges":"Badges","badgesDesc":"Enable/disable the display of the ‘Badges’ section. This section displays a list of all the badges awarded to the employee.","certificatesDesc":"Enable/disable the display of the ‘Certificates’ section. This section displays a list of all the certificates awarded to the employee.","pleaseWait":"Please Wait...","save":"Save"},"updates":{"heading":"Updates","subHeading":"View and manage updates for your employees. These updates will be highlighted on the User Portal under ‘Encouragement Board’ section.","sortBy":"Sort by","view":"View","updates":"Updates","updateBtn":"Update","till":"Till","created":"Created on","publish_onn":"Publish on","read_more":"Read more","edit":"Edit","archive":"Archive","unarchive":"Restore","no_data":"No data available","create_update":"Create Update","summary":"SUMMARY","headline":"HEADLINE","publish_on":"PUBLISH ON","publish_till":"PUBLISH TILL","read_more_link":"READ MORE LINK","headline_PHolder":"Enter the headline of update","summary_PHolder":"Enter the summary of update","read_more_link_PHolder":"Enter the read more link"},"customiseLoginData":{"admin_login_link":"Admin Login Link","admin_login_link_details":"Admin Login link takes the user to the login page for admin.","company_logo":"Company Logo","company_logo_details":"This section displays your company logo when the user portal login page is visited using your custom portal link.","magic_link_login":"Magic Link Login","magic_link_login_details":"This section allows users to request a magic link that gets sent to the registered official email id of the user. Users can click on the Magic Link sent to their registered official email id to easily and quickly login to the User Portal without the need to remember their password.","sso_login":"SSO Login","sso_login_details":"Enable the SSO login option used at your organisation.","smal":"SAML.","heading":"Customise Login Page","title_description":"Customise the User Portal login page. Enable sections relevant to your organisation you would like to keep on the User Portal login page.","features_highlight":"Features Highlight","features_highlight_details":"This section highlights the features benefits of the User Portal to encourage users to login.","smal_heading":"SAML Details","SAML2_AAD_IDP_HOST":"SAML2_AAD_IDP_HOST.","SAML2_AAD_IDP_ENTITYID":"SAML2_AAD_IDP_ENTITYID.","SAML2_AAD_IDP_SSO_URL":"SAML2_AAD_IDP_SSO_URL.","SAML2_AAD_IDP_SL_URL":"SAML2_AAD_IDP_SL_URL.","SAML2_AAD_IDP_x509":"SAML2_AAD_IDP_x509.","pleaseWait":"Please Wait...","save":"Save"},"customiseUserPortalLogin":{"heading1":"Humans are the weakest link in Cyber Security.","heading2":"Now make it the strongest by protecting yourself and others in your organisation.","heading_title":"Be the HumanFirewall of your organisation!.","admin_login":"Admin Login","magic_link_title":"Get the magic link to login to HumanFirewall User Portal","email_id":"EMAIL ID","email_id_placeholder":"Enter your official email id","logininfoList":{"one":"Couldn't send the magic link.","two":"Please ensure that you are entering your valid official email id.","three":"Please check that you are connected to the Internet.","five":"Wait for some time and retry. If the problem persists contact your Information Security team."},"send":"Send Magic Link.","pleaseWait":"Please Wait...","difficulty_logging":"Difficulty logging in? Contact your Information Security team.","or_sign_in_with":"Or sign in with"}}

/***/ }),

/***/ 1096:
/***/ (function(module, exports) {

	module.exports = {"common":{"home":"Home","userPortal":"User Portal","customise":"Customise","updates":"News Updates"},"customize":{"customiseUserPortal":"Customise User Portal","infoHeading1":"This common customisation applies to the User Portal of all users.","infoHeading2":"Set the cover image, enable/disable sections that you would like to display on the User Portal.","coverImage":"Cover Image","imageInfo":"Upload a cover image that you would like to be displayed as the cover image on the User Portal.","changeImage":"Change image","supportedFormats":"Supported formats: jpg, jpeg, png. Maximum file size: 2MB. Best fit size: 1920x280 px.","employeeDetails":"Employee Details","employeeDetailsInfo":"Enable/disable the display of employee details information blocks that you would like to be displayed on the User Portal.","department":"Department","points":"Points","riskScore":"Risk Score","certificates":"Certificates","awardedBadges":"Awarded Badges","awardedSections":"Enable/disable the display of badges awarded sections.","Total_Leaderboard_Points_Earned":"Total Leaderboard Points Earned","Completed_Training_Module":"Completed Training Module","Total_Phishing_Campaign_Email_Reported":"Total Phishing Campaign Email Reported","Total_Real_Phishing_Email_Reported":"Total Real Phishing Email Reported","Total_Training_Modules_Completed":"Total Training Modules Completed","Used_Reporter_Button_First_Time":"Used Reporter Button First Time","myCourses":"My Courses","trainingModulesSections":"Enable/disable the display of sections related to training modules.","assigned":"Assigned","pending":"Pending","completed":"Completed","notStarted":"Not Started","inProgress":"In Progress","ExpiredDeleted":"Expired","leaderboard":"Leaderboard","leaderboardPoints":"Enable/disable the display of sections related to leaderboard points.","organisation":"Organisation","allDepartments":"All Departments","activitiesPoints":"Activities & Points","activitiesPointsDesc":"Enable/disable the display of the ‘Activities & Points’ section. This section displays all the activities of the employee for which s/he was awarded points.","badges":"Badges","badgesDesc":"Enable/disable the display of the ‘Badges’ section. This section displays a list of all the badges awarded to the employee.","certificatesDesc":"Enable/disable the display of the ‘Certificates’ section. This section displays a list of all the certificates awarded to the employee.","pleaseWait":"Please Wait...","save":"Save"},"updates":{"heading":"News Updates","subHeading":"View and manage updates for your employees. These updates will be highlighted on the User Portal under ‘Encouragement Board’ section.","sortBy":"Sort by","view":"View","updates":"Updates","updateBtn":"News Update","till":"Till","created":"Created on","publish_onn":"Publish on","read_more":"Read more","edit":"Edit","archive":"Archive","unarchive":"Restore","no_data":"No data available","create_update":"Create News Update","summary":"SUMMARY","headline":"HEADLINE","publish_on":"PUBLISH ON","publish_till":"PUBLISH TILL","read_more_link":"READ MORE LINK","headline_PHolder":"Enter the headline of update","summary_PHolder":"Enter the summary of update","read_more_link_PHolder":"Enter the read more link"},"customiseLoginData":{"admin_login_link":"Admin Login Link","admin_login_link_details":"Admin Login link takes the user to the login page for admin.","company_logo":"Company Logo","company_logo_details":"This section displays your company logo when the user portal login page is visited using your custom portal link.","magic_link_login":"Magic Link Login","magic_link_login_details":"This section allows users to request a magic link that gets sent to the registered official email id of the user. Users can click on the Magic Link sent to their registered official email id to easily and quickly login to the User Portal without the need to remember their password.","login_crendential":"Login Credentials","sso_login_details":"Enable the SSO login option used at your organisation.","smal":"SAML.","sso":"SSO","heading":"Customise Login Page","title_description":"Customise the User Portal login page. Enable sections relevant to your organisation you would like to keep on the User Portal login page.","features_highlight":"Features Highlight","features_highlight_details":"This section highlights the features benefits of the User Portal to encourage users to login.","smal_heading":"SAML Details","SAML2_AAD_IDP_HOST":"SAML2_AAD_IDP_HOST.","SAML2_AAD_IDP_ENTITYID":"SAML2_AAD_IDP_ENTITYID.","SAML2_AAD_IDP_SSO_URL":"SAML2_AAD_IDP_SSO_URL.","SAML2_AAD_IDP_SL_URL":"SAML2_AAD_IDP_SL_URL.","SAML2_AAD_IDP_x509":"SAML2_AAD_IDP_x509.","pleaseWait":"Please Wait...","save":"Save"},"customiseUserPortalLogin":{"heading1":"Humans are the weakest link in Cyber Security.","heading2":"Now make it the strongest by protecting yourself and others in your organisation.","heading_title":"Be the HumanFirewall of your organisation!.","admin_login":"Admin Login","magic_link_title":"Get the magic link to login to HumanFirewall User Portal","email_id":"EMAIL ID","email_id_placeholder":"Enter your official email id","logininfoList":{"one":"Couldn't send the magic link.","two":"Please ensure that you are entering your valid official email id.","three":"Please check that you are connected to the Internet.","five":"Wait for some time and retry. If the problem persists contact your Information Security team."},"send":"Send Magic Link.","pleaseWait":"Please Wait...","difficulty_logging":"Difficulty logging in? Contact your Information Security team.","or_sign_in_with":"Or sign in with"}}

/***/ }),

/***/ 1165:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAuRJREFUWIXtV19IU3EU/s7v7o+FYZpU5ktZ9BD4UD31FPUeUpsropbL8kboTCJ7sGBBvYRYbGx2nTQLfOji7CF6joIIhHrpLfqHRBo1tERz6v2dHqYw5nZ317aC6Hu755z7fR/n9+eeC/xHmRCJDFcHtfjFfHWiXAYMxdlC4POBwBPbHzcQ1B5uZ8IVJjTUbElcNaulUgrruq5MTFMzAbcB2pSWipJiD3S0Nn0umwFNe7R2XiSjxDiG7J0dl5JOXjjnelaUgfCgvsOQqPe3eZ5my4c0vZEh7oGwezmUBKPbiUS/qqqLmfUF7wHJogUs/LnyHarnteFQDgJ4BwAgbvOr7mA2caDADui6rkxOi7cA6sSCqG9vP5LIVRuKjpxgRpe/zb3XjLOgDkx+Fx4AWwE4pUPm7AIALM7IOBHdzMdpuQPhsF5p2MVLADuXQ9MgavSfdX2yypENljrAzGTYKZYmDgDrwTwai8UqijGQtwPhsF65ZBdDBLhylLxiloc7Vc94SQ1ommafR80pIupBat3NaL4Bsven4ohcbm2aKcpA8I6+C4pQkbpQNhZCBmCGCKMginaccT238sKqPWAoNi5QdBWklJY5TJdgQdR6mbkHwLY8PF+JqXfOZusvegkykTp+FAPInZ2BXhgSri7VNVGIsGUDQOoYhgZHH4C5OeP1sXX2H/t9Pt/874gDFu8BIuKkc9YH4E1adAoEVzHilg0AwCWvdxaEwMozswya3YJ9ffqaUDR+tGQGAGBzldQBfASQVBaVkFmtUqm4mbm7pAY8Ho9BhGEwHpt9CSOR4WrBHACwJzgQbzHjNB0Ys0GQHDII9bnyIU1vNEjcZ6AhFWEtNDBS5eBEJNtM8NdHspJNxap6aK6uSnqJ6DjAX9JzxBggxb4vUxwo8VS8glt34w2KwWNgbGDma51qcyBXbVn+C7pOu96TxA0AH6Ymaq+b1Ra8Ca1CMZJDS0qFCAQOLJVL49/AL8mMEPRR5TAeAAAAAElFTkSuQmCC"

/***/ }),

/***/ 1172:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(541)
	
	/* template */
	var __vue_template__ = __webpack_require__(1618)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1402:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(776)
	
	/* template */
	var __vue_template__ = __webpack_require__(1461)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1410:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(786)
	
	/* template */
	var __vue_template__ = __webpack_require__(1431)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1067)
	
	/* script */
	__vue_exports__ = __webpack_require__(787)
	
	/* template */
	var __vue_template__ = __webpack_require__(1639)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a1aba226"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1413:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1066)
	
	/* script */
	__vue_exports__ = __webpack_require__(789)
	
	/* template */
	var __vue_template__ = __webpack_require__(1637)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9f361b70"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1414:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(790)
	
	/* template */
	var __vue_template__ = __webpack_require__(1435)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1415:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1055)
	
	/* script */
	__vue_exports__ = __webpack_require__(791)
	
	/* template */
	var __vue_template__ = __webpack_require__(1579)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-644abc84"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1416:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(1043)
	
	/* script */
	__vue_exports__ = __webpack_require__(792)
	
	/* template */
	var __vue_template__ = __webpack_require__(1536)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-49619a10"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1417:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(793)
	
	/* template */
	var __vue_template__ = __webpack_require__(1554)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1418:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(794)
	
	/* template */
	var __vue_template__ = __webpack_require__(1636)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1419:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(795)
	
	/* template */
	var __vue_template__ = __webpack_require__(1454)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(796)
	
	/* template */
	var __vue_template__ = __webpack_require__(1448)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(798)
	
	/* template */
	var __vue_template__ = __webpack_require__(1561)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(799)
	
	/* template */
	var __vue_template__ = __webpack_require__(1604)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(800)
	
	/* template */
	var __vue_template__ = __webpack_require__(1655)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1431:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1435:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "header"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "in_mobile"
	  }, [_c('div', {
	    staticClass: "brand inline d-none d-lg-block d-xl-block"
	  }, [(_vm.company_logo != '' && _vm.company_logo_exist == 1) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard.index'
	      }
	    }
	  }, [_c('img', {
	    staticClass: "logo_c",
	    attrs: {
	      "src": _vm.company_logo,
	      "alt": "logo",
	      "data-src": _vm.company_logo
	    },
	    on: {
	      "error": _vm.handleLogoError
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.company_logo == '' && _vm.company_logo_exist == 0) ? _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard.index'
	      }
	    }
	  }, [_c('img', {
	    staticClass: "logo_w",
	    attrs: {
	      "src": "/static/img/logo.svg",
	      "alt": "logo",
	      "data-src": "/static/img/logo.svg"
	    }
	  })]) : _vm._e()], 1)]), _vm._v(" "), (_vm.liveOrDemoStatus) ? _c('div', {
	    staticClass: "mode_alert m-auto"
	  }, [_vm._v("\n      Your account is in DEMO mode. To activate LIVE mode please contact your\n      customer success manager.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "d-flex align-items-center"
	  }, [(_vm.showOrNot === 2) ? _c('div', {
	    staticStyle: {
	      "white-space": "nowrap"
	    }
	  }, [_c('div', {
	    staticClass: "form-check form-check-inline success radioborder mr-2",
	    class: {
	      active: _vm.liveOrDemo == 'demo'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.liveOrDemo),
	      expression: "liveOrDemo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "state",
	      "id": "demo",
	      "value": "demo"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.liveOrDemo, "demo")
	    },
	    on: {
	      "change": [function($event) {
	        _vm.liveOrDemo = "demo"
	      }, _vm.showLiveOrDemo]
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "m-0",
	    attrs: {
	      "for": "demo"
	    }
	  }, [_vm._v("Demo")])]), _vm._v("\n         \n        "), _c('div', {
	    staticClass: "form-check form-check-inline success radioborder mr-3",
	    class: {
	      active: _vm.liveOrDemo == 'live'
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.liveOrDemo),
	      expression: "liveOrDemo"
	    }],
	    attrs: {
	      "type": "radio",
	      "name": "state",
	      "id": "live",
	      "value": "live"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.liveOrDemo, "live")
	    },
	    on: {
	      "change": [function($event) {
	        _vm.liveOrDemo = "live"
	      }, _vm.showLiveOrDemo]
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "m-0",
	    attrs: {
	      "for": "live"
	    }
	  }, [_vm._v("Live")])])]) : _vm._e(), _vm._v(" "), (this.currentURL == '/') ? _c('span', {
	    staticClass: "header_icon btn-icon-link",
	    attrs: {
	      "title": "Quick Start Guide",
	      "data-target": "#quickviewa",
	      "data-toggle": "modal"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-rocket"
	  })]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "header_icon btn-icon-link",
	    attrs: {
	      "id": "intro_siderbar",
	      "title": "Home screen menus walkthrough."
	    },
	    on: {
	      "click": _vm.startWalkthrough
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-running",
	    attrs: {
	      "data-placement": "bottom",
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), (!_vm.isHelpIconHidden(_vm.$route.path)) ? _c('span', {
	    staticClass: "header_icon btn-icon-link",
	    attrs: {
	      "id": "faq-btn",
	      "data-target": "#help",
	      "data-toggle": "modal",
	      "data-step": "10",
	      "data-intro": "Click here at any page to get your FAQs answered.",
	      "data-position": "bottom",
	      "title": "Contextual Help & FAQs."
	    }
	  }, [_c('i', {
	    staticClass: "far fa-question-circle"
	  })]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('system-alert-bell'), _vm._v(" "), _c('div', {
	    staticClass: "dropdown pull-right d-lg-block"
	  }, [_c('button', {
	    staticClass: "profile-dropdown-toggle logindetail_p",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false",
	      "aria-label": "profile dropdown"
	    }
	  }, [(_vm.currentUser) ? _c('div', {
	    staticClass: "logindetail"
	  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.titleCase(_vm.currentUser.first_name)) + "\n              "), (_vm.currentUser.last_name) ? _c('strong', [_vm._v("\n                " + _vm._s(_vm.titleCase(_vm.currentUser.last_name)) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.currentUser.company) + ")")])]) : _vm._e(), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu dropdown-menu-right profile-dropdown",
	    attrs: {
	      "role": "menu"
	    }
	  }, [(_vm.permissions.general) ? _c('li', [_c('router-link', {
	    staticClass: "m-t-10",
	    attrs: {
	      "to": {
	        name: 'general'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "pg-settings_small"
	  }), _vm._v(" Settings\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.status && _vm.status == 2 && _vm.company_id != _vm.selected_company) ? _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": _vm.updateAdminLogin
	    }
	  }, [_c('i', {
	    staticClass: "pg-outdent"
	  }), _vm._v(" Login As Admin")])]) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "bg-master-lighter",
	    on: {
	      "click": _vm.logoutUser
	    }
	  }, [_vm._m(3)])])])], 1)]), _vm._v(" "), (
	    _vm.managementReportQuickBtnpermissions.vulnerability_trend_new ||
	    _vm.managementReportQuickBtnpermissions.awareness_trend_new ||
	    _vm.managementReportQuickBtnpermissions.reporting_trend_new ||
	    _vm.managementReportQuickBtnpermissions.weakest_links_new ||
	    _vm.managementReportQuickBtnpermissions.strongest_links_least_compromised_new ||
	    _vm.managementReportQuickBtnpermissions.strongest_links_most_compromised_new ||
	    _vm.managementReportQuickBtnpermissions.weakest_departments_new
	  ) ? _c('div', {
	    class: _vm.quickmenu + ' quickview-wrapper builder hidden-sm hidden-xs',
	    attrs: {
	      "id": "builder"
	    }
	  }, [_c('a', {
	    staticClass: "builder-close",
	    attrs: {
	      "data-toggle": "quickview",
	      "data-toggle-element": "#builder"
	    },
	    on: {
	      "click": function($event) {
	        _vm.quickview()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-times"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "builder-toggle",
	    attrs: {
	      "id": "quickview-btn",
	      "data-intro": "Management Level Reporting of your data. Get easy answers.",
	      "data-position": "left",
	      "data-toggle": "quickview",
	      "data-toggle-element": "#builder",
	      "title": "Management Report"
	    },
	    on: {
	      "click": function($event) {
	        _vm.quickview()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "far fa-file-pdf"
	  })]), _vm._v(" "), _c('h4', {
	    staticClass: "filters_h_tag"
	  }, [_vm._v("Management Report")]), _vm._v(" "), _c('div', {
	    staticClass: "filter_slide_popup"
	  }, [_c('ol', {
	    staticClass: "report_link_list"
	  }, [(_vm.managementReportQuickBtnpermissions.vulnerability_trend_new) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.phishingvulnerabilitytrend'
	      }
	    }
	  }, [_c('a', {
	    class: {
	      active:
	        _vm.currentRouteName ==
	        'managementreport.phishingvulnerabilitytrend',
	    }
	  }, [_vm._v("\n            What does our Phishing Vulnerability trend look like?")])]) : _vm._e(), _vm._v(" "), (_vm.managementReportQuickBtnpermissions.awareness_trend_new) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.cybersecurityawarenesstrend'
	      }
	    }
	  }, [_c('a', {
	    class: {
	      active:
	        _vm.currentRouteName ==
	        'managementreport.cybersecurityawarenesstrend',
	    }
	  }, [_vm._v("What does our Awareness Trend look like?")])]) : _vm._e(), _vm._v(" "), (_vm.managementReportQuickBtnpermissions.reporting_trend_new) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.phishingreportingtrend'
	      }
	    }
	  }, [_c('a', {
	    class: {
	      active:
	        _vm.currentRouteName == 'managementreport.phishingreportingtrend',
	    }
	  }, [_vm._v("What does our Reporting trend look like?")])]) : _vm._e(), _vm._v(" "), (_vm.managementReportQuickBtnpermissions.weakest_links_new) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.weakestlinks'
	      }
	    }
	  }, [_c('a', {
	    class: {
	      active: _vm.currentRouteName == 'managementreport.weakestlinks',
	    }
	  }, [_vm._v("Who are our weakest links?")])]) : _vm._e(), _vm._v(" "), (
	    _vm.managementReportQuickBtnpermissions.strongest_links_least_compromised_new
	  ) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.strongestlinks-least-compromised'
	      }
	    }
	  }, [_c('a', {
	    class: {
	      active:
	        _vm.currentRouteName ==
	        'managementreport.strongestlinks-least-compromised',
	    }
	  }, [_vm._v("Who are our strongest links? (Least Compromised)")])]) : _vm._e(), _vm._v(" "), (
	    _vm.managementReportQuickBtnpermissions.strongest_links_most_compromised_new
	  ) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.strongestlinks-most-reported'
	      }
	    }
	  }, [_c('a', {
	    class: {
	      active: _vm.currentRouteName == 'strongestlinks-most-reported',
	    }
	  }, [_vm._v("Who are our strongest links? (Most Reported)")])]) : _vm._e(), _vm._v(" "), (_vm.managementReportQuickBtnpermissions.weakest_departments_new) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.weakestdepartments'
	      }
	    }
	  }, [_c('a', {
	    class: {
	      active:
	        _vm.currentRouteName == 'managementreport.weakestdepartments',
	    }
	  }, [_vm._v("Which of our departments are the weakest?")])]) : _vm._e()], 1)])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "hamburger"
	  }, [_c('i', {
	    staticClass: "fas fa-bars"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "theme_change btn-icon-link",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-sun"
	  }), _c('i', {
	    staticClass: "far fa-moon"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "thumbnail-wrapper d32 circular inline"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/dummy_user.png",
	      "alt": "",
	      "data-src": "/static/img/dummy_user.png",
	      "width": "32",
	      "height": "32"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "clearfix pointer"
	  }, [_c('span', {
	    staticClass: "pull-left"
	  }, [_vm._v("Logout")]), _vm._v(" "), _c('span', {
	    staticClass: "pull-right"
	  }, [_c('i', {
	    staticClass: "pg-power",
	    staticStyle: {
	      "padding": "11px"
	    }
	  })])])
	}]}

/***/ }),

/***/ 1448:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "thumbnail_card"
	  }, [_c('div', {
	    staticClass: "imgbox"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.education.thumbnail
	    }
	  })]), _vm._v(" "), _c('h3', {
	    staticClass: "thumbnail_title",
	    attrs: {
	      "title": _vm.education.title
	    }
	  }, [_vm._v(_vm._s(_vm.education.title))]), _vm._v(" "), _c('p', {
	    staticClass: "thumbnail_desc m-0 oneline_text"
	  }, [_vm._v(_vm._s(_vm._f("truncate")((_vm.education.description.length < 100) ? _vm.education.description : _vm.education.description, 100)))]), _vm._v(" "), _c('div', {
	    staticClass: "card_footer_btn"
	  }, [_c('button', {
	    staticClass: "btn hf-btn-info card_btn_w btn_h",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.getScenarioByEducation(_vm.education.id)
	      }
	    }
	  }, [_vm._v("Use This")])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1454:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade stick-up",
	    attrs: {
	      "id": 'editCampaign_' + _vm.id,
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-hidden": "true"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg",
	    staticStyle: {
	      "width": "80%"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header clearfix text-left",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('h5', {
	    staticClass: "font-montserrat text-complete"
	  }, [_vm._v(_vm._s(_vm.campaignData.scenario.name) + "\n                    "), _c('i', {
	    staticClass: "fa fa-chevron-right"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "hint-text m-t-10 small"
	  }, [_vm._v(_vm._s(_vm.campaignData.scenario.description))])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 no-padding"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "panel p-t-30 p-b-30"
	  }, [_c('div', {
	    staticClass: "panel-body no-padding"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.data.emailTemplate) ? _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h4', {
	    staticClass: "font-montserrat"
	  }, [_vm._v("Email body\n                                                ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('froala', {
	    attrs: {
	      "tag": 'textarea',
	      "config": _vm.froala_config
	    },
	    model: {
	      value: (_vm.data.emailTemplate.file),
	      callback: function($$v) {
	        _vm.$set(_vm.data.emailTemplate, "file", $$v)
	      },
	      expression: "data.emailTemplate.file"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h4', {
	    staticClass: "font-montserrat"
	  }, [_vm._v("Landing page preview\n                                                ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('froala', {
	    attrs: {
	      "tag": 'textarea',
	      "config": _vm.froala_config
	    },
	    model: {
	      value: (_vm.data.landingTemplate.file),
	      callback: function($$v) {
	        _vm.$set(_vm.data.landingTemplate, "file", $$v)
	      },
	      expression: "data.landingTemplate.file"
	    }
	  })], 1), _vm._v(" "), (_vm.data.educationTemplate) ? _c('div', {
	    staticClass: "col-md-12 m-t-40"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "panel panel-default scen"
	  }, [_c('div', {
	    staticClass: "panel-heading"
	  }, [_c('h5', {
	    staticClass: "bold"
	  }, [_vm._v(_vm._s(_vm.data.educationTemplate.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "panel-body"
	  }, [_c('div', {
	    staticClass: " p-b-5"
	  }, [_c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": _vm.data.educationTemplate.link
	    }
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "scenarios_description"
	  }, [_vm._v(_vm._s(_vm.data.educationTemplate.description) + "\n                                                        ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h4', {
	    staticClass: "font-montserrat"
	  }, [_vm._v("Sending Details\n                                                ")]), _vm._v(" "), _c('form', {
	    attrs: {
	      "role": "form"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group form-group-default"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t("campaign.email.sender_name")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|alpha_spaces'),
	      expression: "'required|alpha_spaces'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.campaignData.from_name),
	      expression: "campaignData.from_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "from_name",
	      "placeholder": "A make believe from full name.. e.g. John Smith"
	    },
	    domProps: {
	      "value": (_vm.campaignData.from_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.campaignData, "from_name", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('from_name')),
	      expression: "errors.has('from_name')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("\n                                                                    " + _vm._s(_vm.errors.first('from_name')) + "\n                                                                ")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group form-group-default"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t("campaign.email.email_subject")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.campaignData.subject),
	      expression: "campaignData.subject"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "subject",
	      "placeholder": "A make believe from name.."
	    },
	    domProps: {
	      "value": (_vm.campaignData.subject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.campaignData, "subject", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('subject')),
	      expression: "errors.has('subject')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("\n                                                                    " + _vm._s(_vm.errors.first('subject')) + "\n                                                                ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xs-6 no-padding"
	  }, [_c('div', {
	    staticClass: "form-group form-group-default"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t("campaign.email.sender")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.campaignData.from_sender),
	      expression: "campaignData.from_sender"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "from_sender",
	      "placeholder": "A make believe from name.."
	    },
	    domProps: {
	      "value": (_vm.campaignData.from_sender)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.campaignData, "from_sender", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('from_sender')),
	      expression: "errors.has('from_sender')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("\n                                                                            " + _vm._s(_vm.errors.first('from_sender')) + "\n                                                                        ")])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5 col-lg-5 col-xs-5 col-md-5 no-padding"
	  }, [_c('div', {
	    staticClass: "form-group form-group-default"
	  }, [_c('label', [_vm._v("Select Domain")]), _vm._v(" "), _c('el-select', {
	    staticClass: "form-control el-select-wrapper",
	    attrs: {
	      "placeholder": "Select Domain"
	    },
	    model: {
	      value: (_vm.campaignData.from_domain_id),
	      callback: function($$v) {
	        _vm.$set(_vm.campaignData, "from_domain_id", $$v)
	      },
	      expression: "campaignData.from_domain_id"
	    }
	  }, _vm._l((_vm.domains), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  })), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isDomainSelected),
	      expression: "isDomainSelected"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("\n                                                                            " + _vm._s(_vm.$t("campaign.email.please_select_a_domain_name")) + "\n                                                                        ")])], 1)])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "checkbox"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t("campaign.email.personalise_subject_email")) + "\n                                                                    "), _c('a', {
	    on: {
	      "click": function($event) {
	        _vm.click_recp()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t("campaign.email.click_here_to_see_complete_list")))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.recp == 1),
	      expression: "recp==1"
	    }]
	  }, [_c('a', {
	    attrs: {
	      "value": "{FIRST_NAME}"
	    },
	    on: {
	      "click": function($event) {
	        _vm.place_holder('{FIRST_NAME}')
	      }
	    }
	  }, [_vm._v("{FIRST_NAME}")]), _vm._v(",\n                                                                    "), _c('a', {
	    attrs: {
	      "value": "{LAST_NAME}"
	    },
	    on: {
	      "click": function($event) {
	        _vm.place_holder('{LAST_NAME}')
	      }
	    }
	  }, [_vm._v("{LAST_NAME}")]), _vm._v(",\n                                                                    "), _c('a', {
	    attrs: {
	      "value": "{EMAIL}"
	    },
	    on: {
	      "click": function($event) {
	        _vm.place_holder('{EMAIL}')
	      }
	    }
	  }, [_vm._v("{EMAIL}")]), _vm._v(",\n                                                                    "), _c('a', {
	    attrs: {
	      "value": "{NUMBER}"
	    },
	    on: {
	      "click": function($event) {
	        _vm.place_holder('{NUMBER}')
	      }
	    }
	  }, [_vm._v("{NUMBER}")]), _vm._v(",\n                                                                    "), _c('a', {
	    attrs: {
	      "value": "{DESIGNATION}"
	    },
	    on: {
	      "click": function($event) {
	        _vm.place_holder('{DESIGNATION}')
	      }
	    }
	  }, [_vm._v("{DESIGNATION}")]), _vm._v(",\n                                                                    "), _c('a', {
	    attrs: {
	      "value": "{DEPARTMENT}"
	    },
	    on: {
	      "click": function($event) {
	        _vm.place_holder('{DEPARTMENT}')
	      }
	    }
	  }, [_vm._v("{DEPARTMENT}")]), _vm._v(",\n                                                                    "), _c('a', {
	    attrs: {
	      "value": "{LOCATION}"
	    },
	    on: {
	      "click": function($event) {
	        _vm.place_holder('{LOCATION}')
	      }
	    }
	  }, [_vm._v("{LOCATION}")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "padding-5 bg-master-lighter p-l-15 p-r-15"
	  }, [_c('h3', {
	    staticClass: "no-margin p-t-10 p-b-10"
	  }, [_vm._v(_vm._s(_vm.$t("campaign.landing.specify_landing_url")))]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 no-padding"
	  }, [_c('div', {
	    staticClass: "form-group form-group-default"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t("campaign.landing.subdomain")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|alpha_num'),
	      expression: "'required|alpha_num'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.campaignData.landing_sub_domain),
	      expression: "campaignData.landing_sub_domain"
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "landing_sub_domain",
	      "autofocus": "",
	      "placeholder": "A make believe subdomain name.."
	    },
	    domProps: {
	      "value": (_vm.campaignData.landing_sub_domain)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.campaignData, "landing_sub_domain", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('landing_sub_domain')),
	      expression: "errors.has('landing_sub_domain')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("\n                                                                            " + _vm._s(_vm.errors.first('landing_sub_domain')) + "\n                                                                        ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 no-padding"
	  }, [_c('div', {
	    staticClass: "form-group form-group-default"
	  }, [_c('label', [_vm._v("Select Domain")]), _vm._v(" "), _c('el-select', {
	    staticClass: "form-control el-select-wrapper",
	    attrs: {
	      "clearable": "",
	      "placeholder": "Select Domain"
	    },
	    model: {
	      value: (_vm.campaignData.landing_domain_id),
	      callback: function($$v) {
	        _vm.$set(_vm.campaignData, "landing_domain_id", $$v)
	      },
	      expression: "campaignData.landing_domain_id"
	    }
	  }, _vm._l((_vm.domains), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  })), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isDomainSelected),
	      expression: "isDomainSelected"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("\n                                                                            " + _vm._s(_vm.$t("campaign.landing.please_select_any_domain_name")) + "\n                                                                        ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 no-padding"
	  }, [_c('div', {
	    staticClass: "form-group form-group-default"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t("campaign.landing.subdirectory_file")))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.campaignData.landing_sub_path),
	      expression: "campaignData.landing_sub_path"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|alpha_num'),
	      expression: "'required|alpha_num'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "sub_directory",
	      "placeholder": "A make believe sub_directory name.."
	    },
	    domProps: {
	      "value": (_vm.campaignData.landing_sub_path)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.campaignData, "landing_sub_path", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('sub_directory')),
	      expression: "errors.has('sub_directory')"
	    }],
	    staticClass: "help is-danger"
	  }, [_vm._v("\n                                                                            " + _vm._s(_vm.errors.first('sub_directory')) + "\n                                                                        ")])])]), _vm._v(" "), _c('br', {
	    staticClass: "clearfix"
	  })])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 b-t b-grey p-t-30 m-t-30"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [(_vm.campaign.locked == 1) ? _c('button', {
	    staticClass: "btn btn-complete btn-space",
	    attrs: {
	      "data-dismiss": "modal",
	      "aria-hidden": "true",
	      "type": "button"
	    }
	  }, [_vm._v(" Close")]) : _vm._e(), _vm._v(" "), (_vm.campaign.locked !== 1) ? _c('button', {
	    staticClass: "btn btn-complete btn-space",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.editCampaignSchedule
	    }
	  }, [_vm._v(" Save")]) : _vm._e()])])])])])])])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-hidden": "true"
	    }
	  }, [_c('i', {
	    staticClass: "pg-close fs-14"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alert alert-info visible-xs m-r-5 m-l-5",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "data-dismiss": "alert"
	    }
	  }), _vm._v(" "), _c('strong', [_vm._v("Info: ")]), _vm._v(" On mobile the tab will be come a Accorian by using data-init-reponsive-tabs=\"collapse\"\n                                ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-6"
	  }, [_c('h4', {
	    staticClass: "font-montserrat ",
	    staticStyle: {
	      "font-size": "26px",
	      "font-weight": "bold",
	      "text-transform": "uppercase"
	    }
	  }, [_vm._v("Education Preview")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-1 col-sm-1 col-xs-1 col-lg-1 no-padding"
	  }, [_c('p', {
	    staticStyle: {
	      "text-align": "center",
	      "font-size": "20px",
	      "line-height": "54px",
	      "background": "#ececec"
	    }
	  }, [_vm._v("@")])])
	}]}

/***/ }),

/***/ 1461:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "vcroFormulaModal",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-hidden": "true"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._m(1), _vm._v(" "), _c('h6', {
	    staticClass: "bold mb5 fs-13"
	  }, [_vm._v("FACTORS")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "fs-13 mb15"
	  }, [_vm._v("A user's Risk Score = average of the factors that apply (a factor with no data is skipped, not counted as zero).")]), _vm._v(" "), (_vm.isAggregate) ? [_c('h6', {
	    staticClass: "bold mb5 fs-13"
	  }, [_vm._v(_vm._s(_vm.levelWord.toUpperCase()) + " SCORE")]), _vm._v(" "), _c('div', {
	    staticClass: "fs-13 mb15"
	  }, [_vm._v("The " + _vm._s(_vm.levelWord) + " Risk Score is the "), _c('strong', [_vm._v("median")]), _vm._v(" of its members' individual User Risk Scores, and each factor (Behavior / Training / Amplifier) is likewise the median of members' individual factor values: sort everyone's values and take the middle one, so a few outliers don't skew it the way a plain average would.")])] : _vm._e(), _vm._v(" "), _c('h6', {
	    staticClass: "bold mb5 fs-13"
	  }, [_vm._v("RISK LEVELS")]), _vm._v(" "), _c('div', {
	    staticClass: "fs-13"
	  }, [_vm._v("Low 0–24 · Medium 25–49 · High 50–74 · Critical 75–100")])], 2), _vm._v(" "), _vm._m(4)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('h5', {
	    staticClass: "modal-title"
	  }, [_vm._v("How the Risk Score is calculated")]), _vm._v(" "), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "fs-13 mb15"
	  }, [_vm._v("A user's Risk Score is the "), _c('strong', [_vm._v("average of their active risk factors")]), _vm._v(" — each scored 0–100 (higher = more risk).")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "fs-13 mt-0 pl-3"
	  }, [_c('li', {
	    staticClass: "mb5"
	  }, [_vm._v("Behavior = (Clicked / Opened) × 100")]), _vm._v(" "), _c('li', {
	    staticClass: "mb5"
	  }, [_vm._v("Training = (Assigned − Evaluated) / Assigned × 100"), _c('br'), _c('span', {
	    staticStyle: {
	      "opacity": ".75",
	      "font-style": "italic"
	    }
	  }, [_vm._v("Note: only mandatory trainings count toward the score.")])]), _vm._v(" "), _c('li', {
	    staticClass: "mb5"
	  }, [_vm._v("Amplifier = highest amplifier set by the company for the user or their groups")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "fs-13 mb15"
	  }, [_vm._v("Each factor is a 0–100 score and is "), _c('strong', [_vm._v("capped at 100")]), _vm._v(" — Behavior can work out above 100% when there are more clicks than opens, so it's clamped.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Close")])])
	}]}

/***/ }),

/***/ 1536:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.enabled && (_vm.alerts.length || _vm.dismissedCount)) ? _c('div', {
	    staticClass: "dropdown notificationicoblock system-alert-block"
	  }, [_c('span', {
	    staticClass: "notificationico pointer header_icon system-alert-ico",
	    class: _vm.severityClass,
	    attrs: {
	      "title": _vm.iconTitle,
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false",
	      "aria-label": "system alerts"
	    }
	  }, [_c('i', {
	    staticClass: "far fa-bell"
	  }), _vm._v(" "), (_vm.totalCount > 0) ? _c('span', {
	    staticClass: "notification_count"
	  }, [_vm._v(_vm._s(_vm.totalCount))]) : _vm._e()]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu dropdown-menu-right mt10 system-alert-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('li', {
	    staticClass: "viewallNotify system-alert-menu-head"
	  }, [(_vm.alerts.length) ? _c('a', {
	    staticClass: "system-alert-dismiss-all",
	    class: {
	      'is-busy': _vm.dismissingAll
	    },
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        $event.stopPropagation();
	        return _vm.dismissAll($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.dismissingAll ? 'Dismissing…' : 'Dismiss all'))]) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "system-alert-viewall",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.goToAlerts($event)
	      }
	    }
	  }, [_vm._v("View all")])]), _vm._v(" "), (!_vm.alerts.length) ? _c('li', {
	    staticClass: "system-alert-empty"
	  }, [_c('div', {
	    staticClass: "notificationClick"
	  }, [_c('h6', {
	    staticClass: "fs-14 bold m-0 lh_18"
	  }, [_vm._v("Nothing needs attention right now")]), _vm._v(" "), _c('small', {
	    staticClass: "opacity-75 block"
	  }, [_vm._v("\n          " + _vm._s(_vm.dismissedCount) + " dismissed issue(s) are still unfixed and will\n          come back tomorrow.\n        ")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.alerts), function(alert) {
	    return _c('li', {
	      key: alert.id
	    }, [_c('div', {
	      staticClass: "notificationClick system-alert-row"
	    }, [_c('span', {
	      staticClass: "system-alert-dot",
	      class: 'sev-' + alert.severity
	    }), _vm._v(" "), _c('div', {
	      staticClass: "system-alert-body"
	    }, [_c('h6', {
	      staticClass: "fs-14 bold m-0 lh_18"
	    }, [_vm._v(_vm._s(alert.title))]), _vm._v(" "), (alert.impact) ? _c('small', {
	      staticClass: "opacity-75 block"
	    }, [_vm._v(_vm._s(alert.impact))]) : _vm._e(), _vm._v(" "), _c('small', {
	      staticClass: "opacity-50 block"
	    }, [_vm._v(_vm._s(alert.detected_at))]), _vm._v(" "), _c('div', {
	      staticClass: "system-alert-actions"
	    }, [(alert.action_route) ? _c('a', {
	      staticClass: "a_color",
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.goToFix(alert)
	        }
	      }
	    }, [_vm._v(_vm._s(alert.action_text || 'Open settings'))]) : _vm._e(), _vm._v(" "), _c('a', {
	      staticClass: "a_color ml10",
	      attrs: {
	        "href": "#"
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.dismiss(alert)
	        }
	      }
	    }, [_vm._v("Dismiss")])])])])])
	  })], 2)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 1554:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "card shadow-none px-3 pt-3"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4 col-md-5"
	  }, [_c('div', {
	    staticClass: "form-group mb15"
	  }, [_c('label', {
	    staticClass: "label_uc"
	  }, [_vm._v("Name your schedule")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.data.name),
	      expression: "data.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "e.g. all employees"
	    },
	    domProps: {
	      "value": (_vm.data.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.data, "name", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.publishErrorName),
	      expression: "publishErrorName"
	    }],
	    staticClass: "text-danger"
	  }, [_vm._v("\n          " + _vm._s(_vm.publishErrorName) + "\n        ")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-5"
	  }, [_c('div', {
	    staticClass: "form-group mb15"
	  }, [_c('label', {
	    staticClass: "label_uc"
	  }, [_vm._v("Select Recipients")]), _vm._v(" "), _c('el-select', {
	    staticClass: "hf_email_select hf_email_select_m",
	    attrs: {
	      "autofocus": "",
	      "multiple": "",
	      "filterable": "",
	      "remote": "",
	      "reserve-keyword": "",
	      "placeholder": "Enter text to Search",
	      "remote-method": _vm.remoteRecipientGroup,
	      "loading": _vm.loading
	    },
	    model: {
	      value: (_vm.selectedRecipient),
	      callback: function($$v) {
	        _vm.selectedRecipient = $$v
	      },
	      expression: "selectedRecipient"
	    }
	  }, [_c('el-option', {
	    key: _vm.all,
	    attrs: {
	      "value": "All Sheets"
	    }
	  }), _vm._v(" "), _vm._l((_vm.recipients), function(group) {
	    return _c('el-option-group', {
	      key: group.label,
	      attrs: {
	        "label": group.label
	      }
	    }, _vm._l((group.options), function(item) {
	      return _c('el-option', {
	        key: item.value,
	        attrs: {
	          "label": item.label,
	          "value": item.value + '|' + group.label
	        }
	      })
	    }))
	  })], 2), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.publishError),
	      expression: "publishError"
	    }],
	    staticClass: "text-danger"
	  }, [_vm._v("\n          " + _vm._s(_vm.publishError) + "\n        ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-4 col-md-2"
	  }, [_c('div', {
	    staticClass: "form-group mb15 mt16"
	  }, [(_vm.action == 'add') ? _c('button', {
	    staticClass: "btn hf-btn-info btn-block btn-lg px-3",
	    on: {
	      "click": function($event) {
	        _vm.addBulkCampaign()
	      }
	    }
	  }, [_vm._v("Start Scheduling")]) : _vm._e(), _vm._v(" "), (_vm.action == 'edit') ? _c('button', {
	    staticClass: "btn hf-btn-info btn-block btn-lg px-3",
	    on: {
	      "click": function($event) {
	        _vm.addBulkCampaign()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.published ? 'Published' : 'Publish Schedule'))]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.publish_check == 1),
	      expression: "publish_check==1"
	    }],
	    staticClass: "col-sm-12 text-right"
	  }, [_c('span', {
	    staticClass: "text-danger"
	  }, [_vm._v("\n        Please schedule atleast one campaign. \n      ")])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1561:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-6 col-md-4 pad_c"
	  }, [_c('div', {
	    staticClass: "append_next_btn"
	  }, [_c('button', {
	    staticClass: "btn hf-btn-info btn_w_f btn-lg",
	    attrs: {
	      "data-toggle": "modal",
	      "data-target": '#campaign_schedule_' + _vm.index
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-plus mr-2"
	  }), _vm._v("Next")])]), _vm._v(" "), _c('div', {
	    staticClass: "modal delete_modal fade slide-up disable-scroll",
	    attrs: {
	      "id": 'campaign_schedule_' + _vm.index,
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-hidden": "false"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg modal-dialog-scrollable"
	  }, [_c('div', {
	    staticClass: "modal-content-wrapper"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "modal-body modal_body"
	  }, [_c('div', {
	    staticClass: "form-group between_input"
	  }, [_c('span', [_vm._v("Schedule Campaign After Main ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sendAfter),
	      expression: "sendAfter"
	    }],
	    staticClass: "datepicker_component",
	    attrs: {
	      "type": "number",
	      "min": "1",
	      "name": ""
	    },
	    domProps: {
	      "value": (_vm.sendAfter)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.sendAfter = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.sendAfterType),
	      expression: "sendAfterType"
	    }],
	    staticClass: "form-control arrow_d",
	    staticStyle: {
	      "width": "80px!important"
	    },
	    attrs: {
	      "data-init-plugin": "cs-select"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.sendAfterType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1",
	      "selected": "selected"
	    }
	  }, [_vm._v("Days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("Hours")])]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.sendAfterError),
	      expression: "sendAfterError"
	    }],
	    staticClass: "text-danger"
	  }, [_vm._v("\n                " + _vm._s(_vm.sendAfterError) + "\n              ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "form-group mb10"
	  }, [_c('div', {
	    staticClass: "fs-14 mb5"
	  }, [_vm._v("Run this campaign on those ")]), _vm._v(" "), _c('label', {
	    staticClass: "label_uc"
	  }, [_vm._v("Select Action")]), _vm._v(" "), _c('el-select', {
	    staticClass: "hf_email_select",
	    attrs: {
	      "multiple": "",
	      "placeholder": "Select"
	    },
	    model: {
	      value: (_vm.campaignAction),
	      callback: function($$v) {
	        _vm.campaignAction = $$v
	      },
	      expression: "campaignAction"
	    }
	  }, _vm._l((_vm.actionArry), function(item) {
	    return _c('el-option', {
	      key: item.value,
	      attrs: {
	        "label": item.label,
	        "value": item.value
	      }
	    })
	  })), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.campaignActionError),
	      expression: "campaignActionError"
	    }],
	    staticClass: "text-danger"
	  }, [_vm._v("\n                " + _vm._s(_vm.campaignActionError) + "\n              ")]), _vm._v(" "), (_vm.dateconflicterrormessage == true) ? _c('span', {
	    staticClass: "text-danger"
	  }, [_vm._v(" " + _vm._s(_vm.$t("campaign.bulk_campaign.error_in_date_conflict")) + " ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer px-2 py-2"
	  }, [_c('button', {
	    staticClass: "btn hf-btn-info btn_w",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.updateCampaignSchedule(_vm.campaign.id, _vm.index)
	      }
	    }
	  }, [_vm._v("Save and Proceed")])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header modal_header bg-transparent"
	  }, [_c('span', {
	    staticClass: "fs-18"
	  }, [_vm._v("Schedule A Campaign or Learning")]), _vm._v(" "), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group"
	  }, [_c('strong', [_vm._v("Recommended : ")]), _vm._v("with in 7 days of campaign. \n            ")])
	}]}

/***/ }),

/***/ 1579:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "page-sidebar",
	    attrs: {
	      "data-pages": "sidebar"
	    }
	  }, [_c('div', {
	    staticClass: "sidebar-header"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard.index'
	      }
	    }
	  }, [_c('img', {
	    staticClass: "brand",
	    attrs: {
	      "src": __webpack_require__(239),
	      "alt": "logo",
	      "width": "180px"
	    }
	  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
	    staticClass: "sidebar-menu"
	  }, [_c('ul', {
	    staticClass: "menu-items"
	  }, [(_vm.user_permission.data.dashboard) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "id": "sidebar-dashboard",
	      "data-intro": "Get a birds eye view of all important metrics.",
	      "data-position": "right",
	      "tag": "li",
	      "to": {
	        name: 'dashboard.index'
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow invisible"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-home"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.status == 2) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'dashboard.companylist'
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    }
	  }, [_c('span', [_vm._v("Login As Company")])]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "far fa-newspaper"
	  })])]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "id": "sidebar-calendar",
	      "tag": "li",
	      "title": "Schedule Calendar",
	      "to": {
	        name: 'schedule_calendar'
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    }
	  }, [_c('span', [_vm._v("Calendar")])]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-calendar-alt"
	  })])]), _vm._v(" "), (_vm.user_permission.data.campaign_create || _vm.user_permission.data.campaign_view || _vm.user_permission.data.campaign_schedule) ? _c('li', {
	    attrs: {
	      "id": "sidebar-campaign",
	      "data-intro": "Create and manage Phishing simulation campaigns.",
	      "data-position": "right"
	    }
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.campaign_create) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    class: _vm.checkActive(_vm.$route.path === '/campaigns/create'),
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'campaigns.create'
	      }
	    }
	  }, [_c('a', [_vm._v("Add Campaign")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.needlePhishingStatus) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'create_needle_phishing'
	      }
	    }
	  }, [_c('a', [_vm._v("Add Needle Phishing")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.campaign_view) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    class: _vm.checkActive(_vm.$route.path === '/campaigns'),
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'campaigns'
	      }
	    }
	  }, [_c('a', [_vm._v("View Campaign")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.campaign_schedule) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'bulk_campaigns'
	      }
	    }
	  }, [_c('a', [_vm._v("Schedule Campaigns")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.userRole == 'creator') ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/campaigns/creator-workspace'
	      }
	    }
	  }, [_c('a', [_vm._v("Campaigns Workspace")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.userRole == 'approver') ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/campaigns/approver-workspace'
	      }
	    }
	  }, [_c('a', [_vm._v("Campaigns Workspace")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.announcement_create || _vm.user_permission.data.announcement_view) ? _c('li', {
	    attrs: {
	      "id": "sidebar-announcement",
	      "data-intro": "Use this to create and manage Announcements, eAUP or internal communication.",
	      "data-position": "right"
	    }
	  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.announcement_create) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    class: _vm.checkActive(_vm.$route.path === '/announcements/create'),
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/announcements/create'
	      }
	    }
	  }, [_c('a', [_vm._v("Add Announcement")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.announcement_view) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    class: _vm.checkActive(_vm.$route.path === '/announcements'),
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/announcements'
	      }
	    }
	  }, [_c('a', [_vm._v("View Announcement")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.userRole == 'creator') ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/announcements/creator-workspace'
	      }
	    }
	  }, [_c('a', [_vm._v("Announcement Workspace")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.userRole == 'approver') ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/announcements/approver-workspace'
	      }
	    }
	  }, [_c('a', [_vm._v("Announcement Workspace")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.policy_create || _vm.user_permission.data.policy_view) ? _c('li', {
	    attrs: {
	      "id": "sidebar-policy",
	      "data-intro": "Policy",
	      "data-position": "right"
	    }
	  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.policy_create) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    class: _vm.checkActive(_vm.$route.path === '/policy/create'),
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/policy/create'
	      }
	    }
	  }, [_c('a', [_vm._v("Add Policy")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.policy_view) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    class: _vm.checkActive(_vm.$route.path === '/policy'),
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/policy'
	      }
	    }
	  }, [_c('a', [_vm._v("View Policy")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.userRole == 'creator') ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/policy/creator-workspace'
	      }
	    }
	  }, [_c('a', [_vm._v("Policy Workspace")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.userRole == 'approver') ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/policy/approver-workspace'
	      }
	    }
	  }, [_c('a', [_vm._v("Policy Workspace")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.adobeAcrobatStatus) ? _c('li', {
	    attrs: {
	      "id": "adobe_acrobat",
	      "data-intro": "adobe_acrobat",
	      "data-position": "right"
	    }
	  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [_c('router-link', {
	    staticClass: "hide_after_click",
	    class: _vm.checkActive(_vm.$route.path === '/add-agreement'),
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/add-agreement'
	      }
	    }
	  }, [_c('a', [_vm._v("Add Agreement")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]), _vm._v(" "), _c('router-link', {
	    staticClass: "hide_after_click",
	    class: _vm.checkActive(_vm.$route.path === '/view-agreements'),
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/view-agreements'
	      }
	    }
	  }, [_c('a', [_vm._v("View Agreement")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]), _vm._v(" "), _c('router-link', {
	    staticClass: "hide_after_click",
	    class: _vm.checkActive(_vm.$route.path === '/adobe-auth'),
	    attrs: {
	      "tag": "li",
	      "to": {
	        path: '/adobe-auth'
	      }
	    }
	  }, [_c('a', [_vm._v("Settings")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_scenario || _vm.user_permission.data.add_scenario) ? _c('li', {
	    attrs: {
	      "id": "sidebar-scenario",
	      "data-intro": "Create and manage Scenarios for Phishing Simulation and Announcement campaigns.",
	      "data-position": "right"
	    }
	  }, [_vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.add_scenario) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    class: _vm.checkActive(_vm.$route.path === '/scenario/description'),
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'scenario.description'
	      }
	    }
	  }, [_c('a', [_vm._v("Add Scenario")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_scenario) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    class: _vm.checkActive(_vm.$route.path === '/scenario'),
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'scenario'
	      }
	    }
	  }, [_c('a', [_vm._v("View Scenarios")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_modules || _vm.user_permission.data.upload_modules || _vm.user_permission.data.direct_learning_management || _vm.user_permission.data.education_uploader || _vm.user_permission.data.is_education_editable) ? _c('li', {
	    attrs: {
	      "id": "sidebar-training"
	    }
	  }, [_vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.is_education_editable) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'trainingmoduleAdmin'
	      }
	    }
	  }, [_c('a', [_vm._v("View Training (Super Admin)")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_modules) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'trainingmodule'
	      }
	    }
	  }, [_c('a', [_vm._v("View Training")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.upload_modules) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'bulkeducation'
	      }
	    }
	  }, [_c('a', [_vm._v("Upload Training")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("U")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.settings) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'training_settings'
	      }
	    }
	  }, [_c('a', [_vm._v("Settings")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("S")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.lms) ? _c('li', {
	    attrs: {
	      "id": "sidebar-lms",
	      "oncontextmenu": "return false;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.redirectToLms()
	      }
	    }
	  }, [_vm._m(13), _vm._v(" "), _vm._m(14)]) : _vm._e(), _vm._v(" "), (_vm.needlePhishingStatus) ? _c('li', {
	    staticClass: "AIIcon",
	    attrs: {
	      "id": "sidebar-lms",
	      "oncontextmenu": "return false;"
	    },
	    on: {
	      "click": function($event) {
	        _vm.redirectToHFv3()
	      }
	    }
	  }, [_vm._m(15), _vm._v(" "), _vm._m(16)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_recepients || _vm.user_permission.data.add_new_recepients || _vm.user_permission.data.manage_groups || _vm.user_permission.data.add_suppression || _vm.user_permission.data.view_suppression) ? _c('li', {
	    attrs: {
	      "id": "sidebar-recipients",
	      "data-intro": "Manage your recipients here.",
	      "data-position": "right"
	    }
	  }, [_vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.view_recepients) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'recipients'
	      }
	    }
	  }, [_c('a', [_vm._v("View Recipients")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.add_new_recepients) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'recipients.imports'
	      }
	    }
	  }, [_c('a', [_vm._v("Add New Recipients")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.manage_groups) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'recipients.manage_groups'
	      }
	    }
	  }, [_c('a', [_vm._v("Manage Groups")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("M")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_suppression) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'recipients.suppression.imports'
	      }
	    }
	  }, [_c('a', [_vm._v("Suppression List")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.add_suppression) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'suppression'
	      }
	    }
	  }, [_c('a', [_vm._v("Suppressed Recipients")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.view_recepients && _vm.ouSettingStatus) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'recipients.ouSetting'
	      }
	    }
	  }, [_c('a', [_vm._v("OU Settings")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("O")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.phishing_campaigns_new || _vm.user_permission.data.announcement_campaigns_new || this.user_permission.data.policy_announcement_new || _vm.user_permission.data.leaderboard_new || _vm.user_permission.data.laggardsnew || _vm.user_permission.data.all_reports) ? _c('li', {
	    attrs: {
	      "id": "sidebar-reports-new"
	    }
	  }, [_vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.phishing_campaigns_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'reports.phishingcampaignsperformance'
	      }
	    }
	  }, [_c('a', [_vm._v("Phishing Campaigns")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("P")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.announcement_campaigns_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'reports.announcementcampaignsperformance'
	      }
	    }
	  }, [_c('a', [_vm._v("Announcement Campaigns")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.policy_announcement_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'reports.policyannouncementperformance'
	      }
	    }
	  }, [_c('a', [_vm._v("Policy Announcement")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("P")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.leaderboard_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'reports.leaderboard'
	      }
	    }
	  }, [_c('a', [_vm._v("Leaderboard")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("L")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.laggardsnew) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'reports.laggards'
	      }
	    }
	  }, [_c('a', [_vm._v("Laggards")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("L")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.detailed_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'report.campaigns-detailed-report'
	      }
	    }
	  }, [_c('a', [_vm._v("Detailed")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("D")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.weakest_departments_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.repeatoffenders'
	      }
	    }
	  }, [_c('a', [_vm._v("Repeatedly Phished Users ")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("R")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.vulnerability_trend_new || _vm.user_permission.data.awareness_trend_new || _vm.user_permission.data.reporting_trend_new || _vm.user_permission.data.weakest_links_new || _vm.user_permission.data.strongest_links_least_compromised_new || _vm.user_permission.data.strongest_links_most_compromised_new || _vm.user_permission.data.weakest_departments_new) ? _c('li', {
	    attrs: {
	      "id": "sidebar-management-reports"
	    }
	  }, [_vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.vulnerability_trend_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.phishingvulnerabilitytrend'
	      }
	    }
	  }, [_c('a', [_vm._v("Vulnerability Trend")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.awareness_trend_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.cybersecurityawarenesstrend'
	      }
	    }
	  }, [_c('a', [_vm._v("Awareness Trend")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.reporting_trend_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.phishingreportingtrend'
	      }
	    }
	  }, [_c('a', [_vm._v("Reporting Trend")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("R")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.weakest_links_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.weakestlinks'
	      }
	    }
	  }, [_c('a', [_vm._v("Weakest Links")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("W")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.strongest_links_least_compromised_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.strongestlinks-least-compromised'
	      }
	    }
	  }, [_c('a', [_vm._v("Strongest Links (Least Compromised)")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.strongest_links_most_compromised_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.strongestlinks-most-reported'
	      }
	    }
	  }, [_c('a', [_vm._v("Strongest Links (Most Reported)")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.weakest_departments_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'managementreport.weakestdepartments'
	      }
	    }
	  }, [_c('a', [_vm._v("Weakest Departments ")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("W")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.departments_new || _vm.user_permission.data.designations_new) ? _c('li', {
	    attrs: {
	      "id": "sidebar-vulnerability-reports"
	    }
	  }, [_vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.departments_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'newreports.VulnerabilityReport-DepartmentWiseUniqueEmployees'
	      }
	    }
	  }, [_c('a', [_vm._v("Departments")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("D")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.designations_new) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'newreports.VulnerabilityReport-DesignationWiseUniqueEmployees'
	      }
	    }
	  }, [_c('a', [_vm._v("Designations")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("D")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.organisation_vcro || _vm.user_permission.data.departments_vcro || _vm.user_permission.data.groups_vcro || _vm.user_permission.data.users_vcro) ? _c('li', {
	    attrs: {
	      "id": "sidebar-vcro"
	    }
	  }, [_vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.organisation_vcro) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "Risk Score of the Organisation.",
	      "tag": "li",
	      "to": {
	        name: 'vcro.organisation_risk_score'
	      }
	    }
	  }, [_c('a', [_vm._v(" Organisation")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("O")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.departments_vcro) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "Risk Score of all the departments of the organisation.",
	      "tag": "li",
	      "to": {
	        name: 'vcro.all_department_risk_score'
	      }
	    }
	  }, [_c('a', [_vm._v(" Departments")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("D")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.groups_vcro) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "Risk Score of all the groups of the organisation.",
	      "tag": "li",
	      "to": {
	        name: 'vcro.all_group_risk_score'
	      }
	    }
	  }, [_c('a', [_vm._v(" Groups")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("G")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.users_vcro) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "Risk Score of all the users of the organisation.",
	      "tag": "li",
	      "to": {
	        name: 'vcro.all_user_risk_score'
	      }
	    }
	  }, [_c('a', [_vm._v(" Users ")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("U")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.gamification_add_badgee || _vm.user_permission.data.gamification_award_log || _vm.user_permission.data.gamification_badges || _vm.user_permission.data.gamification_set_points) ? _c('li', {
	    attrs: {
	      "id": "sidebar-gamification"
	    }
	  }, [_vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.gamification_badges) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "",
	      "tag": "li",
	      "to": {
	        name: 'gamification.badges'
	      }
	    }
	  }, [_c('a', [_vm._v("Badges")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("B")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.gamification_add_badgee) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "",
	      "tag": "li",
	      "to": {
	        name: 'gamification.add_badge'
	      }
	    }
	  }, [_c('a', [_vm._v("Add Badge")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("B")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.gamification_award_log) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "",
	      "tag": "li",
	      "to": {
	        name: 'gamification.award_log_all'
	      }
	    }
	  }, [_c('a', [_vm._v("Award Log")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.gamification_set_points) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "",
	      "tag": "li",
	      "to": {
	        name: 'gamification.points'
	      }
	    }
	  }, [_c('a', [_vm._v("Set Points")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.gamification_set_points) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "",
	      "tag": "li",
	      "to": {
	        name: 'gamification.gamification_notification'
	      }
	    }
	  }, [_c('a', [_vm._v("Notification Emails")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("N")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), ((_vm.user_permission.data.myUserportal || _vm.user_permission.data.myUserportal_view_as || _vm.user_permission.data.customise_user_portal || _vm.user_permission.data.customise_login_page || _vm.user_permission.data.news_updates) && (_vm.showBoth || _vm.user_permission.data.userportal_active_version.userportal === 'v1')) ? _c('li', [_vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.myUserportal) ? _c('li', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "My User Portal",
	      "tag": "li"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.myUserportal
	    }
	  }, [_vm._v("My User Portal")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("U")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.myUserportal_view_as) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "View As",
	      "tag": "li",
	      "to": {
	        name: 'viewas'
	      }
	    }
	  }, [_c('a', [_vm._v("View As")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.customise_user_portal) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "Customise User Portal",
	      "tag": "li",
	      "to": {
	        name: 'customize'
	      }
	    }
	  }, [_c('a', [_vm._v("Customise User Portal")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.customise_login_page) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "Customise Login Page",
	      "tag": "li",
	      "to": {
	        name: 'customize_login'
	      }
	    }
	  }, [_c('a', [_vm._v("Customise Login Page")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.news_updates) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "News Updates",
	      "tag": "li",
	      "to": {
	        name: 'news_updates'
	      }
	    }
	  }, [_c('a', [_vm._v("News Updates")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("N")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), ((_vm.user_permission.data.myUserportal || _vm.user_permission.data.myUserportal_view_as || _vm.user_permission.data.customise_user_portal || _vm.user_permission.data.customise_login_page || _vm.user_permission.data.news_updates || _vm.user_permission.data.all_reports) && (_vm.showBoth || _vm.user_permission.data.userportal_active_version.userportal === 'v2')) ? _c('li', [_vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.myUserportal_view_as) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "View As",
	      "tag": "li",
	      "to": {
	        name: 'viewasNew'
	      }
	    }
	  }, [_c('a', [_vm._v("View As")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.myUserportal_view_as) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "Customise User Portal",
	      "tag": "li",
	      "to": {
	        name: 'customize_new'
	      }
	    }
	  }, [_c('a', [_vm._v("Customise User Portal")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.customise_login_page) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "Customise Login Page",
	      "tag": "li",
	      "to": {
	        name: 'customize_login_new'
	      }
	    }
	  }, [_c('a', [_vm._v("Customise Login Page")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.news_updates) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "News Updates",
	      "tag": "li",
	      "to": {
	        name: 'news_updates_new',
	      }
	    }
	  }, [_c('a', [_vm._v("News Updates")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("N")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.all_reports) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "Portal Logins",
	      "tag": "li",
	      "to": {
	        name: 'report.userportaltraffic'
	      }
	    }
	  }, [_c('a', [_vm._v("Portal Traffic")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("PL")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.exported) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "Exported Files",
	      "tag": "li",
	      "id": "exported_files",
	      "to": {
	        name: 'report.exported_files'
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "id": "sidebar-user-portal",
	      "href": "javascript:;",
	      "title": "Exported Files"
	    }
	  }, [_c('span', {
	    staticClass: "title title_sup"
	  }, [_vm._v("Exported Files "), _c('sup', [_vm._v("New")])])]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-file-alt"
	  })])]) : _vm._e(), _vm._v(" "), ((_vm.user_permission.data.my_team_portal || _vm.user_permission.data.customise_team_portal || _vm.user_permission.data.team_portal_view_as) && (_vm.isAdmin == 2 || (_vm.teamPortalStatus.is_active_teamportal && _vm.teamPortalStatus.is_team_flag))) ? _c('li', {
	    attrs: {
	      "id": "teamportal"
	    }
	  }, [_vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.team_portal_view_as) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "View As",
	      "tag": "li",
	      "to": {
	        name: 'viewasTeamportal'
	      }
	    }
	  }, [_c('a', [_vm._v("View As")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.customise_team_portal) ? _c('router-link', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.usersType != '3'),
	      expression: "usersType!='3'"
	    }],
	    staticClass: "hide_after_click",
	    attrs: {
	      "title": "Customise Team Portal",
	      "tag": "li",
	      "to": {
	        name: 'customizeTeamportal'
	      }
	    }
	  }, [_c('a', [_vm._v("Customise Team Portal")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.status == 2) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "id": "admin_log",
	      "tag": "li",
	      "title": "Admin Activity Logs",
	      "to": {
	        name: 'adminLogs'
	      }
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": ""
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Admin Logs")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow invisible"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-clipboard-list"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.domain || _vm.user_permission.data.general || _vm.user_permission.data.user_management || _vm.user_permission.data.retest_frequency || _vm.user_permission.data.email_setting || _vm.user_permission.data.throttling_speed || _vm.user_permission.data.data_entry_oops_page || _vm.user_permission.data.landing_page_templates || _vm.user_permission.data.notifications || _vm.user_permission.data.ignore_ip_list || _vm.user_permission.data.passing_percentage || _vm.user_permission.data.leaderboard_settings || _vm.user_permission.data.training_login_template || _vm.user_permission.data.security || _vm.user_permission.data.change_password || _vm.user_permission.data.import_reporters) ? _c('li', {
	    attrs: {
	      "id": "sidebar-settings",
	      "data-intro": "Manage all company settings from here.",
	      "data-position": "right"
	    }
	  }, [_vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.general) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'general'
	      }
	    }
	  }, [_c('a', [_vm._v("General")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("G")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'customizeAdminLogin'
	      }
	    }
	  }, [_c('a', [_vm._v("Admin Login Page")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]), _vm._v(" "), (_vm.user_permission.data.domains) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'company.domains'
	      }
	    }
	  }, [_c('a', [_vm._v("Domains  ")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("D")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.domains) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'appCredentials'
	      }
	    }
	  }, [_c('a', [_vm._v("Channel Credentials")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.domains) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'O365Setup'
	      }
	    }
	  }, [_c('a', [_vm._v("O365 Settings")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("O")])]) : _vm._e(), _vm._v(" "), (_vm.needlePhishingStatus) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'aiSettings'
	      }
	    }
	  }, [_c('a', [_vm._v("AI Settings")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.email_settings) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'email'
	      }
	    }
	  }, [_c('a', [_vm._v("Email Settings")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("E")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.email_settings) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'credentials'
	      }
	    }
	  }, [_c('a', [_vm._v("Reply To - Credentials")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("R")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.throttling_speed) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'throttling_sending_speed'
	      }
	    }
	  }, [_c('a', [_vm._v("Throttling Speed")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("T")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.auto_reminder_mail) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'trainingmail'
	      }
	    }
	  }, [_c('a', [_vm._v("Auto Reminder Mail")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.user_management) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'usermanagement'
	      }
	    }
	  }, [_c('a', [_vm._v("User Management")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("U")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.data_entry_oops_page) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'oopspage'
	      }
	    }
	  }, [_c('a', [_vm._v("Data Entry Oops Page")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("D")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.landing_page_templates) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'master_landing'
	      }
	    }
	  }, [_c('a', [_vm._v("Landing Page Templates")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("L")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.import_trained_users) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'import_trained_users'
	      }
	    }
	  }, [_c('a', [_vm._v("Import Trained Users")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("I")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.notifications) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'notifications'
	      }
	    }
	  }, [_c('a', [_vm._v("Notifications")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("N")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.ignore_ip_list) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'ignore_list'
	      }
	    }
	  }, [_c('a', [_vm._v("Ignore IP List")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("I")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.passing_percentage) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'books'
	      }
	    }
	  }, [_c('a', [_vm._v("Passing Percentage")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("P")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'training_languages'
	      }
	    }
	  }, [_c('a', [_vm._v("Training Languages")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("T")])]), _vm._v(" "), (_vm.user_permission.data.security) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'security'
	      }
	    }
	  }, [_c('a', [_vm._v("Security")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("S")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.import_reporters) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'import_reporters'
	      }
	    }
	  }, [_c('a', [_vm._v("Import Reporters")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("I")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.change_password) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'changepassword'
	      }
	    }
	  }, [_c('a', [_vm._v("Change Password")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]) : _vm._e(), _vm._v(" "), (_vm.isActivePdfCampaign) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'pdfCampaign'
	      }
	    }
	  }, [_c('a', [_vm._v("PDF Campaign")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("P")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'campaignUserRole'
	      }
	    }
	  }, [_c('a', [_vm._v("Campaign User Role")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])])], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
	    attrs: {
	      "id": "ip_information",
	      "data-intro": "ip_information",
	      "data-position": "right"
	    }
	  }, [_vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [_c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'ip.index'
	      }
	    }
	  }, [_c('a', [_vm._v("Campaigns IP")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("C")])]), _vm._v(" "), _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'ip.announcementIp'
	      }
	    }
	  }, [_c('a', [_vm._v("Announcements IP")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])])], 1)]), _vm._v(" "), (_vm.user_permission.data.ad_servers || _vm.user_permission.data.active_directory_view_logs) ? _c('li', {
	    attrs: {
	      "id": "active_directory_nav",
	      "data-intro": "Manage Active Directory settings here!",
	      "data-position": "right"
	    }
	  }, [_vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.ad_servers) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'listad'
	      }
	    }
	  }, [_c('a', [_vm._v("AD Servers")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.active_directory_view_logs) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'alladlogs'
	      }
	    }
	  }, [_c('a', [_vm._v("View Logs")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("V")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.user_permission.data.azure_active_directory_authorization) ? _c('li', {
	    attrs: {
	      "id": "sidebar-azure-active-dir",
	      "data-intro": "Manage Azure Active Dir settings here!",
	      "data-position": "right"
	    }
	  }, [_vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [(_vm.user_permission.data.azure_active_directory_authorization) ? _c('router-link', {
	    staticClass: "hide_after_click",
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'azure'
	      }
	    }
	  }, [_c('a', [_vm._v("Authorization")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_vm._v("A")])]) : _vm._e()], 1)]) : _vm._e()], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sidebarCollapse",
	    attrs: {
	      "aria-label": "Pin Menu",
	      "type": "button"
	    }
	  }, [_c('i', {
	    staticClass: "pg-icon"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Campaigns")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "far fa-newspaper"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Announcements")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fa fa-bullhorn"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Policy")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fa fa-file"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Adobe Acrobat")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fa fa-file"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Scenarios")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-file-contract"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Training")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "far fa-file-alt"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("LMS")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow invisible"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-graduation-cap"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("HFAI")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow invisible"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1165)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Recipients")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-users"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title title_sup"
	  }, [_vm._v("Reports"), _c('sup', [_vm._v("New")])]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-chart-line"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title title_new"
	  }, [_c('small', [_vm._v("New")]), _vm._v("Management Reports")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-chart-line"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title title_new"
	  }, [_c('small', [_vm._v("New")]), _vm._v("Vulnerability Reports")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-chart-line"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;",
	      "title": "Virtual Cyber Risk Officer"
	    }
	  }, [_c('span', {
	    staticClass: "title title_sup"
	  }, [_vm._v("vCRO"), _c('sup', [_vm._v("New")])]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-exclamation-triangle"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;",
	      "title": "Gamification"
	    }
	  }, [_c('span', {
	    staticClass: "title title_new"
	  }, [_c('small', [_vm._v("New")]), _vm._v(" Gamification Engine")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-gamepad"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "id": "sidebar-user-portal",
	      "href": "javascript:;",
	      "title": "User Portal"
	    }
	  }, [_c('span', {
	    staticClass: "title title_sup"
	  }, [_vm._v("User Portal")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-user"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "id": "sidebar-user-portal",
	      "href": "javascript:;",
	      "title": "User Portal"
	    }
	  }, [_c('span', {
	    staticClass: "title title_sup"
	  }, [_vm._v("User Portal - V2"), _c('sup', [_vm._v("New")])]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-user"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "id": "sidebar-user-portal",
	      "href": "javascript:;",
	      "title": "Team Portal"
	    }
	  }, [_c('span', {
	    staticClass: "title title_sup"
	  }, [_vm._v("Team Portal "), _c('sup', [_vm._v("New")])]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-user"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Settings")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-cog"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("IP Infomation")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-map-marker"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Active Directory")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-folder"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("Azure Active Dir")]), _vm._v(" "), _c('span', {
	    staticClass: "arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-folder"
	  })])
	}]}

/***/ }),

/***/ 1604:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "thumbnail_card"
	  }, [_c('div', {
	    staticClass: "imgbox"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.scenario.thumbnail
	    }
	  })]), _vm._v(" "), (_vm.scenario.showCheck === true) ? _c('h3', {
	    staticClass: "thumbnail_title"
	  }, [_vm._v(" " + _vm._s(_vm.scenario.name))]) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "thumbnail_desc m-0 pt-2 oneline_text"
	  }, [_vm._v(_vm._s(_vm._f("truncate")((_vm.scenario.description.length < 100) ? _vm.scenario.description : _vm.scenario.description, 100)))]), _vm._v(" "), _c('ul', {
	    staticClass: "thumbnail_card_icon"
	  }, [_c('li', [_c('span', {
	    staticClass: "card_counter"
	  }, [_vm._v(_vm._s(_vm.scenario.level))])]), _vm._v(" "), (_vm.scenario.type == 'click') ? _c('li', [_c('img', {
	    attrs: {
	      "src": "https://app.humanfirewall.io/static/img/click.svg",
	      "width": "17px"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.scenario.type == 'attachment') ? _c('li', {
	    attrs: {
	      "title": "Attachment"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-paperclip"
	  })]) : _vm._e(), _vm._v(" "), (_vm.scenario.type == 'data-entry') ? _c('li', {
	    attrs: {
	      "title": "Data Entry"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-keyboard envelope_size"
	  })]) : _vm._e(), _vm._v(" "), (_vm.scenario.type == 'announcement') ? _c('li', {
	    attrs: {
	      "title": "Announcement"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bullhorn"
	  })]) : _vm._e(), _vm._v(" "), (!_vm.scenario.channel_type || _vm.scenario.channel_type == 0) ? _c('li', {
	    attrs: {
	      "title": _vm.title
	    }
	  }, [_c('i', {
	    staticClass: "far fa-envelope envelope_size"
	  })]) : _vm._e(), _vm._v(" "), (_vm.scenario.channel_type == 1) ? _c('li', {
	    attrs: {
	      "title": "SMS Campaign"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-commenting"
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "card_footer_btn"
	  }, [_c('button', {
	    staticClass: "btn hf-btn-info card_btn_w btn_h",
	    attrs: {
	      "title": "Use this scenario"
	    },
	    on: {
	      "click": function($event) {
	        _vm.selectScenario(_vm.scenario.id)
	      }
	    }
	  }, [_vm._v("Use This")]), _vm._v(" "), _c('a', {
	    staticClass: "btn btn-default btn-sm card_btn_w btn_h ml-2",
	    attrs: {
	      "target": "_blank",
	      "href": '/previewScenario/' + _vm.scenario.id
	    }
	  }, [_vm._v("Preview")])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1618:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-view', {
	    key: _vm.$route.fullPath
	  })
	},staticRenderFns: []}

/***/ }),

/***/ 1636:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-sm-6 col-md-4 pad_c"
	  }, [_c('div', {
	    staticClass: "list_card_append"
	  }, [(_vm.scenarioId) ? _c('div', {
	    staticClass: "list_card_append_h"
	  }, [_c('h4', {
	    staticClass: "m-0 fs-12 bold"
	  }, [_vm._v(_vm._s(_vm.moment(_vm.start_date).format('DD MMM YYYY  hh:mm A')) + " - " + _vm._s(_vm.moment(_vm.start_date).add(this.days, 'days').format("DD MMM YYYY  hh:mm A")) + " "), (_vm.campaign.locked) ? _c('i', {
	    staticClass: "pull-right fs-13 fa fa-lock"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "date_show"
	  }, [(_vm.campaign.locked !== 1) ? _c('a', {
	    staticClass: "datefieldinput fs-13 p-0",
	    attrs: {
	      "data-toggle": "modal",
	      "data-target": '#update_campaign_schedule_' + _vm.campaign.id
	    }
	  }, [_vm._v(_vm._s(_vm.ActionsValue) + ", After " + _vm._s(_vm.campaign.send_after) + " " + _vm._s(_vm.campaign.send_after_type == 1 ? "Days" : "Hours"))]) : _vm._e(), _vm._v(" "), (_vm.campaign.locked == 1) ? _c('div', {
	    staticClass: "datefieldinput fs-13 p-0"
	  }, [_vm._v(_vm._s(_vm.ActionsValue) + ", After " + _vm._s(_vm.campaign.send_after) + " " + _vm._s(_vm.campaign.send_after_type == 1 ? "Days" : "Hours"))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "vapos"
	  }, [_c('span', {}, [_vm._v("Validity:")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.days),
	      expression: "days"
	    }],
	    staticClass: "form-control select_field arrow_d",
	    staticStyle: {
	      "height": "20px!important",
	      "padding": "0px!important",
	      "min-height": "1px!important",
	      "line-height": "20px!important"
	    },
	    attrs: {
	      "disabled": _vm.campaign.locked == 1
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.days = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        _vm.changeday(_vm.campaign.id)
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("1 day")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("2 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("3 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("4 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("5 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v("6 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, [_vm._v("7 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8"
	    }
	  }, [_vm._v("8 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9"
	    }
	  }, [_vm._v("9 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v("10 days")])])]), _vm._v(" "), (_vm.dateconflicterrormessage == true) ? _c('span', {
	    staticClass: "text-danger"
	  }, [_vm._v(" " + _vm._s(_vm.$t("campaign.bulk_campaign.error_in_date_conflict")) + " ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.scenarioId) ? _c('div', {
	    staticClass: "list_card_append_h"
	  }, [_c('h4', {
	    staticClass: "m-0 fs-12 bold"
	  }, [_vm._v(_vm._s(_vm.moment(_vm.start_date).format('DD MMM YYYY  hh:mm A')) + " - " + _vm._s(_vm.moment(_vm.start_date).add(this.days, 'days').format("DD MMM YYYY  hh:mm A")) + " "), (_vm.campaign.locked) ? _c('i', {
	    staticClass: "pull-right fs-13 fa fa-lock"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "date_show"
	  }, [_c('el-date-picker', {
	    staticClass: "form-control datefieldinput",
	    attrs: {
	      "format": "dd-MM-yyyy hh:mm A",
	      "type": "datetime",
	      "size": "small",
	      "placeholder": "Change date and time",
	      "picker-options": _vm.startDatePickerOptions,
	      "disabled": _vm.campaign.locked == 1
	    },
	    on: {
	      "change": function($event) {
	        _vm.changeDate(_vm.campaign.id)
	      }
	    },
	    model: {
	      value: (_vm.start_at),
	      callback: function($$v) {
	        _vm.start_at = $$v
	      },
	      expression: "start_at"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "vapos"
	  }, [_c('span', {}, [_vm._v("Validity:")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.days),
	      expression: "days"
	    }],
	    staticClass: "form-control select_field arrow_d",
	    staticStyle: {
	      "height": "20px!important",
	      "padding": "0px!important",
	      "min-height": "1px!important",
	      "line-height": "20px!important"
	    },
	    attrs: {
	      "disabled": _vm.campaign.locked == 1
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.days = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        _vm.changeday(_vm.campaign.id)
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("1 day")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("2 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("3 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("4 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("5 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v("6 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, [_vm._v("7 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8"
	    }
	  }, [_vm._v("8 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9"
	    }
	  }, [_vm._v("9 days")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v("10 days")])])]), _vm._v(" "), (_vm.dateerrorblank == true) ? _c('span', {
	    staticClass: "text-danger"
	  }, [_vm._v("Please Select Date")]) : _vm._e(), _vm._v(" "), (_vm.dateerrormessage == true) ? _c('span', {
	    staticClass: "text-danger"
	  }, [_vm._v(_vm._s(_vm.$t("campaign.bulk_campaign.error_early_schedule")))]) : _vm._e(), _vm._v(" "), (_vm.dateconflicterrormessage == true) ? _c('span', {
	    staticClass: "text-danger"
	  }, [_vm._v(" " + _vm._s(_vm.$t("campaign.bulk_campaign.error_in_date_conflict")) + " ")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "camp_details"
	  }, [_c('div', {
	    staticClass: "camp_img"
	  }, [_c('img', {
	    attrs: {
	      "alt": "Profile Image",
	      "src": _vm.campaign.thumbnail
	    }
	  })]), _vm._v(" "), (_vm.campaign.locked !== 1) ? _c('span', {
	    staticClass: "a_color change_btn pointer",
	    attrs: {
	      "data-toggle": "modal",
	      "data-target": "#campaigns_schedule"
	    },
	    on: {
	      "click": function($event) {
	        _vm.changeScenario(_vm.campaign.id, _vm.campaign.book.id)
	      }
	    }
	  }, [_vm._v("Change")]) : _vm._e(), _vm._v(" "), _c('h3', {
	    staticClass: "thumbnail_title m-0 fs-15",
	    attrs: {
	      "title": _vm.campaign.scenario.name
	    }
	  }, [_vm._v(_vm._s(_vm.campaign.scenario.name))]), _vm._v(" "), _c('p', {
	    staticClass: "thumbnail_desc m-0 oneline_text"
	  }, [(_vm.campaign.scenario.type == "click") ? _c('i', {
	    staticClass: "far fa-hand-pointer mr-1"
	  }) : _vm._e(), _vm._v(" "), (_vm.campaign.scenario.type == "attachment") ? _c('i', {
	    staticClass: "fas fa-paperclip mr-1"
	  }) : _vm._e(), _vm._v(" "), (_vm.campaign.scenario.type == "data-entry") ? _c('i', {
	    staticClass: "fas fa-keyboard mr-1"
	  }) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "mr-1"
	  }, [_vm._v(_vm._s(_vm.campaign.scenario.type))]), _vm._v(" "), _c('span', [_vm._v("Level " + _vm._s(_vm.campaign.scenario.level))])])]), _vm._v(" "), _c('div', {
	    staticClass: "lesson_box"
	  }, [_c('h6', {
	    staticClass: "m-0 bold pt-2"
	  }, [_vm._v("Lessons")]), _vm._v(" "), _vm._l((_vm.campaign.book.chapters), function(item, index) {
	    return _c('p', {
	      staticClass: "thumbnail_desc m-0 oneline_text"
	    }, [_vm._v("lesson " + _vm._s(++index) + ": " + _vm._s(item.title))])
	  }), _vm._v(" "), (_vm.campaign.locked == 1) ? _c('button', {
	    staticClass: "btn hf-btn-info btn-sm  btn_h mt10",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.campaign_preview(_vm.campaign.id)
	      }
	    }
	  }, [_vm._v("Preview")]) : _vm._e(), _vm._v(" "), (_vm.campaign.locked != 1) ? _c('button', {
	    staticClass: "btn hf-btn-info btn-sm  btn_h mt10",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        _vm.campaign_preview_edit(_vm.campaign.id)
	      }
	    }
	  }, [_vm._v("Edit & Preview")]) : _vm._e()], 2)])])
	},staticRenderFns: []}

/***/ }),

/***/ 1637:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "template_body"
	  }, [_c('nav-bar', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.shouldShowNavigation),
	      expression: "shouldShowNavigation"
	    }]
	  }), _vm._v(" "), _c('side-bar', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.shouldShowNavigation),
	      expression: "shouldShowNavigation"
	    }]
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-container"
	  }, [(_vm.alert) ? _c('div', {
	    staticClass: "notificationdiv"
	  }, [_vm._v("\n      " + _vm._s(_vm.alrtshow) + "\n      "), _c('span', {
	    staticClass: "notificationClose",
	    on: {
	      "click": _vm.campaignsEmailAlertUpdate
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-times"
	  })])]) : _vm._e(), _vm._v(" "), (_vm.showSystemAlertBanner) ? _c('div', {
	    staticClass: "system-alert-banners"
	  }, [_c('div', {
	    staticClass: "system-alert-banner"
	  }, [_c('i', {
	    staticClass: "fas fa-exclamation-triangle sa-banner-icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "sa-banner-text"
	  }, [_c('strong', [_vm._v("Needs attention")]), _vm._v(" "), _c('span', {
	    staticClass: "sa-banner-sep"
	  }, [_vm._v("—")]), _vm._v(" "), _vm._l((_vm.systemAlertTypes), function(type) {
	    return _c('a', {
	      key: type.key,
	      staticClass: "sa-banner-tag",
	      attrs: {
	        "href": "#",
	        "title": 'Open ' + type.label + ' settings'
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.goToSystemAlertType(type)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(type.label) + "\n            "), _c('span', {
	      staticClass: "sa-banner-count"
	    }, [_vm._v(_vm._s(type.count))])])
	  }), _vm._v(" "), _c('a', {
	    staticClass: "sa-banner-fix",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.goToSystemAlerts($event)
	      }
	    }
	  }, [_vm._v("View all")])], 2), _vm._v(" "), _c('span', {
	    staticClass: "sa-banner-close",
	    attrs: {
	      "title": "Hide until you sign in again"
	    },
	    on: {
	      "click": function($event) {
	        _vm.hideSystemAlertBanner()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-times"
	  })])])]) : _vm._e(), _vm._v(" "), _c('router-view', {
	    key: _vm.$route.fullPath
	  }), _vm._v(" "), _c('div', {
	    staticClass: "footer"
	  }, [_c('div', {
	    staticClass: "px-3 py-4 sm-text-center fs-13 hint-text"
	  }, [_vm._v("\n        Copyright © " + _vm._s(_vm.moment(Date.now()).format("YYYY")) + " |\n        HumanFirewall"), _c('sup', {
	    staticClass: "fs-14"
	  }, [_vm._v("®")]), _vm._v(" | All Rights Reserved.\n        "), _vm._m(0)])])], 1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "pull-right sm-pull-reset"
	  }, [_vm._v("\n          Version: "), _c('span', {
	    staticClass: "hint-text"
	  }, [_vm._v("3.05")])])
	}]}

/***/ }),

/***/ 1639:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alerts"
	  }, [_c('el-alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasSuccessMessage),
	      expression: "hasSuccessMessage"
	    }],
	    attrs: {
	      "title": _vm.messages.success,
	      "type": "success",
	      "show-icon": ""
	    },
	    on: {
	      "close": function($event) {
	        _vm.dismiss('success')
	      }
	    }
	  }), _vm._v(" "), _c('el-alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasErrorMessages),
	      expression: "hasErrorMessages"
	    }],
	    attrs: {
	      "title": _vm.formatedErrorMessage,
	      "type": "error",
	      "show-icon": ""
	    },
	    on: {
	      "close": function($event) {
	        _vm.dismiss('error')
	      }
	    }
	  }), _vm._v(" "), _c('el-alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasValidationMessages),
	      expression: "hasValidationMessages"
	    }],
	    attrs: {
	      "title": _vm.formatedValidationMessage,
	      "type": "warning",
	      "show-icon": ""
	    },
	    on: {
	      "close": function($event) {
	        _vm.dismiss('validation')
	      }
	    }
	  }), _vm._v(" "), _c('el-alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasWarningMessages),
	      expression: "hasWarningMessages"
	    }],
	    attrs: {
	      "title": _vm.messages.warning,
	      "type": "warning",
	      "show-icon": ""
	    },
	    on: {
	      "close": function($event) {
	        _vm.dismiss('warning')
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1655:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "userportalbody"
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.346f7a28d10113ae5be5.js